var _style, _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g3, _g4, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _g5, _g6, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _g7, _g8, _g9, _g10, _g11, _g12, _path58, _polygon, _path59, _path60, _path61, _path62, _g13, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _g14, _g15, _path70, _path71, _path72, _path73, _path74, _g16, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _g17, _g18, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _g19, _g20, _path105, _path106, _g21, _g22, _g23, _path107, _path108, _path109, _g24, _g25, _path110, _path111, _polygon2, _path112, _g26, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _g27, _g28, _g29, _g30, _g31;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaintainance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x31_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 310 277",
    style: {
      enableBackground: "new 0 0 310 277"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#0E61C0;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#007DDB;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#D0E2F7;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#DCCF71;}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#554D84;}\n\t.st5{fill:#FFCC00;}\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:#CC4D1C;}\n\t.st7{fill-rule:evenodd;clip-rule:evenodd;fill:#B32F2A;}\n\t.st8{fill-rule:evenodd;clip-rule:evenodd;fill:#64889B;}\n\t.st9{fill-rule:evenodd;clip-rule:evenodd;fill:#EF7D00;}\n\t.st10{fill-rule:evenodd;clip-rule:evenodd;fill:#221F1F;}\n\t.st11{fill-rule:evenodd;clip-rule:evenodd;fill:#DB9669;}\n\t.st12{fill-rule:evenodd;clip-rule:evenodd;fill:#F2B387;}\n\t.st13{fill-rule:evenodd;clip-rule:evenodd;fill:#4F2B0C;}\n\t.st14{fill-rule:evenodd;clip-rule:evenodd;fill:#DAE0E0;}\n\t.st15{fill:#EDEDED;}\n\t.st16{fill-rule:evenodd;clip-rule:evenodd;fill:#14B5C1;}\n\t.st17{fill-rule:evenodd;clip-rule:evenodd;fill:#2D939B;}\n\t.st18{fill:#3C3C3B;}\n\t.st19{fill-rule:evenodd;clip-rule:evenodd;fill:#383431;}\n\t.st20{fill-rule:evenodd;clip-rule:evenodd;fill:#40C1F8;}\n\t.st21{fill-rule:evenodd;clip-rule:evenodd;fill:#009FE3;}\n\t.st22{fill-rule:evenodd;clip-rule:evenodd;fill:#008BD2;}\n\t.st23{fill-rule:evenodd;clip-rule:evenodd;fill:#F2722A;}\n\t.st24{fill-rule:evenodd;clip-rule:evenodd;fill:#F2B211;}\n\t.st25{fill-rule:evenodd;clip-rule:evenodd;fill:#93ABBE;}\n\t.st26{fill-rule:evenodd;clip-rule:evenodd;fill:#394E7D;}\n\t.st27{fill:#D8DEE7;}\n\t.st28{fill-rule:evenodd;clip-rule:evenodd;fill:#0095FC;}\n\t.st29{fill-rule:evenodd;clip-rule:evenodd;fill:#95A6B1;}\n\t.st30{fill-rule:evenodd;clip-rule:evenodd;fill:#575756;}\n\t.st31{fill-rule:evenodd;clip-rule:evenodd;fill:#1D1D1B;}\n\t.st32{fill-rule:evenodd;clip-rule:evenodd;fill:#3C3C3B;}\n\t.st33{fill-rule:evenodd;clip-rule:evenodd;fill:#DADADA;}\n\t.st34{fill-rule:evenodd;clip-rule:evenodd;fill:#C6C6C6;}\n\t.st35{fill-rule:evenodd;clip-rule:evenodd;fill:#B2B2B2;}\n\t.st36{fill-rule:evenodd;clip-rule:evenodd;fill:#EDEDED;}\n\t.st37{fill-rule:evenodd;clip-rule:evenodd;fill:#878787;}\n\t.st38{fill-rule:evenodd;clip-rule:evenodd;fill:#93BBCE;}\n\t.st39{fill-rule:evenodd;clip-rule:evenodd;fill:#1E170E;}\n\t.st40{fill-rule:evenodd;clip-rule:evenodd;fill:#F0B186;}\n\t.st41{fill-rule:evenodd;clip-rule:evenodd;fill:#616160;}\n\t.st42{fill-rule:evenodd;clip-rule:evenodd;fill:#E9E9E9;}\n\t.st43{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st44{fill-rule:evenodd;clip-rule:evenodd;fill:#F4BA8A;}\n\t.st45{fill-rule:evenodd;clip-rule:evenodd;fill:#E30613;}\n\t.st46{fill-rule:evenodd;clip-rule:evenodd;fill:#0084C4;}\n\t.st47{fill-rule:evenodd;clip-rule:evenodd;fill:#006DA5;}\n\t.st48{fill-rule:evenodd;clip-rule:evenodd;fill:#015C42;}\n\t.st49{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_1_);}\n\t.st50{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_2_);}\n\t.st51{fill-rule:evenodd;clip-rule:evenodd;fill:#706F6F;}\n\t.st52{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_3_);}\n\t.st53{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_4_);}\n\t.st54{fill:#575756;}\n\t.st55{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_5_);}\n\t.st56{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_6_);}\n\t.st57{fill-rule:evenodd;clip-rule:evenodd;fill:#9D9D9C;}\n\t.st58{fill-rule:evenodd;clip-rule:evenodd;fill:#B6CBD8;}\n\t.st59{fill-rule:evenodd;clip-rule:evenodd;fill:#87470F;}\n\t.st60{fill:#FFFFFF;}\n\t.st61{fill-rule:evenodd;clip-rule:evenodd;fill:#EFEEED;}\n\t.st62{fill-rule:evenodd;clip-rule:evenodd;fill:#DBD8D7;}\n\t.st63{fill-rule:evenodd;clip-rule:evenodd;fill:#FBA400;}\n\t.st64{fill-rule:evenodd;clip-rule:evenodd;fill:#EA7500;}\n\t.st65{fill-rule:evenodd;clip-rule:evenodd;fill:#FED09E;}\n\t.st66{fill-rule:evenodd;clip-rule:evenodd;fill:#ECB167;}\n\t.st67{fill:#DA9549;}\n\t.st68{fill-rule:evenodd;clip-rule:evenodd;fill:#5574A0;}\n\t.st69{fill-rule:evenodd;clip-rule:evenodd;fill:#3D5175;}\n\t.st70{fill:#C6C6C6;}\n\t.st71{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_7_);}\n\t.st72{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_8_);}\n\t.st73{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_9_);}\n\t.st74{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_10_);}\n\t.st75{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_11_);}\n\t.st76{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_12_);}\n\t.st77{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_13_);}\n\t.st78{fill:#706F6F;}\n\t.st79{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_14_);}\n\t.st80{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_15_);}\n\t.st81{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_16_);}\n\t.st82{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_17_);}\n\t.st83{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_18_);}\n\t.st84{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_19_);}\n\t.st85{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_20_);}\n\t.st86{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_21_);}\n\t.st87{fill-rule:evenodd;clip-rule:evenodd;fill:#3B8700;}\n\t.st88{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_22_);}\n\t.st89{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_23_);}\n\t.st90{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_24_);}\n\t.st91{fill-rule:evenodd;clip-rule:evenodd;fill:#53668D;}\n\t.st92{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_25_);}\n\t.st93{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_26_);}\n\t.st94{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_27_);}\n\t.st95{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_28_);}\n\t.st96{fill-rule:evenodd;clip-rule:evenodd;fill:#4D4D4C;}\n\t.st97{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_29_);}\n\t.st98{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_30_);}\n\t.st99{fill-rule:evenodd;clip-rule:evenodd;fill:#54AB11;}\n\t.st100{fill-rule:evenodd;clip-rule:evenodd;fill:#90E314;}\n\t.st101{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_31_);}\n\t.st102{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_32_);}\n\t.st103{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_33_);}\n\t.st104{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_34_);}\n\t.st105{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_35_);}\n\t.st106{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_36_);}\n\t.st107{fill:#DADADA;}\n\t.st108{fill-rule:evenodd;clip-rule:evenodd;fill:#87C48E;}\n\t.st109{fill-rule:evenodd;clip-rule:evenodd;fill:#BAE5BD;}\n\t.st110{fill-rule:evenodd;clip-rule:evenodd;fill:#CD2628;}\n\t.st111{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFBDC;}\n\t.st112{fill-rule:evenodd;clip-rule:evenodd;fill:#A52323;}\n\t.st113{fill:#9D9D9C;}\n\t.st114{fill-rule:evenodd;clip-rule:evenodd;fill:#E1E3E5;}\n\t.st115{fill-rule:evenodd;clip-rule:evenodd;fill:#F0F4F7;}\n\t.st116{fill-rule:evenodd;clip-rule:evenodd;fill:#46505F;}\n\t.st117{fill-rule:evenodd;clip-rule:evenodd;fill:#D7DBDD;}\n\t.st118{fill-rule:evenodd;clip-rule:evenodd;fill:#F1B287;}\n\t.st119{fill-rule:evenodd;clip-rule:evenodd;fill:#6D85AE;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65,52.7c-3.3,0.3-3.4,3.3-1.9,5.7c0.1,0.1-0.8,6.8,3.7,11.3c1.9,2.6,3.8-0.8,3.6-2.3 c-0.1-1.1,0.5-5.7-0.5-8.9C69.7,53.8,68.8,51,65,52.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59,51.4c-0.4,0-5.2,1.1-7.5,2.4c-1.6,1.1-0.7,4.7-0.8,5.1c-0.3,1.4-1.8,10.5-2,12.5c-0.2,2-1.1,1.5,0.1,2.9 c1,6,9.5,12.7,11.7,8.5c0.1-4.1,4.7-14.3,6.6-20.9c0.4-1.6,2.9-6.8,1-9.5c-0.5-0.7-1.6-1.3-2.4-1.5C63,50.4,59.5,51.4,59,51.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M59.7,90.7c-10,0-18.1,4.3-18.1,9.6c0,5.3,8.1,9.6,18.1,9.6c10,0,18.1-4.3,18.1-9.6 C77.7,95,69.6,90.7,59.7,90.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M65.8,97.8c0,0,0.8,3.6-0.8,2.9c-0.7-0.3-0.5,1.1-0.4,1.6c0.2,0.5,2.3,1.6,2.7,1.5c0.4,0,0.6-0.2,1,0.2 c0.4,0.4,0.3,0.8,0.9,1.3c0.5,0.4,2.9,1.5,5.1,0.5c1-0.4,1.5-0.8,1.1-1.7c-0.1-0.3-2.7-1.6-3.5-2c-1.9-0.9-2.7-2.9-2.9-3.4 c-0.2-0.4-0.8-1.8-0.8-1.8S67.5,96.7,65.8,97.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M65.8,97.8c-0.5,0.8-1.2,2.1-1,3.6c0.2,0.5,2.1,1.7,2.5,1.7c1,0,1.3,0.9,2,1.5c1.1,0.9,3.6,1.8,5.8,0.2 c0.5-0.4,0.2-1.2-0.1-1.5c-0.5-0.6-2.3-0.8-3-1.2c-2.2-1-2.7-3.6-2.9-4.1c-0.2-0.4-0.7-1.1-0.7-1.1S67.5,96.7,65.8,97.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M70.9,103.2c0,0,0,0.1,0.1,0.1c0.1,0,0.1,0,0.1,0c0.2-0.4,0.4-0.7,0.6-0.8c0.2-0.2,0.5-0.2,0.8-0.2 c0.1,0,0.1,0,0.1-0.1c0-0.1-0.1-0.1-0.1-0.1c-0.3,0-0.7,0-0.9,0.2C71.3,102.5,71.1,102.8,70.9,103.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M70.4,102.8c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0c0.2-0.3,0.3-0.6,0.6-0.7c0.2-0.1,0.4-0.2,0.7-0.2 c0,0,0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1c-0.3,0-0.6,0-0.8,0.2C70.8,102.2,70.6,102.5,70.4,102.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M69.9,102.4c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0c0.2-0.3,0.3-0.6,0.6-0.7c0.2-0.1,0.4-0.2,0.7-0.2 c0,0,0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1c-0.3,0-0.6,0-0.8,0.2C70.3,101.8,70.1,102,69.9,102.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M69.5,102c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0c0.2-0.3,0.3-0.6,0.6-0.7c0.2-0.1,0.4-0.2,0.7-0.2 c0,0,0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1c-0.3,0-0.6,0-0.8,0.2C69.8,101.4,69.6,101.6,69.5,102z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M69,101.6c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0c0.2-0.3,0.3-0.6,0.6-0.7c0.2-0.1,0.4-0.2,0.7-0.2 c0,0,0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1c-0.3,0-0.6,0-0.8,0.2C69.4,101,69.2,101.2,69,101.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M68.5,101.2c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0c0.2-0.3,0.3-0.6,0.6-0.7c0.2-0.1,0.4-0.2,0.7-0.2 c0,0,0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1c-0.3,0-0.6,0-0.8,0.2C68.9,100.5,68.7,100.8,68.5,101.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M68,100.7c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0c0.2-0.3,0.3-0.6,0.6-0.7c0.2-0.1,0.4-0.2,0.7-0.2 c0,0,0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1c-0.3,0-0.6,0-0.8,0.2C68.4,100.1,68.2,100.4,68,100.7z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.1,67.2c3,2.9,5.4,7.8,5.8,8.6c0,1.3-2.5,3.2-3.8,2.2c-2-1.5-3.4-3.2-6.7-8.5C64,67.3,68.6,65.7,70.1,67.2z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M53.5,80.3c0.8,2.4,0.4,4.2,1,6.6c0.9,3,13.8-3.2,15.9-1.6c-3.7,3.6-5.3,8.6-5.4,14.3c1.7,1.3,3.5,2.8,5.8,1.4 c2-6,6.4-13.6,7.8-16.1c0.4-0.7,1.4-5.1,0-6.1c-8.9-4.1-14.1-1.3-16.1-2.5c-0.2-1.2,0-2.8-0.1-3.2c0,0-2.1,1.3-6.3,2.2 C55.9,76.1,53.4,80,53.5,80.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M76.4,76.9c0.5,0.8-1.2,2.9-2.3,2.4c-0.7-0.6-1.2-1.1-1.9-1.7c-0.3-1.2,1.7-3,2.8-2.3 C75.8,76,75.8,76.1,76.4,76.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M74.2,76.7c0.5-0.1,1.7-0.2,2.1-0.1c0.6,0,0.9,0.2,1.5,0.2c-0.1,0.5-0.4,0.8-1.5,0.6 c-1.6,0.1-2.1,1.3-3.2,0.5C72.7,77.5,72.7,77.1,74.2,76.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M73.5,77.1c0.6-0.4,0.9-0.5,1.4-0.3c0.9,0.6,2.8,0.7,3,0.8c0.3,0.2-0.6,0.8,0.3,1.2c0.3,0.2-1.5,0.2-0.3,1.2 c-1.3,0.6-1.4,0.2-0.7,1.1c-0.1,0.4-1.2,0.4-2.1,0.4c-0.3,0.3-1.9-1.4-2.2-2.3l-0.6-0.3c-0.6-0.9,0.2-1.7,0.8-1.9L73.5,77.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M25.9,104.4c7.9,0,14.3-4,14.3-8.9c0-4.9-6.4-8.9-14.3-8.9c-7.9,0-14.3,4-14.3,8.9 C11.6,100.4,18.1,104.4,25.9,104.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M50.3,85.5c0,0-3.4,1.5-3-0.2c0.1-0.7-1.2-0.3-1.6-0.1c-0.4,0.3-1.1,2.5-1,2.9c0.1,0.4,0.3,0.6,0,1 c-0.3,0.5-0.8,0.4-1.1,1.1c-0.3,0.6-0.9,3.2,0.5,5.1c0.6,0.8,1,1.3,1.9,0.7c0.3-0.2,1.1-3,1.3-3.8c0.5-2,2.3-3.2,2.7-3.5 c0.4-0.3,1.6-1.1,1.6-1.1C51.7,87.8,51.8,86.9,50.3,85.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M50.3,85.5c-0.9-0.3-2.3-0.8-3.7-0.3c-0.4,0.3-1.3,2.4-1.2,2.8c0.2,1-0.7,1.5-1.1,2.2c-0.7,1.3-1,3.8,0.9,5.7 c0.5,0.4,1.2,0,1.5-0.4c0.5-0.6,0.4-2.4,0.6-3.2c0.6-2.4,3-3.4,3.4-3.6c0.4-0.3,0.9-0.9,0.9-0.9C51.7,87.8,51.8,86.9,50.3,85.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M46.1,91.5c0,0-0.1,0-0.1,0.1c0,0.1,0,0.1,0.1,0.1c0.4,0.1,0.7,0.3,0.9,0.5c0.2,0.2,0.3,0.5,0.3,0.8 c0,0.1,0.1,0.1,0.1,0.1c0.1,0,0.1-0.1,0.1-0.1c0-0.3-0.2-0.6-0.4-0.9C46.9,91.8,46.5,91.6,46.1,91.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M46.4,91c0,0-0.1,0-0.1,0.1c0,0,0,0.1,0,0.1c0.4,0.1,0.6,0.2,0.8,0.4c0.2,0.2,0.3,0.4,0.3,0.7 c0,0,0,0.1,0.1,0.1c0,0,0.1-0.1,0.1-0.1c0-0.3-0.1-0.6-0.3-0.8C47.1,91.2,46.8,91.1,46.4,91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M46.7,90.4c0,0-0.1,0-0.1,0.1c0,0,0,0.1,0,0.1c0.4,0.1,0.6,0.2,0.8,0.4c0.2,0.2,0.3,0.4,0.3,0.7 c0,0,0,0.1,0.1,0.1c0,0,0.1-0.1,0.1-0.1c0-0.3-0.1-0.6-0.3-0.8C47.4,90.7,47.1,90.5,46.7,90.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M47,89.9c0,0-0.1,0-0.1,0.1c0,0,0,0.1,0,0.1c0.4,0.1,0.6,0.2,0.8,0.4c0.2,0.2,0.3,0.4,0.3,0.7 c0,0,0,0.1,0.1,0.1c0,0,0.1-0.1,0.1-0.1c0-0.3-0.1-0.6-0.3-0.8C47.7,90.1,47.4,90,47,89.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M47.3,89.3c0,0-0.1,0-0.1,0.1c0,0,0,0.1,0,0.1c0.4,0.1,0.6,0.2,0.8,0.4c0.2,0.2,0.3,0.4,0.3,0.7 c0,0,0,0.1,0.1,0.1c0,0,0.1-0.1,0.1-0.1c0-0.3-0.1-0.6-0.3-0.8C48,89.6,47.7,89.4,47.3,89.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M47.6,88.8c0,0-0.1,0-0.1,0.1c0,0,0,0.1,0,0.1c0.4,0.1,0.6,0.2,0.8,0.4c0.2,0.2,0.3,0.4,0.3,0.7 c0,0,0,0.1,0.1,0.1c0,0,0.1-0.1,0.1-0.1c0-0.3-0.1-0.6-0.3-0.8C48.3,89,48,88.9,47.6,88.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M47.9,88.2c0,0-0.1,0-0.1,0.1c0,0,0,0.1,0,0.1c0.4,0.1,0.6,0.2,0.8,0.4c0.2,0.2,0.3,0.4,0.3,0.7 c0,0,0,0.1,0.1,0.1c0,0,0.1-0.1,0.1-0.1c0-0.3-0.1-0.6-0.3-0.8C48.6,88.5,48.3,88.3,47.9,88.2z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M48,84.8c-1.4,1-2.5,2.7-0.7,6.3c4.7,2.8,7.9,10.1,12.4,13.4c-2.3-4.7-1.7-6.9-4-11.5 C52.6,87.6,49.8,85,48,84.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M62.5,52.1c2.8-0.2,4,4.4,1.6,12.3c0.8,0.5,1.3,0.1,2.4,0c2-6.6,2.9-11.1-0.6-13C64.3,51.7,64,51.5,62.5,52.1z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M59.7,104.5c0.9,0.6,1.7,0.9,2.6,0.9c0.9,0,2.8-0.8,2.8-1.6c0.2-7.3-2-11.3-5.5-19.9c2.7-0.7,0.8-5.4,1-10 c-5.9,4-10.4,2.4-11.8,1.3c-2,3.1-0.9,8.7-0.2,9.9c1.3,1.9,1.6,1.4,4.1,5.6C55.5,95.4,57,101,59.7,104.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M48.6,75.6c2.1,1.9,11.1,2.5,13.9-1.5c0-0.5,0.1-1.3,0.1-1.8c-3.2,2.4-10.1,4.1-13.8,2 C48.8,74.7,48.7,75.1,48.6,75.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M50.9,75.8c3.3-2.7,5-7.4,5.4-14.1c4.3,0.7,8.4-0.5,11.4-2.4c-1.4,4.9-3.1,13.8-5.5,16.5 C60.6,76.9,57.5,77.8,50.9,75.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M51.8,53.7c2.2-0.2,4.1,2.1,4.6,8.1l0,0c1.1,0.2,2.1,0.2,3.1,0.2c-0.2-5.3-1.2-9.4-3.9-9.6 C54.1,52.5,53,53,51.8,53.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M56.3,73.4c1.2-3.1,2-6.2,2-9.6c2.7,0.1,5.2-0.4,7.3-1.7c-1,3.5-1,8.4-2.7,10.3C60.6,73.3,58.3,73.6,56.3,73.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M60.6,96.4c-1.5-2.4-2.6-5-3.2-8c-2.2,0.7-4.1,0.9-6.1,0.3c1.2,3.4,2.7,8.1,4.3,8.2 C57.7,97.1,59,97.1,60.6,96.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M57,88.9c-2.5,0.5-4,0.5-5.6,0.2c0.1,0.8,0.2,1.6,0.3,2.3c1.8,0.4,3.7,0.6,5.7-0.1 C57.4,90.5,57.3,89.7,57,88.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M57.4,77.8c0.2,4.4,1.5,5.3,2.7,9.1c-2.4-0.6-4.3,0.1-6.3,1.6c-1.2-1.7-3-2.9-3-5.7c3.2-0.6,4.6-1.1,3.9-4.7 C55.4,78.4,56.5,77.9,57.4,77.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M58.7,64.3c3.1-0.3,4.9-0.8,6.7-1.8c0.2,1,0.3,1.9,0.5,2.9c-2,1.2-4.1,2-6.7,2C58.8,66.4,58.6,65.4,58.7,64.3z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M53.1,91.2c0-0.2-0.2-0.4-0.4-0.5c-0.3-0.1-0.5,0-0.6,0.2c0,0.2,0.2,0.4,0.4,0.5 C52.8,91.5,53.1,91.4,53.1,91.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M57,91c0-0.2-0.2-0.4-0.4-0.5c-0.3-0.1-0.5,0-0.6,0.2c0,0.2,0.2,0.4,0.4,0.5C56.7,91.3,57,91.2,57,91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M59.7,66.7c-0.1-0.2,0-0.4,0.3-0.6c0.2-0.2,0.5-0.2,0.6,0c0.1,0.2,0,0.4-0.3,0.6 C60.1,66.8,59.8,66.8,59.7,66.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M64,65.4c-0.1-0.2,0-0.4,0.3-0.6c0.2-0.2,0.5-0.2,0.6,0c0.1,0.2,0,0.4-0.3,0.6C64.4,65.6,64.1,65.6,64,65.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M57.9,46.2l0,0.1C57.9,46.3,57.9,46.3,57.9,46.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M64.8,50.8l0,0.1C64.8,50.8,64.8,50.8,64.8,50.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M60.1,47.6c-0.4,1.4-1.4,2.9-1.9,4.3c-0.3,1.1,1.3,2.7,1.8,3.2c2.2,2.5,3.7,0.9,3.9-0.5 c0.1-0.7,0.1-1.5,0.1-2.2c0-0.8-1.4-1.1-1.2-1.8L60.1,47.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M70.3,44.2c-0.2,0.8-0.2,1.7-0.2,2.6c0.1,1-1.1,1-0.6,2.6c-0.1,1-0.8,2.5-1.3,3.3c-0.3,0.7-0.7,1.6-2,2.1 c-1.9,0.7-3.3-1.4-4.8-2.4c-1.5-1-0.2-2.9-0.4-4.4c-0.3-2.7,0.7-6,3.7-6.4c1.3-0.2,3.4,0.1,4.5,0.9C69.7,42.7,70.6,43.3,70.3,44.2z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M58.9,46l0,0.1C58.9,46.1,58.9,46,58.9,46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M63.8,46.4c-0.5,0.1-0.6,0.1-0.9,0.7c-0.3,0.5-0.6,0.4-0.8,1.5c-0.1,0.2-1.6-1-2.6,0.7 c-1.6-2.4-0.6-7.8,1.3-8.8c3,1,4,1.3,4.8,3.3C65.5,44.8,64.5,46.3,63.8,46.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M66.6,39.8c4.2,1.9,6,4.2,3.8,5.3c-0.7,0.4-2.3,0.3-4.9-0.9c-0.6-1.6-1.4-2.5-4.7-3.7 C62.2,38.3,65.5,39.3,66.6,39.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M65.3,51.1l0,0.1C65.3,51.2,65.3,51.2,65.3,51.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M69.2,51.6c-0.1-0.3-0.3-2.3-1.2-2c-1.1,0.3-1,1.2-4.1,1.5c-0.3,0.6-0.9,1.7-0.7,2.9c0.7,1.2,3.1,2.3,4.2,1.9 C69.6,55.1,69.5,52.6,69.2,51.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M64.3,51.2C64.3,51.2,64.2,51.2,64.3,51.2c-1.9-2.3-4.2-6.1-5-8.9c0,0,0-0.1,0.1-0.1c0,0,0.1,0,0.1,0.1 c0.8,2.8,3.1,6.5,4.9,8.8C64.4,51.1,64.4,51.2,64.3,51.2C64.3,51.2,64.3,51.2,64.3,51.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M65.1,47.8c2.1,0,3.9-0.2,5-0.9c0.1,0,0.2,0,0.3,0c0.1,0.1,0.1,0.2,0.1,0.2c-0.2,0.6-0.3,1.2-0.5,1.8 c-0.1,0.5-0.5,0.9-1,1.1c-0.1,0-0.2,0.1-0.3,0.1c-0.1-1.7-0.7-1.7-1.9,0.4c-0.5,0.1-1.1,0.1-1.7,0.1c-0.3,0-0.7-0.1-0.9-0.4 c-0.2-0.3-0.3-0.6-0.3-0.9c0-0.3,0.1-0.5,0.1-0.8C64.1,48.1,64.6,47.8,65.1,47.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "60.7,45.8 64.5,47.9 64,49.9 61,46.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M60,47.6c0.1,1,0.6,1.7,1,1.7c0.4-0.1,0.8-0.9,0.7-1.9c-0.1-1-0.7-1.7-1.1-1.6C60.1,45.8,59.9,46.6,60,47.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M26.1,105c-2.5,0-4.7-0.5-6.6-1.3c-3.6-1.5-6-4.2-6.2-7c-0.2-2.5,1.3-4.8,4.2-6.5c0.5-0.3,1.2-0.2,1.5,0.4 c0.3,0.5,0.2,1.2-0.4,1.5c-1.5,0.9-3.2,2.4-3.1,4.4c0.1,1.9,2,3.9,4.8,5.1c4,1.7,10.2,1.9,15.6-2.5c3.7-3.1,3.6-7.5,3.4-12.6 c-0.1-3.4-0.2-7,0.8-10.6c2.5-9.1,10.3-12.4,23.2-9.8c0.6,0.1,1,0.7,0.9,1.3c-0.1,0.6-0.7,1-1.3,0.9c-11.7-2.3-18.5,0.3-20.6,8.2 c-0.9,3.3-0.8,6.6-0.7,9.9c0.2,5.5,0.3,10.6-4.2,14.4C33.7,103.9,29.7,105,26.1,105z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M26.1,100.7c4.9,0,8.9-2.5,8.9-5.5c0-3-4-5.5-8.9-5.5c-4.9,0-8.9,2.5-8.9,5.5 C17.2,98.2,21.2,100.7,26.1,100.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M18.8,81.2c4,0,11.3,0,14.5,0l2.2,12.7c0.6,3.2-4.2,5.9-9.5,5.9c-5.2,0-10.1-2.7-9.5-5.9L18.8,81.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M18.8,81.2h11.6l1.8,17.2c-1.7,0.8-3.9,1.3-6.1,1.3c-5.2,0-10.1-2.7-9.5-5.9L18.8,81.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M19.5,82.7l-2.2,13.7c1.1,1.5,3.4,2.6,6.1,3.1l0.3-14.7L19.5,82.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M26.1,85.8c4,0,7.3-2,7.3-4.5c0-2.5-3.3-4.5-7.3-4.5c-4,0-7.3,2-7.3,4.5C18.8,83.8,22.1,85.8,26.1,85.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M32,78.7c0.4,0.5,0.6,1.1,0.6,1.7c0,2.2-2.9,4.1-6.6,4.1c-3.6,0-6.6-1.8-6.6-4.1c0-0.6,0.2-1.2,0.6-1.7 c1.3-1.2,3.5-1.9,5.9-1.9S30.7,77.6,32,78.7z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st25",
    cx: 26.1,
    cy: 80.5,
    rx: 6,
    ry: 3.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M26.1,84c3.3,0,6-1.7,6-3.7c0-2.1-2.7-3.7-6-3.7s-6,1.7-6,3.7C20.1,82.3,22.8,84,26.1,84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M26.1,84c-3.3,0-6.1-1.7-6.1-3.8c0-2.1,2.7-3.8,6.1-3.8s6.1,1.7,6.1,3.8C32.1,82.3,29.4,84,26.1,84z  M26.1,76.5c-3.3,0-6,1.6-6,3.7c0,2,2.7,3.7,6,3.7c3.3,0,6-1.6,6-3.7C32,78.2,29.3,76.5,26.1,76.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M26.1,76.9c3,0,5.4,1.5,5.4,3.4c0,1.9-2.4,3.4-5.4,3.4c-3,0-5.4-1.5-5.4-3.4 C20.7,78.4,23.1,76.9,26.1,76.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M26.1,83.6c-3,0-5.5-1.5-5.5-3.4c0-1.9,2.4-3.4,5.5-3.4c3,0,5.5,1.5,5.5,3.4 C31.5,82.1,29.1,83.6,26.1,83.6z M26.1,76.9c-2.9,0-5.3,1.5-5.3,3.3c0,1.8,2.4,3.3,5.3,3.3c2.9,0,5.3-1.5,5.3-3.3 C31.4,78.4,29,76.9,26.1,76.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M26.1,77.2c2.6,0,4.8,1.3,4.8,3c0,1.6-2.1,3-4.8,3c-2.6,0-4.8-1.3-4.8-3C21.3,78.6,23.4,77.2,26.1,77.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M26.1,83.3c-2.7,0-4.8-1.4-4.8-3c0-1.7,2.2-3,4.8-3c2.7,0,4.8,1.4,4.8,3C30.9,81.9,28.7,83.3,26.1,83.3z  M26.1,77.3c-2.6,0-4.7,1.3-4.7,2.9c0,1.6,2.1,2.9,4.7,2.9s4.7-1.3,4.7-2.9C30.8,78.6,28.7,77.3,26.1,77.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M26.1,77.6c2.3,0,4.2,1.2,4.2,2.6c0,1.4-1.9,2.6-4.2,2.6c-2.3,0-4.2-1.2-4.2-2.6 C21.9,78.8,23.7,77.6,26.1,77.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M26.1,82.9c-2.3,0-4.2-1.2-4.2-2.7c0-1.5,1.9-2.7,4.2-2.7c2.3,0,4.2,1.2,4.2,2.7 C30.3,81.7,28.4,82.9,26.1,82.9z M26.1,77.7c-2.3,0-4.1,1.1-4.1,2.5c0,1.4,1.9,2.5,4.1,2.5c2.3,0,4.1-1.1,4.1-2.5 C30.2,78.8,28.3,77.7,26.1,77.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M26.1,78c2,0,3.6,1,3.6,2.2c0,1.2-1.6,2.2-3.6,2.2c-2,0-3.6-1-3.6-2.2C22.5,79,24.1,78,26.1,78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M26.1,82.5c-2,0-3.6-1-3.6-2.3c0-1.3,1.6-2.3,3.6-2.3c2,0,3.6,1,3.6,2.3C29.7,81.5,28.1,82.5,26.1,82.5z  M26.1,78.1c-1.9,0-3.5,1-3.5,2.2c0,1.2,1.6,2.2,3.5,2.2c1.9,0,3.5-1,3.5-2.2C29.6,79,28,78.1,26.1,78.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M26.1,78.4c1.6,0,3,0.8,3,1.8c0,1-1.3,1.8-3,1.8c-1.6,0-3-0.8-3-1.8C23.1,79.2,24.4,78.4,26.1,78.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M26.1,82.1c-1.7,0-3-0.9-3-1.9c0-1,1.4-1.9,3-1.9c1.7,0,3,0.9,3,1.9C29.1,81.3,27.7,82.1,26.1,82.1z  M26.1,78.4c-1.6,0-2.9,0.8-2.9,1.8c0,1,1.3,1.8,2.9,1.8c1.6,0,2.9-0.8,2.9-1.8C29,79.2,27.7,78.4,26.1,78.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M26.1,78.8c1.3,0,2.4,0.7,2.4,1.5s-1.1,1.5-2.4,1.5c-1.3,0-2.4-0.7-2.4-1.5S24.8,78.8,26.1,78.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M26.1,81.7c-1.3,0-2.4-0.7-2.4-1.5s1.1-1.5,2.4-1.5c1.3,0,2.4,0.7,2.4,1.5S27.4,81.7,26.1,81.7z  M26.1,78.8c-1.3,0-2.3,0.6-2.3,1.4c0,0.8,1,1.4,2.3,1.4c1.3,0,2.3-0.6,2.3-1.4C28.4,79.4,27.3,78.8,26.1,78.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M26.1,79.1c1,0,1.8,0.5,1.8,1.1c0,0.6-0.8,1.1-1.8,1.1c-1,0-1.8-0.5-1.8-1.1 C24.3,79.6,25.1,79.1,26.1,79.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M26.1,81.4c-1,0-1.8-0.5-1.8-1.1s0.8-1.1,1.8-1.1s1.8,0.5,1.8,1.1S27.1,81.4,26.1,81.4z M26.1,79.2 c-0.9,0-1.7,0.5-1.7,1c0,0.6,0.8,1,1.7,1c0.9,0,1.7-0.5,1.7-1C27.8,79.7,27,79.2,26.1,79.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M26.1,79.5c0.6,0,1.2,0.3,1.2,0.7c0,0.4-0.5,0.7-1.2,0.7c-0.6,0-1.2-0.3-1.2-0.7 C24.9,79.8,25.4,79.5,26.1,79.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M26.1,81c-0.7,0-1.2-0.3-1.2-0.8c0-0.4,0.5-0.8,1.2-0.8c0.7,0,1.2,0.3,1.2,0.8C27.3,80.6,26.7,81,26.1,81z  M26.1,79.6c-0.6,0-1.1,0.3-1.1,0.7c0,0.4,0.5,0.7,1.1,0.7c0.6,0,1.1-0.3,1.1-0.7C27.2,79.9,26.7,79.6,26.1,79.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M26.1,80.6c0.3,0,0.5-0.2,0.5-0.3c0-0.2-0.2-0.3-0.5-0.3s-0.5,0.2-0.5,0.3C25.5,80.4,25.8,80.6,26.1,80.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M26.1,80.6c-0.3,0-0.6-0.2-0.6-0.4c0-0.2,0.3-0.4,0.6-0.4c0.3,0,0.6,0.2,0.6,0.4 C26.7,80.4,26.4,80.6,26.1,80.6z M26.1,79.9c-0.3,0-0.5,0.1-0.5,0.3c0,0.2,0.2,0.3,0.5,0.3c0.3,0,0.5-0.1,0.5-0.3 C26.5,80.1,26.3,79.9,26.1,79.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M30.5,82.8C30.5,82.8,30.5,82.8,30.5,82.8l-3.6-2.1c0,0,0,0,0-0.1c0,0,0,0,0.1,0l3.6,2.1 C30.6,82.7,30.6,82.7,30.5,82.8C30.6,82.8,30.6,82.8,30.5,82.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M31.8,81.4C31.8,81.4,31.8,81.4,31.8,81.4l-4.6-0.9c0,0,0,0,0-0.1c0,0,0-0.1,0.1,0l4.6,0.9 C31.8,81.3,31.9,81.4,31.8,81.4C31.8,81.4,31.8,81.4,31.8,81.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M20.2,80.9C20.1,80.9,20.1,80.9,20.2,80.9c-0.1-0.1,0-0.1,0-0.1l4.8-0.5c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1 L20.2,80.9C20.2,80.9,20.2,80.9,20.2,80.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M21.2,82.5C21.1,82.5,21.1,82.5,21.2,82.5c-0.1-0.1,0-0.1,0-0.1l4-1.8c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1 L21.2,82.5C21.2,82.5,21.2,82.5,21.2,82.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M22.7,83.4C22.7,83.4,22.7,83.4,22.7,83.4C22.6,83.3,22.6,83.3,22.7,83.4l2.7-2.6c0,0,0.1,0,0.1,0 c0,0,0,0.1,0,0.1L22.7,83.4C22.7,83.4,22.7,83.4,22.7,83.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M24.1,83.8C24.1,83.8,24.1,83.8,24.1,83.8C24,83.7,24,83.7,24.1,83.8l1.5-2.9c0,0,0,0,0.1,0c0,0,0,0,0,0.1 L24.1,83.8C24.1,83.8,24.1,83.8,24.1,83.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M25.3,84C25.3,84,25.3,84,25.3,84C25.3,84,25.3,84,25.3,84l0.6-3.1c0,0,0-0.1,0.1,0c0,0,0,0,0,0.1L25.3,84 C25.4,84,25.4,84,25.3,84z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M26,79.6C26,79.6,26,79.6,26,79.6l-0.4-3.1c0,0,0-0.1,0-0.1c0,0,0.1,0,0.1,0L26,79.6 C26.1,79.5,26.1,79.6,26,79.6C26,79.6,26,79.6,26,79.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M27.7,83.8C27.7,83.8,27.7,83.8,27.7,83.8l-1.3-2.9c0,0,0-0.1,0-0.1c0,0,0.1,0,0.1,0L27.7,83.8 C27.8,83.8,27.8,83.8,27.7,83.8C27.7,83.8,27.7,83.8,27.7,83.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M29.1,83.5C29,83.5,29,83.5,29.1,83.5l-2.4-2.6c0,0,0-0.1,0-0.1c0,0,0.1,0,0.1,0L29.1,83.5 C29.1,83.4,29.1,83.5,29.1,83.5C29.1,83.5,29.1,83.5,29.1,83.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M27.2,80.1C27.2,80.1,27.1,80.1,27.2,80.1c-0.1-0.1,0-0.1,0-0.1l4.8-0.5c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1 L27.2,80.1C27.2,80.1,27.2,80.1,27.2,80.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M25,80C25,80,25,80,25,80l-4.7-1c0,0,0,0,0-0.1c0,0,0-0.1,0.1,0l4.7,1C25,79.9,25.1,80,25,80 C25.1,80,25,80,25,80z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M25.2,79.8C25.2,79.8,25.2,79.8,25.2,79.8l-3.6-2c0,0,0,0,0-0.1c0,0,0,0,0.1,0l3.6,2 C25.3,79.7,25.3,79.7,25.2,79.8C25.3,79.8,25.3,79.8,25.2,79.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M27,79.9C27,79.9,27,79.8,27,79.9c-0.1-0.1,0-0.1,0-0.1l3.9-1.8c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1L27,79.9 C27,79.8,27,79.9,27,79.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M25.5,79.6C25.5,79.6,25.5,79.6,25.5,79.6L23.1,77c0,0,0-0.1,0-0.1c0,0,0.1,0,0.1,0L25.5,79.6 C25.6,79.6,25.6,79.6,25.5,79.6C25.5,79.6,25.5,79.6,25.5,79.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M26.8,79.6C26.8,79.6,26.7,79.6,26.8,79.6C26.7,79.6,26.7,79.6,26.8,79.6l2.6-2.5c0,0,0.1,0,0.1,0 c0,0,0,0.1,0,0.1L26.8,79.6C26.8,79.6,26.8,79.6,26.8,79.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M26.5,79.6C26.5,79.6,26.5,79.6,26.5,79.6C26.4,79.6,26.4,79.5,26.5,79.6l1.5-2.9c0,0,0,0,0.1,0 c0,0,0,0,0,0.1L26.5,79.6C26.5,79.6,26.5,79.6,26.5,79.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M25.8,79.6C25.8,79.6,25.7,79.6,25.8,79.6l-1.3-2.9c0,0,0-0.1,0-0.1c0,0,0.1,0,0.1,0L25.8,79.6 C25.8,79.5,25.8,79.5,25.8,79.6C25.8,79.6,25.8,79.6,25.8,79.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M26.5,84C26.5,84,26.5,83.9,26.5,84l-0.4-3c0,0,0-0.1,0-0.1c0,0,0.1,0,0.1,0L26.5,84 C26.6,83.9,26.5,84,26.5,84C26.5,84,26.5,84,26.5,84z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M26.2,79.6C26.2,79.6,26.2,79.6,26.2,79.6C26.2,79.6,26.2,79.5,26.2,79.6l0.6-3.1c0,0,0-0.1,0.1,0 c0,0,0,0,0,0.1L26.2,79.6C26.3,79.6,26.3,79.6,26.2,79.6z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M53,54c-2.8-1.7-4.9,3.4-5.2,6.2c0,0.2-2.9,6.2-2.4,11.5c0.6,2.8,4.6,2.2,5.4-0.5c2.2-3.2,3-7.3,3.6-8.3 C55.4,61.1,56.3,55.3,53,54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M46.3,72.9c1.6,1.7,11,1.8,14,1.1c1-0.9,1.2-4.3,0-4.4c-1.2-0.3-8.4-0.9-11.8-1.3 C46.1,68.4,45.7,70.9,46.3,72.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M64.5,70.3c0.8-0.2,2.2-0.2,2.7-0.1c0.7,0.1,1,0.2,1.6,0.3c-0.3,0.4-0.2,0.7-1.3,0.5c-0.8,0.1-3.7,1.7-4,0.6 C63.5,70.9,63.5,70.5,64.5,70.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M68.3,70.6c0.5,0.3,0.7,0.8,0.6,1.4c-0.1,0.8,0,3.2,0.2,3.3c0.6,0.4,0.2,0.4,0.6,0.5 c0.2-0.1,0.4-0.4,0.3-0.5c-0.4-0.5-0.5-2.6-0.6-3.1c-0.1-0.5-0.1-0.9-0.3-1.4C69,70.5,67.8,70.3,68.3,70.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M68.1,70.8c1.5,1-0.3,4,0.8,4.7c0.9,0.6,1,0.3,0.7,0c-0.4-0.5-0.3-2.5-0.4-3c-0.1-0.5-0.1-0.9-0.3-1.4 C68.8,70.7,67.6,70.5,68.1,70.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M64.8,69.6c0.6,0.6,0.8,1.4,0.4,2.3c-0.5,1.1-1,4.8-0.8,5.1c0.8,0.8,1.6,1.2,2.2,1.1 c0.3-0.1,0.8-0.4,0.7-0.6c-0.5-0.9,0.1-3.9,0.2-4.7c0.1-0.8,0.1-1.4,0-2.2C67.6,70,64.2,69,64.8,69.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M64.4,69.8c0.6,0.6,0.8,1.4,0.4,2.3c-0.5,1.1-1,4.8-0.8,5c1.1,1.1,3,1.1,2.8,0.6c-0.5-0.9,0.3-3.9,0.4-4.7 c0.1-0.8,0.1-1.4,0-2.2C67.2,70.2,63.8,69.2,64.4,69.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M73.3,71.3c-0.3,0.7-0.6,2.1-1.1,2.2c0-0.4,0.1-0.8-0.8-1.2l-7.9-3c-0.6-0.2-0.8-1.2-0.4-2.2 c0.4-1,1.2-1.5,1.8-1.3l5.7,2.1C72.6,68.8,73.6,70.6,73.3,71.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M73,75.6c1.6,0,2.9,0.6,3.4,1.4h0.3V83c0,1.3-1.7,2.3-3.7,2.3c-2,0-3.7-1-3.7-2.3V77h0.3 C70.1,76.2,71.5,75.6,73,75.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M73.9,75.6v9.5c-0.3,0-0.5,0.1-0.8,0.1c-1.5,0-2.9-0.6-3.4-1.4V77c0.6-0.8,2.5-1.4,3.4-1.4 C73.9,75.6,73.6,75.6,73.9,75.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M72.7,85.2c-1-0.1-2-0.4-2.6-0.9v-7.9c0.6-0.5,1.5-0.8,2.6-0.9V85.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M73,79.4c2,0,3.7-1,3.7-2.3c0-1.3-1.7-2.3-3.7-2.3c-2,0-3.7,1-3.7,2.3C69.3,78.3,71,79.4,73,79.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M73,74.3c1,0,1.8,0.3,2.3,0.8h0.4v1.2c0,0.9-1.2,1.6-2.6,1.6c-1.5,0-2.6-0.7-2.6-1.6v-1.2h0.4 C71.2,74.7,72,74.3,73,74.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M73,76.7c1.5,0,2.6-0.7,2.6-1.6s-1.2-1.6-2.6-1.6c-1.5,0-2.6,0.7-2.6,1.6S71.6,76.7,73,76.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M73,71.5c0.3,0,0.5,0.1,0.7,0.2h0.1v3.4c0,0.3-0.3,0.5-0.8,0.5c-0.4,0-0.8-0.2-0.8-0.5v-3.4h0.1 C72.5,71.6,72.7,71.5,73,71.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M73.7,71.6c-0.2,0.4-0.5,0.8-0.8,0.9l-0.1,0.2l-0.5-0.2c-0.4-0.2-0.5-0.8-0.3-1.5c0.3-0.7,0.8-1.1,1.2-0.9 l0.5,0.2l-0.1,0.2C73.9,70.7,73.9,71.2,73.7,71.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M75.1,72.1c-0.3,0.6-0.7,1.1-1.1,1.3l-0.1,0.2l-0.8-0.3c-0.6-0.2-0.8-1.2-0.4-2.2c0.4-1,1.2-1.5,1.8-1.3 l0.8,0.3l-0.1,0.2C75.4,70.8,75.4,71.4,75.1,72.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M75.7,72.3c-0.4,1-1.2,1.5-1.8,1.3c-0.6-0.2-0.8-1.2-0.4-2.2c0.4-1,1.2-1.5,1.8-1.3S76.1,71.4,75.7,72.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M75.3,72.1c-0.1,0.2-0.2,0.3-0.3,0.4l0,0.1l-0.2-0.1c-0.2-0.1-0.2-0.3-0.1-0.6c0.1-0.3,0.3-0.4,0.5-0.4 l0.2,0.1l0,0.1C75.4,71.7,75.3,71.9,75.3,72.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M75.4,72.1c-0.1,0.3-0.3,0.4-0.5,0.4c-0.2-0.1-0.2-0.3-0.1-0.6c0.1-0.3,0.3-0.4,0.5-0.4 C75.5,71.6,75.5,71.9,75.4,72.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M64.5,66.1l6.6,2.5c0.6,0.2,1.4,1.1,1.5,1.4c-0.6-0.3-1.1-0.6-1.8-0.9l-6.8-2.6 C64.1,66.3,64.3,66.2,64.5,66.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M63.3,69l9,3.3c-0.3-0.6-1.5-1.1-2.1-1.3l-7-2.7C63.2,68.6,63.2,68.8,63.3,69z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M62.3,70.1c0.9,0.2,1.1,2.9,0,3.3c-1,0.1-1.6,0-2.5,0.1c-1-0.7-0.8-3.3,0.5-3.6C61.2,69.9,61.3,69.9,62.3,70.1 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M61.9,72.4c-0.1-0.4-0.1-2.1,0.7-2c1.1,0.3,2.5,0.2,2.7,0.2c1,0,2.2,0.7,2.5,0.8c3.1,1.1,2.7,1.9,0,1.1 c0.2,0.1,0.1,0.6-0.1,0.8c-0.1,0.3,0.1,0.5-0.2,0.7c-0.1,0.2,0.1,0.5-0.4,0.6c-0.7,0.3-3-0.5-4-0.9C62.2,73.3,62.2,73.3,61.9,72.4z "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M77.6,77.6L76,78.4c-0.5,0.2-0.2,0.8,0.3,0.6l1.7-0.7C78.5,78.2,78.1,77.4,77.6,77.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M77.5,78.5l-1.8,0.9c-0.6,0.3-0.2,0.9,0.4,0.7l1.9-0.7C78.5,79.1,78,78.3,77.5,78.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M77.2,79.7l-1.5,0.7c-0.5,0.2-0.2,0.8,0.3,0.6l1.6-0.6C78,80.2,77.7,79.5,77.2,79.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M76.8,81l-1.4,0.2c-0.4,0.1-0.3,0.6,0.1,0.5l1.4-0.1C77.3,81.6,77.2,80.9,76.8,81z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M290.3,146.7c-0.5,0.3-0.9,0.8-0.8,1.3c0.3,1.4-0.8,1.5-1,2.4c0.1,0.4,2.8,1.8,3.2,1.2 c0.8-0.2,1.3-1.9,1.4-2.8c0-0.8-0.1-0.8-0.4-1.6l0.3-1.9c-0.3-0.7-1.2-0.6-2.2-0.7L290.3,146.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M289.8,146.9c-0.3,0.3-0.9,0.9-1.2,1.2c-0.5,0.4-0.6,0.7-1.1,1.1c0.4,0.3,0.8,0.3,1.6-0.5 c1.3-1,1.7-0.1,2-1.4C291.3,146.7,290.4,146.5,289.8,146.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M288.2,150.6l0.2-1.7c0.1-0.5,0.8-0.4,0.8,0.1l0,1.7C289.1,151.2,288.2,151.1,288.2,150.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M289.1,151.1l0.2-1.9c0.1-0.6,0.9-0.5,0.8,0.1l0,1.8C290.1,151.7,289,151.6,289.1,151.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M290.1,151.2l0.2-1.6c0.1-0.5,0.7-0.4,0.7,0.1l0,1.6C290.9,151.8,290,151.7,290.1,151.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M291,151.5l0.1-1.3c0-0.4,0.6-0.3,0.6,0.1l0,1.3C291.7,152,290.9,151.9,291,151.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M290,146.4c0.1,0.9,2.7,1.7,3.2,0.6c0.3-0.9,0.3-1.5,0.6-2.5c-0.5-1.1-3.1-1.5-3.7-0.2 C290.1,145.3,290.1,145.4,290,146.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M296.3,131.8c1.2,2-1,10.9-2.6,13.6c-1.1,0.7-4.5-0.1-4.3-1.3c0-1.2,1.1-8.2,1.7-11.6 C292.1,130.3,294.7,130.7,296.3,131.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M281.3,180.8c10,0,18.1,4.3,18.1,9.6c0,5.3-8.1,9.6-18.1,9.6c-10,0-18.1-4.3-18.1-9.6 C263.2,185,271.3,180.8,281.3,180.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M286.6,116.4c2.6-2.1,5.4,2.7,6.1,5.4c0,0.2,3.6,5.8,3.8,11.1c-0.2,2.8-4.1,1.9-5.2-0.6 c-2.6-2.9-4.1-6.1-4.8-7C285.3,123.7,283.5,118.1,286.6,116.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M283.6,184.1c-0.2,0-0.8,1.4-0.3,2.4c0.1,0.3,0,1.3,2.8,2.3c0.8,0.3,1.5,0.2,3.1,0.9c0.4,0.2,0,0.7,0.3,0.9 c0.8,0.5,1.4,0.8,1.8,1.1c0.6,0.4,2.7,0.4,3.2-0.5c0.3-0.5-0.1-2.7-0.1-2.7L283.6,184.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M294.6,184.2c0.2-0.4-0.6-1.2-0.6-1.2s-0.1,0.7-0.2,1.1c-0.1,0.4-1.3,1.2-3.3,0.2c-1.4-0.7-1.1-2.2-1.1-2.2 c0-0.2-0.5,0.1-0.5,0.5c0,1.1-0.5,1.5-0.9,1.6c-1.7-0.1-2.6-0.7-3.1-0.7c-0.5,0-1.3,0.4-1.5,1c-0.3,0.9,0.2,1.9,0.7,2.6 c0.4,0.5,1.3,1.1,1.9,1.2c3.5,0.6,5.3,2.5,6.4,2.5c1.4,0,1.8-0.3,2-1c0.4-1.3,0-2.5-0.3-3.4C294.2,185.5,294.4,184.4,294.6,184.2z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M294.6,184.2c0.2-0.4-0.6-1.2-0.6-1.2s-0.1,0.7-0.2,1.1c-0.1,0.4-1.3,1.2-3.3,0.2c-1.4-0.7-1.1-2.2-1.1-2.2 c0-0.2-0.5,0.1-0.5,0.5c0,1.1-0.5,1.5-0.9,1.6c-1.7-0.1-2.6-0.7-3.1-0.7c-0.5,0-1.3,0.4-1.5,1c-0.3,0.9,0.2,1.9,0.7,2.6 c0.4,0.5,1.3,1.1,1.9,1.2c3.5,0.6,5.3,2.5,6.4,2.5c1.4,0,1.8-0.3,2-1c0.4-1.3,0-2.5-0.3-3.4C294.2,185.5,294.4,184.4,294.6,184.2z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M294.6,184.2c0.2-0.4-0.6-1.2-0.6-1.2s-0.1,0.7-0.2,1.1c-0.1,0.4-1.3,1.2-3.3,0.2c-1.4-0.7-1.1-2.2-1.1-2.2 c0-0.2-0.5,0.1-0.5,0.5c0,1.1-0.5,1.5-0.9,1.6c-1.7-0.1-1.4-1-3.1-1c-0.8,0-1.3,0.6-1.5,1.3c-0.3,0.9,0.2,1.9,0.7,2.6 c0.4,0.5,1.3,1.1,1.9,1.2c3.5,0.6,5.3,2.5,6.4,2.5c1.4,0,1.8-0.3,2-1c0.4-1.3,0-2.5-0.3-3.4C294.2,185.5,294.4,184.4,294.6,184.2z "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M285.9,185.1c0,0,0,0.1,0.1,0.1c0.1,0,0.1,0,0.1,0c0.2-0.4,0.4-0.7,0.6-0.8c0.2-0.2,0.5-0.2,0.8-0.2 c0.1,0,0.1,0,0.1-0.1c0-0.1-0.1-0.1-0.1-0.1c-0.3,0-0.7,0-0.9,0.2C286.4,184.4,286.1,184.7,285.9,185.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M286.5,185.4c0,0,0,0.1,0.1,0.1c0.1,0,0.1,0,0.1,0c0.1-0.4,0.3-0.7,0.5-0.9c0.2-0.2,0.5-0.3,0.8-0.3 c0.1,0,0.1,0,0.1-0.1c0-0.1-0.1-0.1-0.1-0.1c-0.3,0-0.6,0.1-0.9,0.3C286.8,184.6,286.6,184.9,286.5,185.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M287.1,185.7c0,0.1,0,0.1,0.1,0.1c0.1,0,0.1,0,0.1-0.1c0-0.4,0.1-0.8,0.3-1c0.2-0.2,0.4-0.4,0.7-0.5 c0.1,0,0.1-0.1,0-0.1c0,0-0.1-0.1-0.1-0.1c-0.3,0.1-0.6,0.3-0.8,0.6C287.2,184.9,287.1,185.2,287.1,185.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M287.8,186.1c0,0,0.1,0.1,0.1,0.1c0.1,0,0.1-0.1,0.1-0.1c-0.2-0.4-0.2-0.7-0.1-1c0.1-0.3,0.2-0.5,0.5-0.7 c0,0,0-0.1,0-0.1c0,0-0.1,0-0.2,0c-0.3,0.2-0.4,0.5-0.5,0.8C287.6,185.3,287.6,185.6,287.8,186.1z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M289.9,157.3c-0.5,2.6,0.8,9.5,0.8,12.1c2.1,3.7,4,15.5,4.5,17.7c0.6,2.7-6.9,2-7.7-0.8 c-0.4-6.6-3.3-8.2-4.7-15.8c-1.3-7-2.8-14.3-2.8-15.4c-0.1-1.9,1.4-2.8,1.4-4.8c0,0,2.8-5.5,7.3-5 C291.7,151,291.1,156.4,289.9,157.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M280.1,119c-0.4,0.1-2.7,1.2-4.5,3.5c-1.3,1.6-1.2,5.3-1.1,5.8c0.2,1.6-1.6,16.9,0.6,17.2 c-1.1,4.5,10.4,0.8,13.8-2c2.1-1.5,1.2-11.3,1.5-13c0.3-1.7,1.6-9.7-0.7-12.8c-0.5-0.7-1.5-1.6-2.3-1.5 C284.5,116.4,280.5,118.8,280.1,119z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M276.1,121.8c2.4-0.8,7.5,3.2,9.4,11.4c1,0.3,0.7-0.8,1.7-1.1c-1.6-6.8-5.3-12.9-8.6-12.4 C277.3,120.3,277.2,120.8,276.1,121.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M285.1,116.9c5.9,1.2,3.3,7.5,1.6,15.7c0.8,0.3,1.1-0.8,2.2-1.1c1.4-6.8,4-13.6-1.4-15.4 C286.8,115.9,286.5,115.9,285.1,116.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M268.9,188.3c-0.2,0-0.8,1.4-0.3,2.4c0.1,0.3,0,1.3,2.8,2.3c0.8,0.3,1.5,0.2,3.1,0.9c0.4,0.2,0,0.7,0.3,0.9 c0.8,0.5,1.4,0.8,1.8,1.1c0.6,0.4,2.7,0.4,3.2-0.5c0.3-0.5-0.1-2.7-0.1-2.7L268.9,188.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M279.9,188.3c0.2-0.4-0.6-1.2-0.6-1.2c0,0-0.1,0.7-0.2,1.1c-0.1,0.4-1.3,1.2-3.3,0.2 c-1.4-0.7-1.1-2.2-1.1-2.2c0-0.2-0.5,0.1-0.5,0.5c0,1.1-0.5,1.5-0.9,1.6c-1.7-0.1-2.6-0.7-3.1-0.7c-0.5,0-1.3,0.4-1.5,1 c-0.3,0.9,0.2,1.9,0.7,2.6c0.4,0.5,1.3,1.1,1.9,1.2c3.5,0.6,5.3,2.5,6.4,2.5c1.4,0,1.8-0.3,2-1c0.4-1.3,0-2.5-0.3-3.4 C279.5,189.6,279.8,188.6,279.9,188.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M279.9,188.3c0.2-0.4-0.6-1.2-0.6-1.2c0,0-0.1,0.7-0.2,1.1c-0.1,0.4-1.3,1.2-3.3,0.2 c-1.4-0.7-1.1-2.2-1.1-2.2c0-0.2-0.5,0.1-0.5,0.5c0,1.1-0.5,1.5-0.9,1.6c-1.7-0.1-2.6-0.7-3.1-0.7c-0.5,0-1.3,0.4-1.5,1 c-0.3,0.9,0.2,1.9,0.7,2.6c0.4,0.5,1.3,1.1,1.9,1.2c3.5,0.6,5.3,2.5,6.4,2.5c1.4,0,1.8-0.3,2-1c0.4-1.3,0-2.5-0.3-3.4 C279.5,189.6,279.8,188.6,279.9,188.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M279.9,188.3c0.2-0.4-0.6-1.2-0.6-1.2c0,0-0.1,0.7-0.2,1.1c-0.1,0.4-1.3,1.2-3.3,0.2 c-1.4-0.7-1.1-2.2-1.1-2.2c0-0.2-0.5,0.1-0.5,0.5c0,1.1-0.5,1.5-0.9,1.6c-1.7-0.1-1.4-1-3.1-1c-0.8,0-1.3,0.6-1.5,1.3 c-0.3,0.9,0.2,1.9,0.7,2.6c0.4,0.5,1.3,1.1,1.9,1.2c3.5,0.6,5.3,2.5,6.4,2.5c1.4,0,1.8-0.3,2-1c0.4-1.3,0-2.5-0.3-3.4 C279.5,189.6,279.8,188.6,279.9,188.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M271.2,189.3c0,0,0,0.1,0.1,0.1c0.1,0,0.1,0,0.1,0c0.2-0.4,0.4-0.7,0.6-0.8c0.2-0.2,0.5-0.2,0.8-0.2 c0.1,0,0.1,0,0.1-0.1c0-0.1-0.1-0.1-0.1-0.1c-0.3,0-0.7,0-0.9,0.2C271.7,188.5,271.4,188.8,271.2,189.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M271.8,189.5c0,0,0,0.1,0.1,0.1c0.1,0,0.1,0,0.1,0c0.1-0.4,0.3-0.7,0.5-0.9c0.2-0.2,0.5-0.3,0.8-0.3 c0.1,0,0.1,0,0.1-0.1c0-0.1-0.1-0.1-0.1-0.1c-0.3,0-0.6,0.1-0.9,0.3C272.1,188.8,271.9,189.1,271.8,189.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M272.4,189.9c0,0.1,0,0.1,0.1,0.1c0.1,0,0.1,0,0.1-0.1c0-0.4,0.1-0.8,0.3-1c0.2-0.2,0.4-0.4,0.7-0.5 c0.1,0,0.1-0.1,0-0.1c0,0-0.1-0.1-0.1-0.1c-0.3,0.1-0.6,0.3-0.8,0.6C272.5,189.1,272.4,189.4,272.4,189.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M273.1,190.2c0,0,0.1,0.1,0.1,0.1c0.1,0,0.1-0.1,0.1-0.1c-0.2-0.4-0.2-0.7-0.1-1c0.1-0.3,0.2-0.5,0.5-0.7 c0,0,0-0.1,0-0.1c0,0-0.1,0-0.2,0c-0.3,0.2-0.4,0.5-0.5,0.8C272.9,189.4,272.9,189.8,273.1,190.2z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M282.4,159.3c-0.2,3.7-1.3,6.5-2.2,10.6c-0.7,3,1.1,18.5,0.3,22.5c-0.7,1.2-5,0.2-7.1-2.4 c-0.7-2.9-1.9-18.1-1.5-21.7c0.3-1.2,0.7-7.3,0.8-9.6c0.3-6,1.4-10.6,2.2-12c0,0,4.9-0.5,9.4,0.3 C288.1,154.3,282.8,158.9,282.4,159.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M274.8,146.7c2.1,1.9,11.1,2.5,13.9-1.5c0-0.5,0.1-1.3,0.1-1.8c-3.2,2.4-10.1,4.1-13.8,2 C275,145.9,274.9,146.3,274.8,146.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M276.4,172.1c0-2.8,0.4-5.7,1.5-8.5c-2.2-0.5-4-1.3-5.3-2.8c-0.7,3.6-2,8.3-0.7,9.2 C273.5,171.2,274.7,171.8,276.4,172.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M277.2,163.7c-2.4-0.8-3.7-1.6-4.8-2.7c-0.3,0.7-0.6,1.4-1,2.2c1.3,1.3,2.8,2.4,4.9,2.8 C276.7,165.3,277.1,164.6,277.2,163.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M272.7,163.8c0.1-0.1,0.1-0.4-0.1-0.7c-0.2-0.2-0.5-0.3-0.6-0.2c-0.1,0.1-0.1,0.4,0.1,0.7 C272.4,163.8,272.6,163.9,272.7,163.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M276.1,165.6c0.1-0.1,0.1-0.4-0.1-0.7c-0.2-0.2-0.5-0.3-0.6-0.2c-0.1,0.1-0.1,0.4,0.1,0.7 C275.7,165.6,276,165.7,276.1,165.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M274.3,147.8c-1.8,6.3-2.6,11.4-1.7,11.8c2.1,1.2,3.1,1.7,5.1,1.8c0.5-1.7,0.7-4.2,1.1-6 c-3.7-1.2-3.3-4.8-2.8-6.9C275.2,148.5,275.1,148.2,274.3,147.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M283.1,145.9c1.5-3.8,2.6-8,2.5-13c1.1-0.5,2.3-1.1,3.4-1.6c0,4.1-0.1,8.1-0.1,12.2 C287.1,145.5,285.2,146.2,283.1,145.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M278,105.4c0,0.8-0.6,1.8-0.7,2.6c-0.1,0.5-0.2,0.7,0,1.2c0.3,0.7,0.2,1.4,0,2.2c-0.2,0.9,0.1,1.8,0.3,2.7 c0.2,0.7,0.3,1.5,0.9,1.9c1.6,1,3.3,0.4,4.9-0.1c1.6-0.5,1.3-3.3,1.8-4.6c0.9-2.3,0.2-5.6-2.3-6.6c-1.2-0.5-3-0.7-4.2-0.2 C278.3,104.6,278,105.4,278,105.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M280.1,114.8c0,0-0.5,2.6-0.2,3.9c0.2,0.4,1.7,1.5,3,1.5c2,0,4.3-1,3.6-2.7c-0.4-0.9-1.3-1.8-0.7-5.4 C286,111.1,280.1,114.8,280.1,114.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M285.5,103.7c-2.4-1.6-5.7-0.6-7.3,1.2c-0.9,1-0.5,1.8-0.5,1.8c0.5,0.7,0.9-0.1,1.2,1.8 c0.1,0.5,0.6,1.1,0.7,1.5c1.9,8.1,5.9,4.6,6,4.3c1.2-2.8,2-2.2,2.5-3.9C289,107.8,288.9,106,285.5,103.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M280.8,112c-0.3,0.9-0.5,1.7-0.9,1.5c-0.4-0.2-0.8-1-0.5-1.8c0.3-0.9,0.5-1.7,0.9-1.7 C281.1,110,281.1,111.1,280.8,112z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M266.1,147c11.3-1.2,20.3,22.4,13.3,27.6l-8,4.6l-15.4-26.6L266.1,147z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M270.1,179.8c-4.9,1.5-11.7-3.6-15-11.4c-3.3-7.8-2-15.4,2.9-16.9c4.9-1.5,11.7,3.6,15,11.4 C276.3,170.7,275,178.3,270.1,179.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M261.2,155.1c-3.8-0.8-6.4,3.1-4.1,10.1c2.2,7,6.3,10.6,9.7,11.7c3.4,1.1,5.7-3.2,4.2-9 C269.6,162.1,265,155.9,261.2,155.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M261.8,155.6c-3.3-0.7-5.5,2.7-3.6,8.7c1.9,6.1,5.4,9.2,8.4,10.1c2.9,1,4.9-2.8,3.7-7.8 C269,161.7,265,156.3,261.8,155.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M262.8,157.1c-2.8-0.6-4.8,2.3-3.1,7.6c1.7,5.3,4.7,8,7.3,8.8c2.5,0.8,4.3-2.4,3.2-6.8 C269.1,162.3,265.6,157.7,262.8,157.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M260.5,165.9c1.6,4.1,4.1,6.2,6.3,6.9c1.5,0.5,2.6-0.5,3.1-2.3C266.8,172.8,263.9,171.6,260.5,165.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M263,157.8c-1.5-0.3-2.7,0.4-3.2,2c0.7-0.7,1.6-0.9,2.6-0.7c2.9,0.6,6.3,5.3,7.4,9.7 c0.1,0.2,0.1,0.5,0.2,0.7c0.1-0.9,0-1.9-0.3-2.9C268.7,162.6,265.6,158.3,263,157.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M263.8,163.5c-0.8-0.2-1.4,0.7-0.9,2.2c0.5,1.5,1.4,2.3,2.1,2.6c0.7,0.2,1.2-0.7,0.9-2 C265.6,165,264.6,163.7,263.8,163.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M261.2,159.2c-0.4-0.1-0.6,0.3-0.4,1c0.2,0.7,0.6,1.1,1,1.2c0.3,0.1,0.6-0.3,0.4-0.9 C262,159.9,261.6,159.3,261.2,159.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M267.2,170.3c-0.4-0.1-0.6,0.3-0.4,1c0.2,0.7,0.6,1.1,1,1.2c0.3,0.1,0.6-0.3,0.4-0.9 C268,171,267.6,170.4,267.2,170.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M264.8,160c-0.4-0.1-0.6,0.3-0.4,1c0.2,0.7,0.6,1.1,1,1.2c0.3,0.1,0.6-0.3,0.4-0.9 C265.6,160.7,265.1,160.1,264.8,160z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M263.3,168.9c-0.4-0.1-0.6,0.3-0.4,1c0.2,0.7,0.6,1.1,1,1.2c0.3,0.1,0.6-0.3,0.4-0.9 C264.1,169.6,263.6,168.9,263.3,168.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M260.7,164.1c-0.4-0.1-0.6,0.3-0.4,1c0.2,0.7,0.6,1.1,1,1.2c0.3,0.1,0.6-0.3,0.4-0.9 C261.5,164.8,261.1,164.1,260.7,164.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M268.2,165.1c-0.4-0.1-0.6,0.3-0.4,1c0.2,0.7,0.6,1.1,1,1.2c0.3,0.1,0.6-0.3,0.4-0.9 C269.1,165.8,268.6,165.2,268.2,165.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M264,163.7c-0.5-0.1-0.9,0.4-0.6,1.5c0.3,1,0.9,1.5,1.4,1.7c0.5,0.2,0.8-0.5,0.6-1.3 C265.2,164.7,264.5,163.8,264,163.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M277.4,122.1c3.3-0.2,4.7,4.8,3.8,8c-0.1,0.1-2.2,7.1-5.2,11.6c-1.8,2.1-4.5-1.6-3.9-4.3 c-0.4-3.9,1.5-7.2,1.8-8.5C273.1,125.9,273.9,121.6,277.4,122.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M266.1,151.5c-0.3,0.4-1.1,0.3-1.6,0.4c-0.6,0.1-0.8,0.9-1.6,0.9c-0.8-0.1,1.3-1.8,1.6-2 c0.2-0.2,1.2-0.6,1.5-0.3C266.6,150.9,266.3,151.1,266.1,151.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M266.1,151.5c-0.3,0.4-1.1,0.3-1.6,0.4c-0.6,0.1-0.8,0.9-1.6,0.9c-0.8-0.1,1.3-1.8,1.6-2 c0.2-0.2,1.2-0.6,1.5-0.3C266.6,150.9,266.3,151.1,266.1,151.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M268.1,150.8c0.1-0.5-1-1.7-1.4-1.2c-0.5,0.4-2.3,1.9-2.4,2.1c-0.2,0.2-0.3,0.4-0.4,0.6 c-0.2,0.3-0.2,0.5-0.2,0.9c0,0.3-0.1,1.3-0.1,1.6c0.1,0.6,0.1,1.3,0.3,1.8c0.1,0,0.3,0,0.4-0.2c0.1,0.2,0.1,0.5,0.2,0.5 c0.4-0.1,0.4-0.5,0.4-0.5l0,0.2c0.4,0,0.6-0.3,0.6-0.5c0.1-0.2,0.1-0.9,0.2-1.2c0.1-0.5,0.4-1.8,0.2-0.5c-0.1,0.6-0.1,1.4,0.2,1.2 c0.5-0.3,0.3-0.7,0.4-1.2c0.1-0.5,0.6-1.5,0.9-1.9C268.2,151.7,268,151.5,268.1,150.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M265.7,149.7c-0.3,0.9,1.7,2.6,2.7,1.9c0.6-0.7,0.9-1.3,1.5-2c0-1.2-2.2-2.6-3.2-1.7 C266.2,148.7,266.2,148.8,265.7,149.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M277.2,138.2c0.5,2.3-4.9,10-7.1,12.1c-1.3,0.3-4.2-1.5-3.7-2.5c2.2-2.4,3.5-7.2,5.7-10.4 C273.6,135.5,275.9,136.6,277.2,138.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M278.4,105c1.4,0,3.7,0.2,4.6,0.7c-2.2,0.1-2.4,1.6-3.6,2c-1.5,0.5-5.1,0.3-5-0.5 C274.7,105.4,277,105,278.4,105z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M288.5,109.3c-2.2,1.3-8,0-11.2-2.1c0.4-5,4-5.3,7.1-4.5C288,103.6,290.1,106.7,288.5,109.3z"
  }))), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M220.1,50.3c-3.3,0.1-2.7,4-1.4,6.5c0.1,0.1,0.5,8.1,4.7,12.9c1.7,2.7,3.6,1.9,3.9,0.5c0.7-3.3-1-9.6-1.8-12.8 C225.7,52.7,224.5,49.8,220.1,50.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M236.7,76.1c0.4-0.2,1.6-0.4,2.1-0.4c0.6-0.1,1,0,1.6,0c0,0.5-0.3,0.8-1.4,0.8c-1.6,0.3-1.9,1.6-3.1,0.9 C235.3,77,235.2,76.6,236.7,76.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M236,76.6c0.6-0.5,0.8-0.7,1.3-0.5c1,0.4,2.9,0.3,3,0.3c0.3,0.1-0.5,0.8,0.4,1.1c0.3,0.2-1.5,0.4-0.2,1.2 c-1.2,0.8-1.3,0.4-0.5,1.2c0,0.4-1.1,0.5-2,0.7c-0.2,0.3-2.1-1.1-2.5-2l-0.6-0.3c-0.7-0.9,0-1.7,0.6-2L236,76.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M214.2,52.7c-0.4,0.1-4.8,2.3-6.7,4.1c-1.3,1.4,0.4,4.7,0.5,5.1c0,1.5,0.7,10.6,1,12.6c0.3,2-0.9,2.9,0.8,3.7 c2.3,5.6,12.3,9.2,13.4,4.6c-0.9-4,1.2-15,1.4-21.8c0.1-1.6,1.2-7.3-1.3-9.5c-0.6-0.6-1.9-0.9-2.7-0.9 C217.8,50.7,214.6,52.6,214.2,52.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M217.7,52.5c2.7-0.8,4.9,3.3,4.5,11.6c0.9,0.3,1.2-0.2,2.3-0.5c0.4-6.8-0.9-11.7-4.7-12.9 C218.3,51.2,219,51.6,217.7,52.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M228,70.3c3.9,1.6,7.6,3.9,8.1,5c0.4,1.2-1.1,3.9-2.8,3.5c-2.4-0.6-2.5,0.2-7.5-3.6 C223.6,73.7,226,69.5,228,70.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M237,76c0.4,0.9-0.5,3-1.6,3.1c-0.9-0.3-1-0.7-1.9-1c-0.2-1.2,0.8-3,1.9-3.1C236.2,75.5,236.1,75.5,237,76z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M233.7,75.8c0.7-0.2,1-0.3,1.4,0.1c0.7,0.8,2.5,1.4,2.7,1.5c0.8,0.9-1.9,3.7-3.6,3.3c-0.4,0.2-2-2.4-1.7-3.1 l-0.5-0.5c-0.3-1.1,0.7-1.6,1.3-1.6L233.7,75.8z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M215.7,113.6c8.5,0,15.5,3.7,15.5,8.2c0,4.5-6.9,8.2-15.5,8.2c-8.5,0-15.5-3.7-15.5-8.2 C200.2,117.3,207.1,113.6,215.7,113.6z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M221.5,116.4c0,0,0.8,3.6-0.8,2.9c-0.7-0.3-0.5,1.1-0.4,1.6c0.2,0.5,2.3,1.6,2.7,1.5c0.4,0,0.6-0.2,1,0.2 c0.4,0.4,0.3,0.8,0.9,1.3c0.5,0.4,2.9,1.5,5.1,0.5c1-0.4,1.5-0.8,1.1-1.7c-0.1-0.3-2.7-1.6-3.5-2c-1.9-0.9-2.7-2.9-2.9-3.4 c-0.2-0.4-0.8-1.8-0.8-1.8S223.1,115.3,221.5,116.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M221.5,116.4c-0.5,0.8-1.2,2.1-1,3.6c0.2,0.5,2.1,1.7,2.5,1.7c1,0,1.3,0.9,2,1.5c1.1,0.9,3.6,1.8,5.8,0.2 c0.5-0.4,0.2-1.2-0.1-1.5c-0.5-0.6-2.3-0.8-3-1.2c-2.2-1-2.7-3.6-2.9-4.1c-0.2-0.4-0.7-1.1-0.7-1.1S223.1,115.3,221.5,116.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M226.6,121.8c0,0,0,0.1,0.1,0.1c0.1,0,0.1,0,0.1,0c0.2-0.4,0.4-0.7,0.6-0.8c0.2-0.2,0.5-0.2,0.8-0.2 c0.1,0,0.1,0,0.1-0.1c0-0.1-0.1-0.1-0.1-0.1c-0.3,0-0.7,0-0.9,0.2C227,121.1,226.8,121.4,226.6,121.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M226.1,121.4c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0c0.2-0.3,0.3-0.6,0.6-0.7c0.2-0.1,0.4-0.2,0.7-0.2 c0,0,0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1c-0.3,0-0.6,0-0.8,0.2C226.5,120.8,226.3,121.1,226.1,121.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M225.6,121c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0c0.2-0.3,0.3-0.6,0.6-0.7c0.2-0.1,0.4-0.2,0.7-0.2 c0,0,0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1c-0.3,0-0.6,0-0.8,0.2C226,120.4,225.8,120.7,225.6,121z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M225.2,120.6c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0c0.2-0.3,0.3-0.6,0.6-0.7c0.2-0.1,0.4-0.2,0.7-0.2 c0,0,0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1c-0.3,0-0.6,0-0.8,0.2C225.5,120,225.3,120.2,225.2,120.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M224.7,120.2c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0c0.2-0.3,0.3-0.6,0.6-0.7c0.2-0.1,0.4-0.2,0.7-0.2 c0,0,0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1c-0.3,0-0.6,0-0.8,0.2C225,119.6,224.8,119.8,224.7,120.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M224.2,119.8c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0c0.2-0.3,0.3-0.6,0.6-0.7c0.2-0.1,0.4-0.2,0.7-0.2 c0,0,0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1c-0.3,0-0.6,0-0.8,0.2C224.6,119.1,224.4,119.4,224.2,119.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M223.7,119.3c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0c0.2-0.3,0.3-0.6,0.6-0.7c0.2-0.1,0.4-0.2,0.7-0.2 c0,0,0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1c-0.3,0-0.6,0-0.8,0.2C224.1,118.7,223.9,119,223.7,119.3z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M200.8,114.5c0,0-0.8,3.6-1.9,2.4c-0.5-0.5-0.9,0.8-1,1.3c0,0.5,1.4,2.4,1.8,2.5c0.4,0.2,0.7,0.1,0.9,0.6 c0.2,0.5-0.1,0.9,0.3,1.6c0.3,0.6,2,2.6,4.5,2.6c1.1,0,1.6-0.1,1.7-1.1c0-0.3-1.8-2.6-2.3-3.3c-1.3-1.6-1.3-3.8-1.2-4.2 c0-0.5,0.1-2,0.1-2C203.4,114.8,202.8,114.2,200.8,114.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M200.8,114.5c-0.8,0.5-2,1.4-2.4,2.9c0,0.5,1.2,2.4,1.6,2.6c0.9,0.4,0.8,1.4,1.2,2.1c0.6,1.3,2.5,3.1,5.2,2.6 c0.6-0.2,0.7-1,0.5-1.4c-0.2-0.7-1.7-1.7-2.2-2.3c-1.6-1.8-1-4.4-1-4.9c0-0.5-0.2-1.3-0.2-1.3 C203.4,114.8,202.8,114.2,200.8,114.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M203.2,121.6c0,0,0,0.1,0,0.1c0,0,0.1,0.1,0.1,0c0.3-0.3,0.6-0.4,0.9-0.5c0.3,0,0.6,0,0.8,0.2 c0,0,0.1,0,0.1,0c0-0.1,0-0.1-0.1-0.1c-0.3-0.2-0.6-0.2-0.9-0.2C203.9,121.1,203.5,121.2,203.2,121.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M202.9,121c0,0,0,0.1,0,0.1c0,0,0.1,0.1,0.1,0c0.3-0.2,0.5-0.4,0.8-0.4c0.2,0,0.5,0,0.7,0.2c0,0,0.1,0,0.1,0 c0,0,0-0.1,0-0.1c-0.3-0.1-0.5-0.2-0.8-0.2C203.5,120.6,203.2,120.7,202.9,121z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M202.7,120.4c0,0,0,0.1,0,0.1c0,0,0.1,0.1,0.1,0c0.3-0.2,0.5-0.4,0.8-0.4c0.2,0,0.5,0,0.7,0.2 c0,0,0.1,0,0.1,0c0,0,0-0.1,0-0.1c-0.3-0.1-0.5-0.2-0.8-0.2C203.3,120,203,120.2,202.7,120.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M202.4,119.8c0,0,0,0.1,0,0.1c0,0,0.1,0.1,0.1,0c0.3-0.2,0.5-0.4,0.8-0.4c0.2,0,0.5,0,0.7,0.2 c0,0,0.1,0,0.1,0c0,0,0-0.1,0-0.1c-0.3-0.1-0.5-0.2-0.8-0.2C203,119.4,202.7,119.6,202.4,119.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M202.1,119.3c0,0,0,0.1,0,0.1c0,0,0.1,0.1,0.1,0c0.3-0.2,0.5-0.4,0.8-0.4c0.2,0,0.5,0,0.7,0.2 c0,0,0.1,0,0.1,0c0,0,0-0.1,0-0.1c-0.3-0.1-0.5-0.2-0.8-0.2C202.7,118.9,202.4,119,202.1,119.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M201.9,118.7c0,0,0,0.1,0,0.1c0,0,0.1,0.1,0.1,0c0.3-0.2,0.5-0.4,0.8-0.4c0.2,0,0.5,0,0.7,0.2 c0,0,0.1,0,0.1,0c0,0,0-0.1,0-0.1c-0.3-0.1-0.5-0.2-0.8-0.2C202.5,118.3,202.2,118.4,201.9,118.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M201.6,118.1c0,0,0,0.1,0,0.1c0,0,0.1,0.1,0.1,0c0.3-0.2,0.5-0.4,0.8-0.4c0.2,0,0.5,0,0.7,0.2 c0,0,0.1,0,0.1,0c0,0,0-0.1,0-0.1c-0.3-0.1-0.5-0.2-0.8-0.2C202.2,117.7,201.9,117.8,201.6,118.1z"
  })))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M214.4,84.2c0.8,2.4,0.4,4.2,1,6.6c0.9,3,3.6,7.5,3.3,11.1c-0.6,6.5,1,10.8,0.9,16.5c1.7,1.3,6.9,0.3,6-1.8 c-0.5-6.8-0.1-14.9-0.3-17c0-0.3-0.2-2-0.2-3c0.1-5.9-1.3-17.5-1.9-19.6c0,0-2.1,1.3-6.3,2.2C216.8,80,214.2,83.9,214.4,84.2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M207.2,105.1c-2.3,1.9-5.6,6-8.5,10c-0.7,1.7,2.5,5.4,5.1,4c1.3-1.8,6.9-6.8,9.5-9.4c0.2-0.2,1.6-1.9,1.7-2.2 c1.9-6.3,3.9-8.5,4.6-19.4c3.5-0.5,1.7-5.7,1.9-10.3c-5.9,4-10.4,2.4-11.8,1.3c-2,3.1-1.3,9.1-0.2,9.9c-0.6,5.5-0.3,10.6-0.8,14.6 C207.8,105.2,208,104.4,207.2,105.1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M209.5,79.5c2.1,1.9,11.1,2.5,13.9-1.5c0-0.5,0.1-1.3,0.1-1.8c-3.2,2.4-10.1,4.1-13.8,2 C209.6,78.7,209.5,79.1,209.5,79.5z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M212,79c2.6-3.4,3.2-9,2-15.6c4.3-0.4,8-2.5,10.5-5c-0.1,5.1,0.4,15-1.3,18.2C221.9,78.9,215.8,80.2,212,79z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M207.7,56.7c2.4-0.8,5.4,1.8,7.3,10.1c1,0.3,2.1,0,3.1-0.3c-1.6-6.8-3.8-12.6-7.1-12.1 C209.6,54.9,208.7,55.7,207.7,56.7z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M216.8,74.7c0.4-3.3,0.5-6.5-0.3-9.8c2.7-0.6,5-1.6,6.7-3.4c-0.1,3.6,1,8.4-0.2,10.6 C220.9,73.5,218.8,74.4,216.8,74.7z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M213.3,104.1c0-2.8,0.3-5.7,1.3-8.5c-2.3-0.5-4-1.3-5.4-2.8c-0.7,3.6-1.8,8.3-0.5,9.2 C210.4,103.2,211.6,103.9,213.3,104.1z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M214,95.8c-2.4-0.8-3.7-1.6-4.9-2.7c-0.3,0.7-0.6,1.4-0.9,2.2c1.3,1.3,2.9,2.4,4.9,2.8 C213.5,97.4,213.9,96.6,214,95.8z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M218.2,81.8c0.2,4.4-0.4,8.2-1.1,11.6c-2.4,0.3-5-0.5-6.7-1.6c0.2-1.8,0.3-2.9,0.6-4.8c3.1-1.1,4-3.2,4.3-5.4 C216.2,81.9,217.4,81.8,218.2,81.8z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M216.9,65.3c2.9-1,4.6-1.9,6.1-3.3c0.4,0.9,0.7,1.8,1.1,2.7c-1.6,1.6-3.5,2.9-6.1,3.5 C217.5,67.3,217.1,66.4,216.9,65.3z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M209.5,95.8c0.1-0.1,0.1-0.4-0.1-0.7c-0.2-0.2-0.5-0.3-0.6-0.2c-0.1,0.1-0.1,0.4,0.1,0.7 C209.2,95.9,209.4,96,209.5,95.8z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M213,97.6c0.1-0.1,0.1-0.4-0.1-0.7c-0.2-0.2-0.5-0.3-0.6-0.2c-0.1,0.1-0.1,0.4,0.1,0.7 C212.6,97.7,212.8,97.8,213,97.6z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M222.4,65.1c-0.1-0.1-0.1-0.4,0.1-0.7c0.2-0.2,0.5-0.3,0.6-0.2c0.1,0.1,0.1,0.4-0.1,0.7 C222.7,65.2,222.5,65.3,222.4,65.1z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M218.5,67.4c-0.1-0.1-0.1-0.4,0.1-0.7c0.2-0.2,0.5-0.3,0.6-0.2c0.1,0.1,0.1,0.4-0.1,0.7 C218.8,67.4,218.6,67.5,218.5,67.4z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M214.1,48.4c0,1.5-0.5,3.2-0.5,4.7c0,1.2,2,2.2,2.6,2.6c2.9,1.7,3.8-0.2,3.6-1.6c-0.4-2.2,0.1-3,1.2-5.9 L214.1,48.4z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M211,42.9c0,0.9-0.3,1.7-0.6,2.5c-0.4,1,0.8,1.3-0.1,2.6c-0.2,1,0,2.6,0.3,3.5c0.1,0.7,0.2,1.8,1.3,2.5 c1.7,1.2,3.5-0.4,5.3-0.9c1.7-0.5,1.1-2.7,1.6-4.1c1.1-2.5,1.1-6-1.7-7.2c-1.2-0.5-3.3-0.9-4.6-0.4C212,41.7,211,42.1,211,42.9z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M221.4,48l-0.1,0.1C221.4,48.1,221.4,48,221.4,48z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M216.4,47.2c1.2,0.6,1.2,2,0.8,3.1c0,0.3,2.2-1.3,2.7,0.7c2.2-1.8,2.8-7.3,1.3-8.8c-3.2,0.1-4.3,0.1-5.5,1.8 C215.4,44.9,215.8,46.9,216.4,47.2z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M215.8,39.9c-4.5,0.6-5.9,2.8-4.1,4.5c0.6,0.6,1.1,0.5,3.9,0c1-1.4,2.1-2,5.6-2.1 C220.4,39.6,217,39.7,215.8,39.9z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M213.8,51.1l0,0.1C213.7,51.1,213.8,51.1,213.8,51.1z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M219.9,49.2c-0.4,0.9-1,1.5-1.4,1.3c-0.4-0.2-0.5-1.1-0.1-2c0.4-0.9,1.1-1.4,1.5-1.3 C220.2,47.4,220.2,48.3,219.9,49.2z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M211.8,50.5c0.8,0.3,1.8,1.1,2.3,1.7c0.3,0.4,0.3,1.3,0.1,2.2c-1,0.5-1.5,0.9-2.3,0.5v-2.7 c0.2,0.2,0.5,0.5,0.5,0.6c0.5,0.3,0.8-0.1,0.3-0.4c-0.4-0.3-0.5-0.4-0.9-0.7V50.5z M210.3,51.2c0.1-0.3,0.4-1,1-0.8 c0.1,0,0.3,0.1,0.5,0.2v1.3c-0.1-0.1-0.2-0.2-0.4-0.3c-0.7,0.2-1,0.5-0.4,0.8c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.2-0.1,0.3-0.2 c0-0.1,0.2,0,0.3,0.2V55c-0.1,0-0.1-0.1-0.2-0.1c-1.3-0.7-1.6-1.4-1.6-2.2C210,52.2,210.2,51.7,210.3,51.2z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M209.8,57.2c-2.6-2-5.2,2.9-5.8,5.6c0,0.2-3.5,5.9-3.5,11.2c0.3,2.8,4.3,2.6,5.4,0c2.5-3,3.7-7,4.4-7.9 C211.5,64.5,213,58.8,209.8,57.2z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M234.7,75.4c0.5-0.1,1.7-0.2,2.1-0.2c0.6,0,0.9,0.2,1.5,0.2c-0.1,0.5-0.4,0.8-1.5,0.7 c-1.6,0.1-2.1,1.4-3.2,0.5C233.2,76.2,233.1,75.8,234.7,75.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 222.4807,
    y1: 84.9875,
    x2: 224.1885,
    y2: 82.0296
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#706F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#706F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#C6C6C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C6C6C6"
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M222.3,82.3l2.3,1.3V85c-1-0.6-1.9-1.1-2.9-1.7C221.4,83,221.7,82.3,222.3,82.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 221.4612,
    y1: 89.204,
    x2: 226.9924,
    y2: 79.2253
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#706F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#706F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#C6C6C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C6C6C6"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M227.8,81.6L227.8,81.6L227.8,81.6L227.8,81.6L227.8,81.6z M221.9,86.1v-0.1c0-0.7,0.2-1.4,0.5-2.2 c0.9-2,2.7-3.3,3.9-2.9c0.1,0,0.1,0,0.2,0.1v0l0,0c0.1,0,0.2,0.1,0.2,0.1l1,0.6c-0.1,0-0.1-0.1-0.2-0.1c-1.3-0.4-3,0.9-3.9,2.9 c-0.8,1.8-0.7,3.6,0.3,4.2l-1.1-0.6l0,0C222.2,87.6,221.9,86.9,221.9,86.1z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M224.2,88.8c1.3,0.4,3-0.9,3.9-2.9c0.9-2,0.6-4-0.6-4.4c-1.3-0.4-3,0.9-3.9,2.9 C222.6,86.4,222.9,88.4,224.2,88.8z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M226.1,101.2c4.1-1.5,8.5-5.9,11.1-11.7c3.7-8.3,2.5-16.3-2.7-17.9c-2.5-0.8-5.6,0.1-8.4,2.2v4.8 c1.6-1.5,3.4-2.4,5-2.6c1.2,2.2,1,5.8-0.6,9.5c-1.1,2.4-2.7,4.5-4.3,5.9V101.2z M221,101.5c1.6,0.5,3.3,0.3,5.1-0.3v-9.9 c-1.8,1.5-3.8,2.3-5.4,2c-0.6-2.4-0.3-5.6,1.2-8.8c1.1-2.4,2.6-4.4,4.2-5.9v-4.8c-3,2.2-5.8,5.7-7.7,9.9 C214.6,91.9,215.8,99.9,221,101.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 245.0227,
    y1: 53.2977,
    x2: 200.8095,
    y2: 148.1133
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#706F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C6C6C6"
    }
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M229.5,95.4c2.1-1.5,4.1-3.9,5.4-6.9c2.6-5.7,1.8-11.3-1.9-12.4c-0.6-0.2-1.3-0.2-2-0.2 c1.2,2.2,1,5.8-0.6,9.5c-0.3,0.6-0.6,1.2-0.9,1.8V95.4L229.5,95.4z M231.1,75.9c-3.6,0.4-4.1,0.5-1.6,0.2L231.1,75.9z M223.7,96.9 c1.7,0.5,3.8-0.1,5.8-1.5v-8.2c-2.4,4-6,6.5-8.8,6.1C221.1,95.1,222.2,96.4,223.7,96.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 236.3261,
    y1: 70.6547,
    x2: 222.0272,
    y2: 101.3188
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#706F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#706F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#C6C6C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C6C6C6"
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M223,95.7c3.3,1,8-2.4,10.4-7.7c2.4-5.3,1.6-11-2.3-12c1.5,2.9,0.6,6.7-0.6,9.5c-2.3,5-6.5,8.4-9.8,7.9 c0.1,0.3,0.2,0.5,0.3,0.8C221.4,94.8,222.1,95.4,223,95.7z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M236,72.2L236,72.2L236,72.2L236,72.2L236,72.2z M211.5,91v-1.8c0.1-2.6,0.8-5.4,2.1-8.3 c3.7-8.3,11-13.7,16.2-12.1c0.2,0.1,0.5,0.2,0.7,0.3l0,0l0,0c0.3,0.2,0.6,0.3,0.9,0.5l4,2.3c-0.3-0.2-0.6-0.3-0.9-0.4 c-5.2-1.6-12.4,3.8-16.2,12.1c-3.4,7.5-2.7,14.7,1.2,17.2l-4.5-2.6l0,0C213,97,211.7,94.4,211.5,91z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M223.9,95.9C223.9,95.9,223.9,95.9,223.9,95.9c-0.1,0-0.1-0.1-0.1-0.1l5.8-19.6c0,0,0.1-0.1,0.1-0.1 c0,0,0.1,0.1,0.1,0.1L223.9,95.9C224,95.9,223.9,95.9,223.9,95.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M226.2,95.6C226.2,95.6,226.2,95.6,226.2,95.6C226.2,95.6,226.2,95.5,226.2,95.6l1-18c0,0,0-0.1,0.1-0.1 c0,0,0,0,0,0c0,0,0.1,0,0.1,0.1L226.2,95.6C226.3,95.5,226.3,95.6,226.2,95.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M228.5,94.3C228.5,94.3,228.5,94.2,228.5,94.3l-3.3-15c0,0,0-0.1,0.1-0.1c0,0,0.1,0,0.1,0.1l3.2,14.9 C228.6,94.2,228.6,94.3,228.5,94.3C228.6,94.3,228.5,94.3,228.5,94.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M230.6,92.3C230.6,92.3,230.6,92.3,230.6,92.3l-7-11.1c0,0,0-0.1,0-0.1c0,0,0.1,0,0.1,0l6.9,11.1 C230.7,92.2,230.7,92.3,230.6,92.3C230.7,92.3,230.6,92.3,230.6,92.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M232.4,89.9C232.4,89.9,232.4,89.9,232.4,89.9l-10-6.6c0,0,0-0.1,0-0.1c0,0,0.1,0,0.1,0l9.9,6.6 C232.5,89.7,232.5,89.8,232.4,89.9C232.5,89.9,232.4,89.9,232.4,89.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M233.8,87C233.8,87,233.8,87,233.8,87l-12.3-1.5c0,0-0.1,0-0.1-0.1c0,0,0-0.1,0.1-0.1c0,0,0,0,0,0 l12.3,1.5C233.9,86.9,233.9,86.9,233.8,87C233.9,87,233.8,87,233.8,87z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M220.7,87.9C220.7,87.9,220.7,87.9,220.7,87.9c-0.1-0.1-0.1-0.2,0-0.2l13.9-4c0,0,0.1,0,0.1,0.1 c0,0,0,0.1-0.1,0.1L220.7,87.9C220.7,87.9,220.7,87.9,220.7,87.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M220.4,90.5C220.4,90.5,220.3,90.5,220.4,90.5c-0.1-0.1-0.1-0.1,0-0.2l14.3-9.7c0,0,0.1,0,0.1,0 c0,0,0,0.1,0,0.1L220.4,90.5C220.4,90.5,220.4,90.5,220.4,90.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M220.6,93.2C220.6,93.2,220.6,93.2,220.6,93.2c-0.1-0.1-0.1-0.1-0.1-0.1l13.2-15c0,0,0.1,0,0.1,0 c0,0,0,0.1,0,0.1L220.6,93.2C220.7,93.2,220.6,93.2,220.6,93.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M221.9,95.2C221.9,95.2,221.8,95.2,221.9,95.2c-0.1,0-0.1-0.1-0.1-0.1l10.3-18.8c0,0,0.1-0.1,0.1,0 c0,0,0.1,0.1,0,0.1L221.9,95.2C221.9,95.2,221.9,95.2,221.9,95.2z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M225.2,95.9C225.2,95.9,225.2,95.9,225.2,95.9C225.1,95.8,225.1,95.8,225.2,95.9l3.1-19 c0,0,0.1-0.1,0.1-0.1c0,0,0.1,0.1,0.1,0.1L225.2,95.9C225.2,95.8,225.2,95.9,225.2,95.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M227.3,95C227.3,95,227.3,95,227.3,95l-1.1-16.7c0,0,0-0.1,0.1-0.1c0,0,0,0,0,0c0,0,0.1,0,0.1,0.1 L227.3,95C227.4,95,227.4,95,227.3,95C227.3,95,227.3,95,227.3,95z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M229.4,93.6C229.3,93.6,229.3,93.6,229.4,93.6L224.6,80c0,0,0-0.1,0.1-0.1c0,0,0.1,0,0.1,0.1l4.7,13.5 C229.5,93.5,229.4,93.6,229.4,93.6C229.4,93.6,229.4,93.6,229.4,93.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M231.2,91.6C231.2,91.6,231.2,91.6,231.2,91.6l-7.9-9.8c0,0,0-0.1,0-0.1c0,0,0.1,0,0.1,0l7.9,9.8 C231.3,91.5,231.3,91.6,231.2,91.6C231.2,91.6,231.2,91.6,231.2,91.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M232.8,89.2C232.8,89.2,232.8,89.2,232.8,89.2l-10.7-5.3c0,0-0.1-0.1,0-0.1c0,0,0.1-0.1,0.1,0l10.6,5.3 C232.9,89,232.9,89.1,232.8,89.2C232.9,89.1,232.8,89.2,232.8,89.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M234.1,86.2h-12.9c0,0-0.1,0-0.1-0.1c0,0,0-0.1,0.1-0.1h12.9C234.1,86,234.2,86,234.1,86.2 C234.2,86.1,234.1,86.2,234.1,86.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M220.6,88.8C220.5,88.8,220.5,88.8,220.6,88.8c-0.1-0.1-0.1-0.1,0-0.2l14.2-6.1c0,0,0.1,0,0.1,0 c0,0,0,0.1,0,0.1L220.6,88.8C220.6,88.8,220.6,88.8,220.6,88.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M220.4,91.8C220.4,91.8,220.4,91.8,220.4,91.8c-0.1-0.1-0.1-0.1-0.1-0.1l14-12.3c0,0,0.1,0,0.1,0 c0,0,0,0.1,0,0.1L220.4,91.8C220.4,91.8,220.4,91.8,220.4,91.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M221.1,94.5C221.1,94.5,221.1,94.5,221.1,94.5c-0.1,0-0.1-0.1-0.1-0.1l11.8-17.3c0,0,0.1,0,0.1,0 c0,0,0,0.1,0,0.1L221.1,94.5C221.2,94.5,221.2,94.5,221.1,94.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M223,95.8C223,95.8,223,95.7,223,95.8c-0.1,0-0.1-0.1-0.1-0.1l7.8-19.7c0,0,0.1-0.1,0.1,0 c0,0,0.1,0.1,0,0.1L223,95.8C223.1,95.7,223,95.8,223,95.8z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 222.8759,
    y1: 89.897,
    x2: 228.4072,
    y2: 79.9183
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#706F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#706F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#C6C6C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C6C6C6"
    }
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M229.2,82.3L229.2,82.3L229.2,82.3L229.2,82.3L229.2,82.3z M223.3,86.7v-0.1c0-0.7,0.2-1.4,0.5-2.2 c0.9-2,2.7-3.3,3.9-2.9c0.1,0,0.1,0,0.2,0.1l0,0l0,0c0.1,0,0.2,0.1,0.2,0.1l1,0.6c-0.1,0-0.1-0.1-0.2-0.1c-1.3-0.4-3,0.9-3.9,2.9 c-0.8,1.8-0.7,3.6,0.3,4.2l-1.1-0.6l0,0C223.6,88.3,223.3,87.6,223.3,86.7z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M225.6,89.4c1.3,0.4,3-0.9,3.9-2.9c0.9-2,0.6-4-0.6-4.4c-1.3-0.4-3,0.9-3.9,2.9 C224,87.1,224.3,89.1,225.6,89.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 225.5696,
    y1: 88.1871,
    x2: 228.4456,
    y2: 82.9986
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#706F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#706F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#C6C6C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C6C6C6"
    }
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M228.7,84.2V84C228.8,84.1,228.8,84.2,228.7,84.2z M228.7,84L228.7,84C229.1,84.2,229.1,84.2,228.7,84 L228.7,84z M228.7,84c-0.1-0.1-0.2-0.1-0.3-0.2c0,0-0.1-0.1-0.1-0.1l0,0v0c0,0-0.1,0-0.1,0c-0.7-0.2-1.7,0.5-2.2,1.6 c-0.5,1-0.4,2,0.2,2.4l0,0l0.3,0.2c-0.5-0.3-0.3-1.2,0.1-2.2c0.6-1.3,1.8-1.4,2.1-1.5V84z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M226.6,88c0.7,0.2,1.7-0.5,2.2-1.6c0.5-1.1,0.3-2.2-0.4-2.5c-0.7-0.2-1.7,0.5-2.2,1.6 C225.7,86.7,225.9,87.8,226.6,88z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M227,87c0.4,0.1,0.9-0.3,1.2-0.9c0.3-0.6,0.2-1.2-0.2-1.3c-0.4-0.1-0.9,0.3-1.2,0.9 C226.6,86.3,226.7,86.9,227,87z"
  }))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M200.7,74.6c0.3,2.3,7.9,7.9,10.7,9.1c1.3-0.1,3.5-2.8,2.6-3.6c-0.8-0.9-6.3-5.6-8.8-8 C203.3,70.9,201.4,72.7,200.7,74.6z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M215.4,81.7c0.6,0.7-0.8,3-1.9,2.7c-0.8-0.5-1.3-0.9-2.1-1.4c-0.4-1.1,1.3-3.2,2.5-2.7 C214.6,81,214.6,81,215.4,81.7z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M215.9,83.3c0.5,0.2,1.1-0.2,1.6-0.4c0.5-0.2,1.1,0.5,1.8,0.1c0.7-0.4-2-1-2.4-1c-0.3-0.1-1.3,0-1.5,0.4 C215.2,83,215.6,83,215.9,83.3z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M213.8,83.6c-0.3-0.4,0.7-1.8,1.4-1.5c0.6,0.1,2.3,0.5,2.4,0.6c0.3,0.1,0.4,0.2,0.7,0.3 c0.4,0.2,0.4,0.3,0.6,0.7c0.2,0.3,0.7,1.1,0.8,1.4c0.2,0.5,0.5,1.2,0.5,1.7c-0.1,0.1-0.3,0.1-0.4,0c0,0.2,0.2,0.5,0,0.6 c-0.4,0.1-0.6-0.3-0.6-0.3l0.1,0.2c-0.4,0.2-0.7,0-0.8-0.2c-0.1-0.2-0.5-0.8-0.7-1c-0.4-0.4-1.2-1.4-0.4-0.3 c0.3,0.5,0.7,1.2,0.4,1.2c-0.5,0-0.5-0.5-0.9-0.9c-0.3-0.4-1.2-1.1-1.7-1.3C214.1,84.4,214.1,84.2,213.8,83.6z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M240.2,76.5l-1.5,1c-0.5,0.3-0.1,0.8,0.4,0.6l1.6-0.9C241.1,76.9,240.6,76.1,240.2,76.5z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M240.1,77.4l-1.7,1.1c-0.5,0.3-0.1,0.9,0.5,0.6l1.7-1C241.2,77.9,240.7,77,240.1,77.4z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M240,78.6l-1.4,1c-0.4,0.3-0.1,0.8,0.4,0.5l1.5-0.8C240.9,79,240.5,78.3,240,78.6z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M239.8,79.9l-1.4,0.4c-0.4,0.1-0.2,0.6,0.2,0.5l1.4-0.3C240.4,80.5,240.2,79.8,239.8,79.9z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M216.1,39.5c-4.5,0.6-6.3,3.5-5.2,5c0.5,0.7,2.2,0,5-0.4c1-1.4,2.4-1.8,5.6-2.1 C220.7,39.3,217.3,39.3,216.1,39.5z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M210.9,44.3c-0.9,0.5-2.5,1.9-3.2,2.6c2.1-0.6,3.6,0.7,4.8,1.2c1.3,0.6,3.3-1.6,4.6-2.2 C213.3,46,211.6,45.1,210.9,44.3z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M210.7,44.7c1.9,1.7,7.8,1.5,11.4,0.2c0.6-4.9-2.8-6-6.1-5.8C212.3,39.2,209.7,41.9,210.7,44.7z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M212.9,44c0-0.4,0.1-0.7,0.1-1c0.1-0.3,0.2-0.7,0.3-1c0,0,0,0,0,0c-0.2,0.3-0.3,0.5-0.4,0.8v-1.1 c0.1-0.2,0.3-0.4,0.4-0.6c0.1,0,0.3,0.1,0.4,0.1c0.1,0,0.3,0.1,0.4,0.1c-0.2,0.7-0.5,1.4-0.6,2.1c-0.1,0.7-0.1,1.4,0,2.1 c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.2-0.1-0.3-0.1c0-0.3,0-0.5,0-0.8l-0.1,0L212.9,44L212.9,44z M212.9,42.7l-0.1,0.1 c-0.1,0.3-0.3,0.6-0.4,1l0.4,0.2v0.5l-0.3-0.1c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0.2-0.1,0.5-0.2,0.7c-0.1,0-0.2-0.1-0.3-0.1 c-0.1,0-0.2-0.1-0.3-0.1c0.2-0.6,0.3-1.3,0.6-1.9c0.2-0.4,0.4-0.8,0.7-1.2V42.7z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M138,26.9c-2.8,1.8-1.5,4.4,0.9,5.9c0.1,0.1,4.6,6.7,10.6,8.7c2.9,1.5,2.7-3.2,1.8-4.4c-0.7-1-4-4.9-6.4-7.3 C142.8,25.7,140.6,23.6,138,26.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.4,36.3c2.2-3.6,4.8-5.9,5.5-6.5c1.3-0.2,3.7,1.7,3,3.3c-1,2.2-1.7,3.9-6.2,8.2 C149.9,43.2,148.3,38.1,149.4,36.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M156.4,28.3c0.9-0.3,2.4,0.9,2.9,1.7c-0.4,0.9-1.2,1.6-1.7,2.4c-1.2,0.1-2.8-1.1-2.8-2.2 C155.5,29.5,155.8,29.1,156.4,28.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M157.2,28.4c-0.2-0.7-0.3-1,0-1.4c0.8-0.8,1.3-2.6,1.4-2.7c0.2-0.2,0.6,0.7,1.2,0c0.3-0.3-0.2,1.5,1.1,0.6 c0.3,1.4-0.1,1.6,1,1.2c0.4,0.2,0.1,1-0.1,1.9c0.2,0.4-1.8,1.5-2.8,1.6l-0.5,0.5c-1.1,0.3-1.6-0.6-1.7-1.3L157.2,28.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M157.3,27.4c0-0.5,0.1-1.7,0.1-2.1c0.1-0.6,0.3-0.9,0.4-1.5c0.5,0.1,0.7,0.5,0.4,1.6c-0.1,1.6,1.1,2.2,0.1,3.2 C157.9,29,157.4,29,157.3,27.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M139.7,18.3l-2.2,3.9l-8.4-4.7c-1.7-1,0.4-4.9,2.2-3.9L139.7,18.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M139.5,18.6l-0.7,1.3l-9.7-5.4c0.3-0.5,0.8-0.9,1.2-1L139.5,18.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M159.6,26.7l-4.3,7.7l-16.7-9.3c-3.5-1.9,0.8-9.6,4.3-7.7L159.6,26.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M159.2,27.4l-1.4,2.6l-19.3-10.8c0.7-1,1.5-1.7,2.4-2L159.2,27.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st62",
    d: "M162.5,27.6l-5,8.7l-2.4-1.3c-3.9-2.1,1.1-10.9,5-8.7L162.5,27.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M157.8,29.4l-2.4-1.4c0.7-0.9,1.7-1.7,2.6-1.9l2.5,1.4C159.5,27.7,158.6,28.4,157.8,29.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M163,33.6c-1.3,2.4-3.8,3.6-5.4,2.7c-1.6-0.9-1.8-3.6-0.5-6c1.3-2.4,3.8-3.6,5.4-2.7 C164.1,28.5,164.3,31.2,163,33.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M150.2,31.9l-1.6-0.9c-3.7-2,0.9-10.2,4.6-8.2l1.6,0.9c0.3,0.2,0.6,0.5,0.6,0.7l-1.1-0.6c-3.2,0-6,5-4.3,7.7 l1.1,0.6C150.8,32.2,150.4,32,150.2,31.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st62",
    d: "M149.9,31.7l-1.6-0.9c-3.7-2,0.9-10.2,4.6-8.2l1.6,0.9C151.1,22.7,147.4,29.3,149.9,31.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M150.7,25.4l-2.2-1.2c0.7-0.9,1.6-1.6,2.5-1.8l2.2,1.2C152.2,23.9,151.3,24.6,150.7,25.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M168.2,34.4l-2,3.5l-7-3.9c-1.6-0.9,0.4-4.4,2-3.5L168.2,34.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M168,34.7l-0.7,1.2l-8.1-4.5c0.3-0.4,0.7-0.8,1.1-0.9L168,34.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M168.4,36.8c-0.5,1-1.5,1.5-2.2,1.1c-0.7-0.4-0.7-1.5-0.2-2.4c0.5-1,1.5-1.5,2.2-1.1 C168.8,34.7,168.9,35.8,168.4,36.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M121.6,61c-0.3-0.4-2.1,0.2-2,0.9c-0.1,1.1,0.1,2,0.1,3.2c0.1,0.4,0.2,0.5,0.5,0.8c0.2,0.2,0.7,0.8,1,1 c0.4,0.2,0.8,0.4,1.4,0.7c0.2,0.1,0.3,0,0.2-0.2c0.2,0.1,0.3,0.3,0.5,0.3c0.2-0.1,0.1-0.4,0.1-0.4c0.2,0.2,0.4,0.5,0.5,0.4 c0.2-0.2,0.1-0.7,0-0.8c-0.1-0.2-0.8-0.8-0.9-1c-0.3-0.5-0.9-1.4-0.1-0.4c0.3,0.4,1.4,1.7,1.6,1.4c0.3-0.6-0.6-1.3-0.9-1.8 c-0.3-0.4-1.1-1.5-1.1-2C122.2,61.6,122.1,61.5,121.6,61z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M121.8,61.2c0.4,0.2,1.4,1.3,1.7,1.6c0.4,0.5,0.6,1.2,1,1.7c-0.4,0.2-0.8,0.2-1.4-0.8c-0.6-0.4-2.6,0-2-1.2 C121.4,61.8,121.1,60.8,121.8,61.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M122.3,61c-0.1,0.9-2.8,1.4-3.3,0.4c-0.2-0.9-0.2-1.6-0.4-2.5c0.6-1.1,3.2-1.2,3.7,0 C122.3,59.9,122.3,60,122.3,61z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M132.1,26.5c-0.4,0.1-4.8,2.3-6.7,4.1c-1.3,1.4,0.4,4.7,0.5,5.1c0,1.5,0.7,10.6,1,12.6c0.3,2-0.9,2.9,0.8,3.7 c2.3,5.6,12.3,9.2,13.4,4.6c-0.9-4,1.2-15,1.4-21.8c0.1-1.6,1.2-7.3-1.3-9.5c-0.6-0.6-1.9-0.9-2.7-0.9 C135.8,24.5,132.6,26.4,132.1,26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M135.6,26.3c2.7-0.8,4.9,3.3,4.5,11.6c0.9,0.3,1.2-0.2,2.3-0.5c0.4-6.8,0.2-11.4-3.6-12.5 C137.3,25.5,136.9,25.4,135.6,26.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M133.6,87.4c8.5,0,15.5,3.7,15.5,8.2c0,4.5-6.9,8.2-15.5,8.2c-8.5,0-15.5-3.7-15.5-8.2 C118.1,91.1,125,87.4,133.6,87.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M139.4,90.2c0,0,0.8,3.6-0.8,2.9c-0.7-0.3-0.5,1.1-0.4,1.6c0.2,0.5,2.3,1.6,2.7,1.5c0.4,0,0.6-0.2,1,0.2 c0.4,0.4,0.3,0.8,0.9,1.3c0.5,0.4,2.9,1.5,5.1,0.5c1-0.4,1.5-0.8,1.1-1.7c-0.1-0.3-2.7-1.6-3.5-2c-1.9-0.9-2.7-2.9-2.9-3.4 c-0.2-0.4-0.8-1.8-0.8-1.8S141.1,89.1,139.4,90.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M139.4,90.2c-0.5,0.8-1.2,2.1-1,3.6c0.2,0.5,2.1,1.7,2.5,1.7c1,0,1.3,0.9,2,1.5c1.1,0.9,3.6,1.8,5.8,0.2 c0.5-0.4,0.2-1.2-0.1-1.5c-0.5-0.6-2.3-0.8-3-1.2c-2.2-1-2.7-3.6-2.9-4.1c-0.2-0.4-0.7-1.1-0.7-1.1S141.1,89.1,139.4,90.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M144.5,95.6c0,0,0,0.1,0.1,0.1c0.1,0,0.1,0,0.1,0c0.2-0.4,0.4-0.7,0.6-0.8c0.2-0.2,0.5-0.2,0.8-0.2 c0.1,0,0.1,0,0.1-0.1c0-0.1-0.1-0.1-0.1-0.1c-0.3,0-0.7,0-0.9,0.2C144.9,94.9,144.7,95.2,144.5,95.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M144,95.2c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0c0.2-0.3,0.3-0.6,0.6-0.7c0.2-0.1,0.4-0.2,0.7-0.2 c0,0,0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1c-0.3,0-0.6,0-0.8,0.2C144.4,94.6,144.2,94.9,144,95.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M143.6,94.8c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0c0.2-0.3,0.3-0.6,0.6-0.7c0.2-0.1,0.4-0.2,0.7-0.2 c0,0,0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1c-0.3,0-0.6,0-0.8,0.2C143.9,94.2,143.7,94.4,143.6,94.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M143.1,94.4c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0c0.2-0.3,0.3-0.6,0.6-0.7c0.2-0.1,0.4-0.2,0.7-0.2 c0,0,0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1c-0.3,0-0.6,0-0.8,0.2C143.5,93.8,143.2,94,143.1,94.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M142.6,94c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0c0.2-0.3,0.3-0.6,0.6-0.7c0.2-0.1,0.4-0.2,0.7-0.2 c0,0,0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1c-0.3,0-0.6,0-0.8,0.2C143,93.4,142.8,93.6,142.6,94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M142.1,93.6c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0c0.2-0.3,0.3-0.6,0.6-0.7c0.2-0.1,0.4-0.2,0.7-0.2 c0,0,0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1c-0.3,0-0.6,0-0.8,0.2C142.5,92.9,142.3,93.2,142.1,93.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M141.7,93.1c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0c0.2-0.3,0.3-0.6,0.6-0.7c0.2-0.1,0.4-0.2,0.7-0.2 c0,0,0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1c-0.3,0-0.6,0-0.8,0.2C142,92.5,141.8,92.8,141.7,93.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M118.7,88.3c0,0-0.8,3.6-1.9,2.4c-0.5-0.5-0.9,0.8-1,1.3c0,0.5,1.4,2.4,1.8,2.5c0.4,0.2,0.7,0.1,0.9,0.6 c0.2,0.5-0.1,0.9,0.3,1.6c0.3,0.6,2,2.6,4.5,2.6c1.1,0,1.6-0.1,1.7-1.1c0-0.3-1.8-2.6-2.3-3.3c-1.3-1.6-1.3-3.8-1.2-4.2 c0-0.5,0.1-2,0.1-2C121.3,88.6,120.7,88,118.7,88.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M118.7,88.3c-0.8,0.5-2,1.4-2.4,2.9c0,0.5,1.2,2.4,1.6,2.6c0.9,0.4,0.8,1.4,1.2,2.1c0.6,1.3,2.5,3.1,5.2,2.6 c0.6-0.2,0.7-1,0.5-1.4c-0.2-0.7-1.7-1.7-2.2-2.3c-1.6-1.8-1-4.4-1-4.9c0-0.5-0.2-1.3-0.2-1.3C121.3,88.6,120.7,88,118.7,88.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M121.1,95.3c0,0,0,0.1,0,0.1c0,0,0.1,0.1,0.1,0c0.3-0.3,0.6-0.4,0.9-0.5c0.3,0,0.6,0,0.8,0.2 c0,0,0.1,0,0.1,0c0-0.1,0-0.1-0.1-0.1c-0.3-0.2-0.6-0.2-0.9-0.2C121.8,94.9,121.5,95,121.1,95.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M120.9,94.8c0,0,0,0.1,0,0.1c0,0,0.1,0.1,0.1,0c0.3-0.2,0.5-0.4,0.8-0.4c0.2,0,0.5,0,0.7,0.2 c0,0,0.1,0,0.1,0c0,0,0-0.1,0-0.1c-0.3-0.1-0.5-0.2-0.8-0.2C121.4,94.4,121.2,94.5,120.9,94.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M120.6,94.2c0,0,0,0.1,0,0.1c0,0,0.1,0.1,0.1,0c0.3-0.2,0.5-0.4,0.8-0.4c0.2,0,0.5,0,0.7,0.2 c0,0,0.1,0,0.1,0c0,0,0-0.1,0-0.1c-0.3-0.1-0.5-0.2-0.8-0.2C121.2,93.8,120.9,93.9,120.6,94.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M120.3,93.6c0,0,0,0.1,0,0.1c0,0,0.1,0.1,0.1,0c0.3-0.2,0.5-0.4,0.8-0.4c0.2,0,0.5,0,0.7,0.1 c0,0,0.1,0,0.1,0c0,0,0-0.1,0-0.1c-0.3-0.1-0.5-0.2-0.8-0.2C120.9,93.2,120.6,93.4,120.3,93.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M120.1,93.1c0,0,0,0.1,0,0.1c0,0,0.1,0.1,0.1,0c0.3-0.2,0.5-0.4,0.8-0.4c0.2,0,0.5,0,0.7,0.2 c0,0,0.1,0,0.1,0c0,0,0-0.1,0-0.1c-0.3-0.1-0.5-0.2-0.8-0.2C120.7,92.6,120.4,92.8,120.1,93.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M119.8,92.5c0,0,0,0.1,0,0.1c0,0,0.1,0.1,0.1,0c0.3-0.2,0.5-0.4,0.8-0.4c0.2,0,0.5,0,0.7,0.2 c0,0,0.1,0,0.1,0c0,0,0-0.1,0-0.1c-0.3-0.1-0.5-0.2-0.8-0.2C120.4,92.1,120.1,92.2,119.8,92.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M119.6,91.9c0,0,0,0.1,0,0.1c0,0,0.1,0.1,0.1,0c0.3-0.2,0.5-0.4,0.8-0.4c0.2,0,0.5,0,0.7,0.2 c0,0,0.1,0,0.1,0c0,0,0-0.1,0-0.1c-0.3-0.1-0.5-0.2-0.8-0.2C120.1,91.5,119.9,91.6,119.6,91.9z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M132.3,58c0.8,2.4,0.4,4.2,1,6.6c0.9,3,3.6,7.5,3.3,11.1c-0.6,6.5,1,10.8,0.9,16.5c1.7,1.3,6.9,0.3,6-1.8 c-0.5-6.8-0.1-14.9-0.3-17c0-0.3-0.2-2-0.2-3c0.1-5.9-1.3-17.5-1.9-19.6c0,0-2.1,1.3-6.3,2.2C134.7,53.8,132.2,57.7,132.3,58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M125.1,78.8c-2.3,1.9-5.6,6-8.5,10c-0.7,1.7,2.5,5.4,5.1,4c1.3-1.8,6.9-6.8,9.5-9.4c0.2-0.2,1.6-1.9,1.7-2.2 c1.9-6.3,3.9-8.5,4.6-19.4c3.5-0.5,1.7-5.7,1.9-10.3c-5.9,4-10.4,2.4-11.8,1.3c-2,3.1-1.3,9.1-0.2,9.9c-0.6,5.5-0.3,10.6-0.8,14.6 C125.7,79,125.9,78.2,125.1,78.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M127.4,53.3c2.1,1.9,11.1,2.5,13.9-1.5c0-0.5,0.1-1.3,0.1-1.8c-3.2,2.4-10.1,4.1-13.8,2 C127.6,52.4,127.5,52.9,127.4,53.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M128,30.6c-2.4-2.2-5.4,2.4-6.3,5.1c0,0.2-4,5.5-4.5,10.9c0.1,2.8,4.1,3,5.4,0.5c2.8-2.8,4.4-6.6,5.1-7.5 C129,38.1,130.9,32.5,128,30.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M129.9,52.8c2.6-3.4,3.2-9,2-15.6c4.3-0.4,8-2.5,10.5-5c-0.1,5.1,0.4,15-1.3,18.2 C139.8,52.7,133.7,54,129.9,52.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M125.6,30.4c2.4-0.8,5.4,1.8,7.3,10.1c1,0.3,2.1,0,3.1-0.3c-1.6-6.8-3.8-12.6-7.1-12.1 C127.6,28.7,126.6,29.5,125.6,30.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M134.7,48.5c0.4-3.3,0.5-6.5-0.3-9.8c2.7-0.6,5-1.6,6.7-3.4c-0.1,3.6,1,8.4-0.2,10.6 C138.8,47.3,136.7,48.2,134.7,48.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M131.3,77.9c0-2.8,0.3-5.7,1.3-8.5c-2.3-0.5-4-1.3-5.4-2.8c-0.7,3.6-1.8,8.3-0.5,9.2 C128.4,77,129.6,77.7,131.3,77.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M131.9,69.6c-2.4-0.8-3.7-1.6-4.9-2.7c-0.3,0.7-0.6,1.4-0.9,2.2c1.3,1.3,2.9,2.4,4.9,2.8 C131.5,71.2,131.8,70.4,131.9,69.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M136.2,55.5c0.2,4.4-0.4,8.2-1.1,11.6c-2.4,0.3-5-0.5-6.7-1.6c0.2-1.8,0.3-2.9,0.6-4.8c3.1-1.1,4-3.2,4.3-5.4 C134.2,55.6,135.3,55.6,136.2,55.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M134.8,39.1c2.9-1,4.6-1.9,6.1-3.3c0.4,0.9,0.7,1.8,1.1,2.7c-1.6,1.6-3.5,2.9-6.1,3.5 C135.4,41.1,135,40.2,134.8,39.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M127.5,69.6c0.1-0.1,0.1-0.4-0.1-0.7c-0.2-0.2-0.5-0.3-0.6-0.2c-0.1,0.1-0.1,0.4,0.1,0.7 C127.1,69.7,127.3,69.8,127.5,69.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M130.9,71.4c0.1-0.1,0.1-0.4-0.1-0.7c-0.2-0.2-0.5-0.3-0.6-0.2c-0.1,0.1-0.1,0.4,0.1,0.7 C130.5,71.5,130.8,71.6,130.9,71.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M140.3,38.9c-0.1-0.1-0.1-0.4,0.1-0.7c0.2-0.2,0.5-0.3,0.6-0.2c0.1,0.1,0.1,0.4-0.1,0.7 C140.7,39,140.4,39,140.3,38.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M136.4,41.1c-0.1-0.1-0.1-0.4,0.1-0.7c0.2-0.2,0.5-0.3,0.6-0.2c0.1,0.1,0.1,0.4-0.1,0.7 C136.8,41.2,136.5,41.3,136.4,41.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M132.1,22.2c0,1.5-0.5,3.2-0.5,4.7c0,1.2,2,2.2,2.6,2.6c2.9,1.7,3.8-0.2,3.6-1.6c-0.1-0.7-0.3-1.5-0.5-2.1 c-0.3-0.7-1.7-0.6-1.7-1.4L132.1,22.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M117.7,45.4c-1.5,1.8-0.5,11.1,0.5,14c1,0.9,4.4,0.7,4.4-0.5c0.2-1.2-0.1-8.5,0-11.9 C122.1,44.8,119.6,44.6,117.7,45.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M158.6,24.5l0.4,1.8c0.1,0.5,0.8,0.4,0.7-0.2l-0.2-1.8C159.4,23.7,158.5,23.9,158.6,24.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M159.5,24.8l0.4,2c0.1,0.6,0.8,0.4,0.8-0.2l-0.3-2C160.3,24,159.3,24.2,159.5,24.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M160.5,25.4l0.4,1.7c0.1,0.5,0.7,0.3,0.6-0.2l-0.2-1.7C161.2,24.7,160.4,24.8,160.5,25.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M161.7,26.3l-0.1,1.4c0,0.4,0.5,0.4,0.6,0l0.2-1.4C162.4,25.9,161.7,25.9,161.7,26.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M140.6,15.7c0,0.9,0.3,1.7,0.6,2.5c0.4,1-0.8,1.3,0.1,2.6c0.2,1,0,2.6-0.3,3.5c-0.1,0.7-0.2,1.8-1.3,2.5 c-1.7,1.2-3.5-0.4-5.3-0.9c-1.7-0.5-1.1-2.7-1.6-4.1c-1.1-2.5-1.1-6,1.7-7.2c1.2-0.5,3.3-0.9,4.6-0.4 C139.6,14.5,140.6,14.8,140.6,15.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M130.2,20.8l0.1,0.1C130.2,20.9,130.2,20.8,130.2,20.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M135,19.8c-0.5,0.3-0.6,0.3-0.7,0.9c-0.1,0.5,0,2,1,3.4c0,0.1-1.2-1.1-1.8-1.4c-1.4-1.4-0.8,2.2-2.1,3.3 c-0.1,0-1-0.3-1.1-0.5c1.8-2.7-2.1-7.8,0.1-10.6c3.2,0.1,4.3,0.1,5.5,1.8C136.2,17.7,135.6,19.5,135,19.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M135.7,12.6c4.5,0.6,5.3,3.2,5.2,5c0,0.8-2.2,0-5-0.4c-1-1.4-2.4-1.8-5.6-2.1 C131.1,12.4,134.5,12.5,135.7,12.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M137.8,23.9l0,0.1C137.8,23.9,137.8,23.9,137.8,23.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M131.7,22c0.4,0.9,1,1.5,1.4,1.3c0.4-0.2,0.5-1.1,0.1-2c-0.4-0.9-1.1-1.4-1.5-1.3 C131.3,20.2,131.3,21.1,131.7,22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M141.5,23.5c-0.2-0.3-0.6-0.5-1.2-0.4c-0.7,0.2-2,0.5-2.8,1.9c-0.4,0.8,0.1,1.7-0.1,1.9l0.3,0.1 c0.5-2.2,2.1-2.1,2.5-2.8c0.2,0.4,0.9,0,0.7,1.3C141.1,25.1,141.8,24.1,141.5,23.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M130.2,16.3c1.4-0.4,3.7-0.8,4.6-0.6c-2.1,0.7-1.9,2.2-2.9,2.9c-1.3,0.9-4.8,1.6-4.9,0.9 C126.7,17.7,128.8,16.7,130.2,16.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M141,17.7c-1.8,1.8-7.7,2.1-11.3,1c-1-4.9,2.4-6.2,5.7-6.3C139,12.4,141.8,14.8,141,17.7z"
  }))), /*#__PURE__*/React.createElement("g", null, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M97.7,155.8c-8.3,5.1-25.3-8-26.9-15.5c-3.3-15.9,22-28.4,35.8-22.2c6.4,2.9,14.6,11.8,21.3,13.5 C117.1,137.3,108.5,150.1,97.7,155.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "M97.7,155.8c-2.8,1.7-6.1,1.2-9.5-0.6c-2-2.6-3.3-5.3-3.8-7.3c-3.3-15.9,18.9-26.5,32.7-20.3 c2.6,1.2,5.4,3.3,8.4,5.5C115.8,139.2,107.7,150.6,97.7,155.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M101.6,155.3c-3.3-1.5-13.4-4.1-15-9.9c-3.7-13.5,15.7-20.6,26.5-17.8c6.6,1.8,9.3,6.1,16,7.6 C118.2,140.1,112.4,150.4,101.6,155.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M110.8,128.5c-6.5-1.6-19,4-20.8,9.6c-1.7,6.4,4.7,6.9,7.5,10.2c1.3,1.5,2,3.9,2,6.2 c-4.3-1.6-11.6-4.2-13-9.1c-3.7-13.5,15.7-20.6,26.5-17.8c1.5,0.4,2.8,0.9,4,1.5C115,129.2,112.3,128.5,110.8,128.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M89.8,139.4c-0.6,5.2,5.1,5.8,7.7,8.9c0.8,1,1.4,2.3,1.8,3.8c-4.6-1.6-11.6-4.1-13.1-8.6 c-0.8-7.4,5.6-12.6,13-15c-4.5,1.9-8.3,4.7-9.3,7.5C89.4,137.3,89.4,138.4,89.8,139.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M146.4,145.2c2.4,3,13.2-2.4,20.7-3.7c3.7,1.4,12.6-2.7,16.7-6.7c2.1-2.1,3.3-7.5,0.1-8.1 c-5.7-1-11.4,2-17.7,4c-0.6,0.2-1.1,0.5-1.6,0.8c-7.8,0.3-23.4-1.9-29.2-1C129.4,131.3,144.7,140.6,146.4,145.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M185.8,129.8c-1.9,3.1-5.4,5.4-8.9,6.4c-2.3,0.6-9.8,2.7-10.9-0.5c-0.5,1.7-1,2.7-2.1,3.4 c-1,0.6-3.3,0.7-4.9,0.7c-1.3,0-4.5-0.4-5.3,0.1c1.9,1.6,3.6,2.8,5.4,3.7c2.7-0.8,5.4-1.7,7.8-2.1c3.7,1.4,12.6-2.7,16.7-6.7 C184.8,133.6,185.7,131.6,185.8,129.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M95.3,155.2c-3.6-5.9,6.8-17.2,17.8-15.7c2.3-4.9,19.4-10.3,25.8-8.8c8.5,2,13.8,8.7,20.6,14.1 c6.4,5.1,15.6,6.5,16.2,11.4c-9.8,20.4-28.3,28.7-41,25.2C119.4,172.7,103.6,168.9,95.3,155.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M174.5,153.8c0.6,0.7,1.1,1.5,1.2,2.4c-9.8,20.4-28.3,28.7-41,25.2c-15.2-8.7-31-12.5-39.3-26.2 c-1.7-2.8-0.3-6.8,2.9-10.1c-1,3.2,4,6.1,9.3,11.1c7.7,7.4,11.9,17.5,25.6,16.8c6.8-0.3,16.8-5.7,22.5-9.6 C158.9,161.1,172.6,151.4,174.5,153.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M207.5,176.3c0.3,0.1,0.7,0.1,1,0.2l0.2,0l0,0c4.7,0.6,13.2-0.7,14.1-1.7c1.6-1.7-0.2-4.5-2.3-5.6 c-4.5-2.3-9.9-2.7-13-1.5c-4.1-2.1-11.1-3.3-13.5-2.8l-0.1,0c-2.7-3.1-14.1-9.3-20.1-10c-3.3-0.3-7.4,3.4-5.2,6.9 c0.3,4.6,14.5,8.3,21.7,12.4c0.1-0.1,0.2-0.1,0.2-0.2C194.5,175.5,202.2,175.4,207.5,176.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M223,171.6c-0.7,3.5-18.8,3.2-18.1,0.6c-3.6,1.7-15.4,1.3-16.6-3.9c-6.5,1.1-16.2-5.8-20.1-7.5 c0.1,0.3,0.3,0.7,0.5,1c0.3,4.6,14.5,8.3,21.7,12.4c0.1-0.1,0.2-0.1,0.2-0.2c3.8,1.5,11.5,1.3,16.9,2.2c0.3,0.1,0.7,0.1,1,0.2 l0.2,0l0,0c4.7,0.6,13.2-0.7,14.1-1.7C223.6,173.9,223.6,172.7,223,171.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M222.4,174.5c0.5-0.6,0.5-1.4,0.3-2.1c-1.8-4.7-11-5.6-14.9-4.1c-4.9-2.1-7.1-3.3-12-3.1v-0.8 c3.9,0.2,8.7,1.2,11.9,2.8c5.3-0.8,14.9,0.2,16.1,4.8c0.4,1.1,0.3,2.3-0.5,3.2c-2.1,2.2-11.4,2.1-14.3,1.9l-0.4,0 c-0.2,0-0.5-0.1-0.7-0.1c-0.2,0-0.3-0.1-0.5-0.1c-2-0.3-4.3-0.5-6.7-0.7c-1.7-0.1-3.4-0.3-5-0.4v-1.1c1.6,0.2,3.3,0.3,5.1,0.5 c2.4,0.2,4.7,0.4,6.8,0.7C211.5,176.4,218.9,176.8,222.4,174.5z M195.7,165.2c-0.7,0-1.4,0.1-2.2,0.1c-1.4-1.6-5.3-4.1-9.5-6.2 c-3.6-1.8-7.5-3.3-10.2-3.6c-1-0.1-2.1,0.2-3,0.8c-0.6,0.4-1.1,0.9-1.5,1.4c-0.4,0.5-0.6,1.1-0.7,1.7c-0.1,0.7,0.1,1.4,0.5,2.1 l0.1,0.1l0,0.1c0.2,2.7,6.4,5.3,12.6,7.9c3.1,1.3,6.1,2.6,8.5,3.9l0.2-0.1l0.3,0.1c1.3,0.5,3,0.8,4.9,1v1.1c-1.9-0.2-3.7-0.5-5-1 l0,0l-0.3,0.2l-0.3-0.2c-2.4-1.4-5.5-2.7-8.7-4c-6.4-2.7-12.9-5.4-13.3-8.7c-0.5-0.9-0.7-1.8-0.6-2.7c0.1-0.8,0.4-1.6,0.9-2.3 c0.5-0.7,1.1-1.2,1.8-1.7c1.1-0.7,2.5-1.1,3.7-1c2.8,0.3,6.8,1.8,10.6,3.7c4.1,2.1,8,4.5,9.6,6.2c0.5,0,1,0,1.6,0.1V165.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M201,186.5c4.3,1.8,15.8,1.7,17.5,0.3c2-1.6,0.3-5.1-1.9-6.4c-4.8-3.1-7.9-2.7-13.6-2.8 c-0.4,0-0.8,0-1.2,0.1c-2.8-1.8-7.6-3.5-13.1-5c-0.3-0.1-0.6-0.1-0.9-0.2c-1.5-3.1-9.9-6.8-17.4-10.6c-6.8-3.4-10,0.7-11.6,6.6 c0.3,4.8,14.3,8.7,22.7,13C184.9,184,194.5,184.8,201,186.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M219,183.2c0.5,3.9-19.5,3.5-21.2-2.2c-7.8,2.2-16.1-2.1-16.6-5.2c-6.9,0.4-20-7.2-20.2-12.5 c-0.5,0.8-1,1.7-1.4,2.7c-0.4,1.6-0.2,3.2,0.6,4.8c3.7,3.7,14.4,7,21.3,10.5c3.3,2.6,12.9,3.4,19.4,5.1 c4.3,1.8,15.8,1.7,17.5,0.3C219.5,185.9,219.5,184.5,219,183.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M201.2,186c2,0.8,5.6,1.2,9,1.3c3.7,0.1,7.1-0.3,7.9-0.9c0.2-0.1,0.3-0.3,0.4-0.5c0.3-0.5,0.4-1.1,0.2-1.8 c-1.4-6-12.3-6.7-16.8-6c-3-2.6-7.4-4.5-12.8-5.1v-0.9c4.3,1,9.1,2.6,12.8,4.9c4.7-0.1,15.5,1.1,17.8,6.8 c0.2,0.9,0.1,1.8-0.3,2.6c-0.2,0.3-0.4,0.5-0.6,0.7c-1,0.8-4.7,1.2-8.6,1.2c-3.5-0.1-7.3-0.5-9.4-1.3c-2.1-0.5-4.6-1-7-1.5 c-1.6-0.3-3.1-0.6-4.6-0.9v-1.1c1.5,0.3,3.2,0.6,4.8,0.9C196.4,184.9,198.9,185.4,201.2,186L201.2,186L201.2,186z M189.1,173 c-0.5-0.1-1.1-0.1-1.7-0.2c-2.1-4.5-10.4-7.6-13.6-8.8c-1.2-0.6-2.4-1.2-3.6-1.8c-3.2-1.6-5.5-1.5-7.2-0.2 c-1.7,1.2-2.9,3.6-3.6,6.4c0.3,3.1,7.2,5.9,14.1,8.8c2.9,1.2,5.8,2.4,8.3,3.7l0,0l0,0c1.4,1.1,4.1,1.9,7.2,2.6v1.1 c-3.3-0.7-6.2-1.5-7.8-2.8c-2.4-1.2-5.3-2.4-8.1-3.6c-7.3-3-14.5-6-14.8-9.8l0-0.1l0-0.1c0.8-3.1,2.1-5.7,4-7.1 c2-1.5,4.7-1.7,8.3,0.1c1.2,0.6,2.4,1.2,3.6,1.8c6.2,3.1,12.3,6.1,13.9,8.8c0.1,0,0.1,0,0.2,0c0.2,0.1,0.5,0.1,0.7,0.2V173z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M159.9,142.5c2.2-1.4,4.7-3.8,6.7-2.4c1.6,0.6,4.4,0.8,7.9-0.2c4.1-1.3,9.8-4.6,10.6-9.3 c0.2-1.2,0.3-3.6-1.3-3.9c-5.7-1-13.2,2.3-19,5.3l-0.1,0.1l-0.2,0c-1.4,0-3,0-4.7,0v-1.1c1.7,0.1,3.2,0.1,4.5,0 c0.2-0.1,0.4-0.3,0.7-0.4c5.1-2.4,13.1-5.4,18.8-4.4c1.7,0.3,2.3,1.8,2.4,3.3v0.3c0,0.3,0,0.7-0.1,1c-0.3,1.6-1.1,3.4-2.1,4.4 c-2.2,2.2-5.7,4.4-9.1,5.7c-3.1,1.2-6.1,1.8-8,1.2c-2.2,0.4-4.6,1.1-7.1,1.9V142.5z M146.9,144.9c1.4,1.6,6.3,0,11.5-1.6 c0.5-0.2,1-0.5,1.6-0.8v1.5c-0.4,0.1-0.9,0.3-1.3,0.4c-5.6,1.8-10.9,3.4-12.7,1.2l-0.1-0.1l0-0.1c-0.7-1.7-3.6-4.4-6.4-6.9 c-2.9-2.6-5.7-5.1-6-6.7c-0.1-1,0.4-1.6,1.8-1.8c3.2-0.5,9.4,0,15.6,0.4c3.1,0.2,6.3,0.4,9,0.6v1.1c-2.8-0.1-6-0.3-9.1-0.6 c-6.1-0.4-12.2-0.9-15.3-0.4c-0.7,0.1-1,0.3-0.9,0.6c0.2,1.2,2.8,3.6,5.6,6.1C143.1,140.2,146,142.9,146.9,144.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M149.1,172.6c-1.2,5.8,12.8,8.5,20.3,12.6c3.5,2.9,11,3.3,16.7,4.9c3.6,1.8,13.5,2.1,15.7,0.8 c2-1.2,0.5-4.5-1.5-5.8c-4.2-2.9-6.2-2.3-11.3-2.6l0,0c-2.8-2.3-8.9-4.4-12.4-4.9l0,0c-1.7-3.3-14.2-10.9-18.1-11.4 c-1.7-0.2-5,0.4-7.2,2.5C150.2,169.7,149.4,171,149.1,172.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M149.9,170.5c3.2,1.2,6.2,4.3,9.8,5.9c1.6,0.7,9.4,4.2,10.4,3.6c2.5,2,6.4,3.8,9.3,4.6 c0.8,0.2,7.6,1.4,7,0.9c2.4,1.5,6.5,3.2,9.4,3.2c1.3,0,2.8,0.1,4.1,0.1c0.5,0,2-0.6,2.4-0.8c0.5,1.2,0.4,2.5-0.7,3.1 c-2.2,1.3-12.1,0.9-15.7-0.8c-5.6-1.6-13.2-2-16.7-4.9c-7.4-4.1-21.4-6.8-20.3-12.6C149.3,171.8,149.5,171.1,149.9,170.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M175.9,187.4c1.4,0.3,2.9,0.6,4.4,0.9c2,0.4,4.1,0.8,5.9,1.3l0,0l0,0c3.1,1.5,12.1,2.7,15.2,0.9 c0.2-0.1,0.3-0.2,0.4-0.4c0.2-0.3,0.3-0.7,0.2-1.2c-0.3-6.1-8.4-6.4-13.1-5.9l0,0l0,0h-0.2l-0.2-0.1c-2.4-2.9-7.1-4.8-12.2-4.8 l-0.3,0l-0.1-0.3c-0.1-0.1-0.1-0.2-0.2-0.4v-1.4c0.4,0.3,0.7,0.7,1,1c4,0.7,9.1,2.3,12.3,4.9c0.9,0.1,1.7,0.1,2.4,0.1 c4,0.1,8.7,1,10.9,4.7c0.4,0.6,0.6,1.3,0.7,2c0.1,0.7,0,1.4-0.4,2c-0.2,0.3-0.4,0.5-0.8,0.7c-4.2,1.4-13.4,0.3-16.2-0.8 c-1.8-0.5-3.8-0.9-5.8-1.3c-1.4-0.3-2.8-0.6-4.2-0.9V187.4z M149.6,172.7c-0.7,3.6,5.6,6.1,12,8.5c2.9,1.1,5.7,2.2,8,3.5l0,0l0,0 c1.4,1.2,3.7,2,6.2,2.6v1.1c-2.7-0.6-5.2-1.5-6.8-2.8c-2.2-1.2-5-2.3-7.8-3.4c-6-2.3-11.9-4.6-12.7-8.2v-1.5l0,0 c0.2-0.9,0.5-1.6,0.8-2.3c0.4-0.7,0.9-1.4,1.5-1.9c1-1,2.3-1.7,3.5-2.1c1.6-0.5,3.1-0.7,4.1-0.5c3.8,0.5,12.6,6,17.3,10.4v1.4 c-2.5-4.1-13.2-10.2-17.5-10.8c-0.9-0.1-2.3,0-3.6,0.5c-1.1,0.4-2.2,1-3.1,1.8c-0.5,0.5-0.9,1-1.3,1.6 C150,171.3,149.8,172,149.6,172.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M136.5,179.7c0.3,4.4,13.6,8,21,12l0,0.1c2.6,2.8,13.6-2.2,20.4-3.3c0,0,0-0.1,0-0.1 c3.6-1,9.6-5.6,12.4-8.9c1.5-1.8-2.4-3.8-4.7-3.7c-4.8,0.3-8.5,2.2-9.7,4.4c-2.7-0.7-7.1-0.1-13,1.1l0,0 c-2.5-3.2-10.8-7.2-14.9-8.1C141.5,171.7,137.9,174.4,136.5,179.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M163.1,181.7c-2.6,0-3.6,0.7-6,2.6c1.7-2.7,3.4-3.6,6-3.6L163.1,181.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M176.4,180.4c-0.4,0.5-0.7,1.2-0.9,2c-0.2,0.7-0.3,1.5-0.4,2.2c-0.9-2.3-0.5-3.5,0.4-4.8L176.4,180.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M190.6,178c-13.1,10.3-15.7,6-16,6.5c-3.3,2.5-10.3,4.6-14.5,3.6c-0.9-0.2-3.9-2.7-2.5-3 c-2.5,2.3-10.9-0.4-14.1-2c-1.7-0.9-4.8-3.7-6.2-5.8c-0.4,0.7-0.6,1.5-0.9,2.4c0.3,4.4,13.6,8,21,12l0,0.1 c2.6,2.8,13.6-2.2,20.4-3.3c0,0,0-0.1,0-0.1c3.6-1,9.6-5.6,12.4-8.9C190.8,179,190.8,178.5,190.6,178z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M157.8,191.2c1.4,1.4,4.2,1.2,7,0.1c5.6-0.4,8.6-2.6,12.8-3.4l0-0.1l0.3-0.1c1.6-0.5,3.8-1.7,5.9-3.2 c2.4-1.7,4.7-3.8,6.2-5.5c0.1-0.1,0.2-0.3,0.2-0.4c0-0.2,0.2-1,0-1.3c-2.9-3.3-11.6-0.7-13.7,2.9l-0.2,0.4l-0.4-0.1 c-3.9-1-8.9,0.3-12.7,1.1l-0.1,0h0l0,0h-0.3l-0.2-0.2c-3.9-5-15.3-9.9-21.3-8.7c0.9-0.4,2-0.6,3.2-0.6c1.1,0,2.4,0.1,3.8,0.4v0 c4.8,1.1,11.7,4.2,15,8c3.9-0.8,8.6-1.9,12.5-1.1c0.7-1.1,2-2.1,3.7-2.9c1.7-0.8,3.8-1.3,6.2-1.4c1.1-0.1,2.4,0.3,3.5,0.9 c0.6,0.3,1.2,0.7,1.6,1.2c0.4,0.5,0.7,1.1,0.6,1.7c-0.1,0.3-0.2,0.6-0.4,0.9c-1.5,1.7-3.9,3.9-6.4,5.7c-2.1,1.5-4.3,2.8-6,3.3 L178,189c-2.2,0.4-5,1.2-7.7,1.9c-5.6,1.6-11.3,3.3-13.2,1.2c-3.2-3.5-19-4.8-21-11.3v-3c0-0.1,0-0.1,0-0.2 C137,185.3,151.7,188,157.8,191.2L157.8,191.2z M163,181.2L163,181.2L163,181.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M189.8,182.6c-2.5,1.1-3.1,2.3-3.6,3.7c0.2-2.3,0.4-3,2-3.8L189.8,182.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M201.9,178c-0.7,0.5-1.3,1.2-1.8,2c-0.6,0.7-1.1,1.5-1.5,2.2c0.2-2.3,1.2-3.5,2.7-4.8L201.9,178z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M188.3,172.5c-1.6,0.7-3.2,0.5-5.1,3c0.5-2.5,2.5-3.1,4-3.5L188.3,172.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M207.9,167.8c-0.7,0.5-1.3,1.2-1.8,2c-0.6,0.7-1.1,1.5-1.5,2.2c0.2-2.3,1.2-3.5,2.7-4.8L207.9,167.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M194.1,165.1c-1.4-0.1-4.2,3.2-4.2,3.3c0.2-2.3,1.7-3.7,3.2-4.2L194.1,165.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M136.9,182.4c-0.8-0.1-1.6-0.3-2.4-0.5l-0.1,0l-0.1,0c-13.6-7.7-30.9-12.2-39.5-26.4 c-2.7-4.4,1.6-10,5-12.6c-1.7,3.7-5.8,8-2.9,12.7c8.4,13.9,24.6,17.6,37.9,25.2c0.7,0.2,0.6-0.5,1.3-0.3L136.9,182.4z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M163.4,155.4c0.2,0,0.4,0,0.6-0.1l5-2.9c0.5-0.3,0.7-1,0.4-1.5c-0.3-0.5-1-0.7-1.5-0.4l-5,2.9 c-0.5,0.3-0.7,1-0.4,1.5C162.7,155.2,163,155.4,163.4,155.4z"
  }))), /*#__PURE__*/React.createElement("g", null, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M153.9,148.5l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C153.4,148.9,153.6,148.6,153.9,148.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M154,148.2l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C153.5,148.6,153.7,148.3,154,148.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M154.1,147.9l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C153.5,148.4,153.8,148.1,154.1,147.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M154.2,147.7l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C153.6,148.1,153.9,147.8,154.2,147.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M154.3,147.4l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C153.7,147.8,153.9,147.5,154.3,147.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M154.4,147.1l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C153.8,147.6,154,147.3,154.4,147.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M154.5,146.9l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C153.9,147.3,154.1,147,154.5,146.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M154.5,146.6l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C154,147,154.2,146.7,154.5,146.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M154.6,146.3l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C154.1,146.7,154.3,146.4,154.6,146.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M154.7,146l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C154.1,146.5,154.4,146.2,154.7,146z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M154.8,145.8l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C154.2,146.2,154.5,145.9,154.8,145.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M154.9,145.5l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C154.3,145.9,154.5,145.6,154.9,145.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M155,145.2l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C154.4,145.7,154.6,145.4,155,145.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M155.1,145l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C154.5,145.4,154.7,145.1,155.1,145z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M155.1,144.7l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C154.6,145.1,154.8,144.8,155.1,144.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M155.2,144.4l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C154.7,144.8,154.9,144.5,155.2,144.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M155.3,144.1l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C154.8,144.6,155,144.3,155.3,144.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M155.4,143.9l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C154.8,144.3,155.1,144,155.4,143.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M155.5,143.6l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C154.9,144,155.2,143.7,155.5,143.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M155.6,143.3l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C155,143.8,155.2,143.5,155.6,143.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M155.7,143.1l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C155.1,143.5,155.3,143.2,155.7,143.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M155.7,142.8l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C155.2,143.2,155.4,142.9,155.7,142.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M155.8,142.5l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C155.3,142.9,155.5,142.6,155.8,142.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M155.9,142.2l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C155.4,142.7,155.6,142.4,155.9,142.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M156,142l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C155.4,142.4,155.7,142.1,156,142z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M156.1,141.7l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C155.5,142.1,155.8,141.8,156.1,141.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M156.2,141.4l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0L156,143c-0.3-0.1-0.5-0.5-0.4-0.8C155.6,141.9,155.8,141.6,156.2,141.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M156.3,141.2l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C155.7,141.6,155.9,141.3,156.3,141.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M156.4,140.9l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C155.8,141.3,156,141,156.4,140.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M156.4,140.6l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C155.9,141,156.1,140.8,156.4,140.6z"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M162.6,149.7c-0.6-0.4-0.6-1.5,0.1-2.4c0.6-1,1.6-1.4,2.2-1.1c0.6,0.4,0.6,1.5-0.1,2.4 C164.2,149.6,163.2,150,162.6,149.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M163.3,149.8c-0.5-0.3-0.5-1.3,0.1-2.2c0.6-0.9,1.4-1.3,2-0.9c0.5,0.3,0.5,1.3-0.1,2.2 C164.7,149.7,163.8,150.2,163.3,149.8z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st70",
    d: "M165.2,156.7c0.6,0,1.2-0.2,1.7-0.6c1.3-1.1,1.7-3.3,1-5.9c-0.4-1.5-1.9-2.4-3.1-2.8 c-0.5-0.1-1,0-1.3,0.5c-0.3,0.5-0.2,1.2,0.4,1.5c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,1.3,0.4,1.5,1.2c0.6,2,0.2,3.2-0.2,3.5 c-0.3,0.3-1,0-1.3-0.2l-11.6-6.6c-0.5-0.3-1.2-0.1-1.5,0.4c-0.3,0.5-0.1,1.2,0.4,1.5l11.6,6.6 C163.8,156.5,164.5,156.7,165.2,156.7z"
  }))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M116.6,124.8c1.7,0.6,0,2.6-1.9,2.9l-1,0.2c-0.1,0-0.8,0.4-0.9,0.4c-1.7-0.2,0-4.4,1.7-4.2 c0.1,0,0.1,0,0.2,0.1L116.6,124.8z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st51",
    points: "153.4,162.1 138.5,153.2 134.9,141.1 163.4,156.5  "
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M153.4,162.1V158c3.5-1.8,7-3.7,10.5-5.5l-0.5,4L153.4,162.1z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M136.7,137.1c-1.8,0.7-3.2,0.7-2.5,3.3c0.7,2.5,0.9,5.3,1.7,7.4c0.4,1.1,5.3,3.3,6.5,4 c3.5,1.9,2.3-5.6,2.3-8C144.7,139.8,140.2,135.7,136.7,137.1z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M153.4,149.5l-10.5,3.9l10.5,5.2c3.7-0.1,7.1-1.8,10.2-5.8L153.4,149.5z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M150.1,141.8c-0.5-0.3-3.4-1.8-4.3-2c-0.3-0.1-0.6-0.1-0.9,0l0,0l0,0c-0.2,0-0.3,0.1-0.4,0.2l-2.7,1 l2.5,12.7l2.8-1.1c0.1,0,0.2-0.1,0.3-0.1l0,0v0c0.3-0.1,0.5-0.3,0.5-0.5l2.6-7.4C151,143.2,150.7,142.2,150.1,141.8z"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M146.8,151.7l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C146.2,152.1,146.4,151.8,146.8,151.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M146.8,151.4l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C146.3,151.8,146.5,151.6,146.8,151.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M146.9,151.2l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C146.4,151.6,146.6,151.3,146.9,151.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M147,150.9l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C146.4,151.3,146.7,151,147,150.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M147.1,150.6l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C146.5,151,146.8,150.7,147.1,150.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M147.2,150.3l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C146.6,150.8,146.8,150.5,147.2,150.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M147.3,150.1l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C146.7,150.5,146.9,150.2,147.3,150.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M147.4,149.8l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C146.8,150.2,147,149.9,147.4,149.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M147.4,149.5l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C146.9,149.9,147.1,149.7,147.4,149.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M147.5,149.3l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C147,149.7,147.2,149.4,147.5,149.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M147.6,149l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C147.1,149.4,147.3,149.1,147.6,149z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M147.7,148.7l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C147.1,149.1,147.4,148.8,147.7,148.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M147.8,148.4l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C147.2,148.9,147.5,148.6,147.8,148.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M147.9,148.2l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C147.3,148.6,147.5,148.3,147.9,148.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M148,147.9l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C147.4,148.3,147.6,148,148,147.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M148,147.6l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C147.5,148.1,147.7,147.8,148,147.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M148.1,147.4l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C147.6,147.8,147.8,147.5,148.1,147.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M148.2,147.1l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C147.7,147.5,147.9,147.2,148.2,147.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M148.3,146.8l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C147.8,147.2,148,146.9,148.3,146.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M148.4,146.5l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C147.8,147,148.1,146.7,148.4,146.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M148.5,146.3l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C147.9,146.7,148.1,146.4,148.5,146.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M148.6,146l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C148,146.4,148.2,146.1,148.6,146z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M148.7,145.7l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C148.1,146.2,148.3,145.9,148.7,145.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M148.7,145.5l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C148.2,145.9,148.4,145.6,148.7,145.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M148.8,145.2l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C148.3,145.6,148.5,145.3,148.8,145.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M148.9,144.9l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C148.4,145.3,148.6,145,148.9,144.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M149,144.6l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C148.4,145.1,148.7,144.8,149,144.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M149.1,144.4l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C148.5,144.8,148.7,144.5,149.1,144.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M149.2,144.1l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C148.6,144.5,148.8,144.2,149.2,144.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M149.3,143.8l4.7-1.8c0.9-0.3,1.7-0.3,2.5,0.1l5.3,2.5c0.3,0.1,0.5,0.4,0.4,0.8c0,0.3-0.2,0.6-0.6,0.8 l-4.4,1.9c-0.9,0.4-1.8,0.4-2.6,0l-5.5-2.6c-0.3-0.1-0.5-0.5-0.4-0.8C148.7,144.3,148.9,144,149.3,143.8z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 771.0748,
    y1: 138.7287,
    x2: 772.8662,
    y2: 135.6258,
    gradientTransform: "matrix(-1 0 0 1 897.5085 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#706F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#706F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#C6C6C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C6C6C6"
    }
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M126.6,135.9l-2.4,1.4v1.5c1-0.6,2-1.2,3.1-1.8C127.6,136.6,127.2,135.9,126.6,135.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 770.0038,
    y1: 143.1572,
    x2: 775.8113,
    y2: 132.6802,
    gradientTransform: "matrix(-1 0 0 1 897.5085 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#706F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#706F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#C6C6C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C6C6C6"
    }
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st72",
    d: "M120.9,135.2L120.9,135.2L120.9,135.2L120.9,135.2L120.9,135.2z M126.2,141.9L126.2,141.9l-1.1,0.7 c1-0.6,1.2-2.5,0.3-4.4c-0.9-2.1-2.8-3.5-4.1-3.1c-0.1,0-0.2,0.1-0.2,0.1l1-0.6c0.1-0.1,0.2-0.1,0.2-0.1l0,0v0 c0.1,0,0.1,0,0.2-0.1c1.3-0.4,3.2,1,4.1,3.1c0.4,0.8,0.5,1.6,0.6,2.3v0.2C127.1,140.8,126.8,141.5,126.2,141.9z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M124.7,142.7c-1.3,0.4-3.2-1-4.1-3.1c-0.9-2.1-0.6-4.2,0.7-4.6c1.3-0.4,3.2,1,4.1,3.1 C126.3,140.2,126,142.3,124.7,142.7z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M122.7,143.7c-1.3-1.1-2.5-2.7-3.4-4.6c-1.3-2.9-1.4-5.7-0.5-7.4c1.3,0.2,2.6,0.9,3.9,2V130 c-2.2-1.6-4.6-2.3-6.6-1.7c-4,1.3-5,7.5-2.1,14c2,4.5,5.4,7.9,8.6,9.1V143.7z M128.7,137.7c-1.5-3.3-3.7-6-6-7.7v3.7 c1.3,1.2,2.5,2.8,3.3,4.6c1.1,2.5,1.4,5,0.9,6.9c-1.3,0.2-2.8-0.4-4.2-1.6v7.7c1.4,0.5,2.7,0.6,3.9,0.3 C130.7,150.4,131.6,144.1,128.7,137.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 789.5379,
    y1: 114.0804,
    x2: 755.0918,
    y2: 187.9503,
    gradientTransform: "matrix(-1 0 0 1 897.5085 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#706F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C6C6C6"
    }
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st73",
    d: "M120.1,146.9v-6.4c-0.3-0.4-0.5-0.9-0.7-1.4c-1.3-2.9-1.4-5.7-0.5-7.4c-0.5-0.1-1.1,0-1.6,0.1 c-2.8,0.9-3.5,5.2-1.4,9.7C116.9,143.8,118.4,145.7,120.1,146.9L120.1,146.9z M120.1,131.9l-1.2-0.2 C121.6,132.1,122,132.1,120.1,131.9z M127,145.2c-2.2,0.3-5-1.6-6.9-4.7v6.4c1.5,1.1,3.1,1.6,4.5,1.1 C125.8,147.7,126.6,146.6,127,145.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 782.7635,
    y1: 127.601,
    x2: 771.6223,
    y2: 151.4933,
    gradientTransform: "matrix(-1 0 0 1 897.5085 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#706F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#706F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#C6C6C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C6C6C6"
    }
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st74",
    d: "M125.1,147.1c-2.6,0.8-6.2-1.9-8.1-6c-1.9-4.1-1.3-8.5,1.8-9.4c-1.1,2.3-0.5,5.2,0.5,7.4 c1.8,3.9,5.1,6.5,7.6,6.1c-0.1,0.2-0.1,0.4-0.2,0.6C126.3,146.5,125.8,146.9,125.1,147.1z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M115,128.8L115,128.8L115,128.8L115,128.8L115,128.8z M131.2,149.1L131.2,149.1l-3.5,2 c3.1-2,3.6-7.6,1-13.4c-2.9-6.4-8.5-10.7-12.6-9.4c-0.3,0.1-0.5,0.2-0.7,0.3l3.1-1.8c0.2-0.2,0.5-0.3,0.7-0.4l0,0l0,0 c0.2-0.1,0.4-0.1,0.5-0.2c4-1.3,9.7,2.9,12.6,9.4c1,2.3,1.6,4.5,1.7,6.5v1.4C133.9,146.1,133,148.1,131.2,149.1z"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M124.4,147.3C124.4,147.3,124.4,147.3,124.4,147.3c0.1,0,0.1-0.1,0.1-0.1L120,132c0,0-0.1-0.1-0.1-0.1 c0,0-0.1,0.1-0.1,0.1L124.4,147.3C124.3,147.3,124.4,147.3,124.4,147.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M122.6,147C122.6,147,122.6,147,122.6,147C122.7,147,122.7,147,122.6,147l-0.8-14.1c0,0,0-0.1-0.1-0.1 c0,0,0,0,0,0c0,0-0.1,0-0.1,0.1L122.6,147C122.5,147,122.6,147,122.6,147z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M120.8,146C120.8,146,120.9,146,120.8,146l2.6-11.7c0,0,0-0.1-0.1-0.1c0,0-0.1,0-0.1,0.1l-2.5,11.6 C120.7,146,120.7,146,120.8,146C120.8,146,120.8,146,120.8,146z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M119.2,144.5C119.2,144.5,119.2,144.5,119.2,144.5l5.4-8.7c0,0,0-0.1,0-0.1c0,0-0.1,0-0.1,0l-5.4,8.6 C119.1,144.4,119.1,144.5,119.2,144.5C119.2,144.5,119.2,144.5,119.2,144.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M117.8,142.6C117.8,142.6,117.8,142.6,117.8,142.6l7.8-5.1c0,0,0-0.1,0-0.1c0,0-0.1,0-0.1,0l-7.7,5.1 C117.7,142.5,117.7,142.5,117.8,142.6C117.7,142.6,117.8,142.6,117.8,142.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M116.7,140.4C116.7,140.4,116.7,140.4,116.7,140.4l9.6-1.2c0,0,0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1 c0,0,0,0,0,0l-9.6,1.2C116.7,140.2,116.6,140.3,116.7,140.4C116.6,140.3,116.7,140.4,116.7,140.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M126.9,141.1C126.9,141.1,127,141.1,126.9,141.1c0.1-0.1,0.1-0.2,0-0.2l-10.8-3.1c0,0-0.1,0-0.1,0.1 c0,0,0,0.1,0.1,0.1L126.9,141.1C126.9,141.1,126.9,141.1,126.9,141.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M127.2,143.1C127.2,143.1,127.2,143.1,127.2,143.1c0.1-0.1,0.1-0.1,0-0.2l-11.2-7.6c0,0-0.1,0-0.1,0 c0,0,0,0.1,0,0.1L127.2,143.1C127.1,143.1,127.2,143.1,127.2,143.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M127,145.2C127,145.2,127,145.2,127,145.2c0.1-0.1,0.1-0.1,0.1-0.1l-10.3-11.7c0,0-0.1,0-0.1,0 c0,0,0,0.1,0,0.1L127,145.2C126.9,145.2,127,145.2,127,145.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M126,146.7C126,146.7,126,146.7,126,146.7c0.1,0,0.1-0.1,0.1-0.1l-7.9-14.5c0,0-0.1-0.1-0.1,0 c0,0-0.1,0.1,0,0.1L126,146.7C125.9,146.7,126,146.7,126,146.7z"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M123.4,147.3C123.4,147.3,123.4,147.3,123.4,147.3C123.5,147.2,123.5,147.2,123.4,147.3l-2.4-14.8 c0,0-0.1-0.1-0.1-0.1c0,0-0.1,0.1-0.1,0.1L123.4,147.3C123.4,147.2,123.4,147.3,123.4,147.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M121.7,146.6C121.8,146.6,121.8,146.6,121.7,146.6l0.9-13.1c0,0,0-0.1-0.1-0.1c0,0,0,0,0,0 c0,0-0.1,0-0.1,0.1L121.7,146.6C121.7,146.6,121.7,146.6,121.7,146.6C121.7,146.6,121.7,146.6,121.7,146.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M120.2,145.5C120.2,145.5,120.2,145.5,120.2,145.5l3.7-10.6c0,0,0-0.1-0.1-0.1c0,0-0.1,0-0.1,0.1 l-3.6,10.6C120.1,145.4,120.1,145.5,120.2,145.5C120.1,145.5,120.2,145.5,120.2,145.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M118.7,144C118.8,144,118.8,144,118.7,144l6.2-7.6c0,0,0-0.1,0-0.1c0,0-0.1,0-0.1,0l-6.1,7.6 C118.6,143.9,118.6,143.9,118.7,144C118.7,144,118.7,144,118.7,144z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M117.5,142C117.5,142,117.5,142,117.5,142l8.3-4.1c0,0,0.1-0.1,0-0.1c0,0-0.1-0.1-0.1,0l-8.3,4.1 C117.4,141.9,117.4,142,117.5,142C117.4,142,117.5,142,117.5,142z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M116.5,139.7h10c0,0,0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1h-10C116.4,139.5,116.4,139.6,116.5,139.7 C116.4,139.7,116.4,139.7,116.5,139.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M127,141.8C127.1,141.8,127.1,141.8,127,141.8c0.1-0.1,0.1-0.1,0-0.2l-11.1-4.7c0,0-0.1,0-0.1,0 c0,0,0,0.1,0,0.1L127,141.8C127,141.8,127,141.8,127,141.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M127.2,144.1C127.2,144.1,127.2,144.1,127.2,144.1c0.1-0.1,0.1-0.1,0.1-0.1l-10.9-9.6c0,0-0.1,0-0.1,0 c0,0,0,0.1,0,0.1L127.2,144.1C127.1,144.1,127.1,144.1,127.2,144.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M126.6,146.2C126.6,146.2,126.6,146.2,126.6,146.2c0.1,0,0.1-0.1,0.1-0.1l-9.2-13.5c0,0-0.1,0-0.1,0 c0,0,0,0.1,0,0.1L126.6,146.2C126.5,146.2,126.5,146.2,126.6,146.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M125.1,147.2C125.1,147.2,125.2,147.2,125.1,147.2c0.1,0,0.1-0.1,0.1-0.1l-6-15.1c0,0-0.1-0.1-0.1,0 c0,0-0.1,0.1,0,0.1L125.1,147.2C125.1,147.2,125.1,147.2,125.1,147.2z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 771.4893,
    y1: 143.8848,
    x2: 777.2968,
    y2: 133.4078,
    gradientTransform: "matrix(-1 0 0 1 897.5085 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#706F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#706F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#C6C6C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C6C6C6"
    }
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st75",
    d: "M119.4,135.9L119.4,135.9L119.4,135.9L119.4,135.9L119.4,135.9z M124.7,142.6L124.7,142.6l-1.1,0.7 c1-0.6,1.2-2.5,0.3-4.4c-0.9-2.1-2.8-3.5-4.1-3.1c-0.1,0-0.2,0.1-0.2,0.1l1-0.6c0.1-0.1,0.2-0.1,0.2-0.1l0,0v0 c0.1,0,0.1,0,0.2-0.1c1.3-0.4,3.2,1,4.1,3.1c0.4,0.8,0.5,1.6,0.6,2.3v0.2C125.6,141.5,125.3,142.2,124.7,142.6z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M123.2,143.4c-1.3,0.4-3.2-1-4.1-3.1c-1-2.1-0.6-4.2,0.7-4.6c1.3-0.4,3.2,1,4.1,3.1 C124.8,141,124.5,143,123.2,143.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 774.3174,
    y1: 142.0903,
    x2: 777.3376,
    y2: 136.6417,
    gradientTransform: "matrix(-1 0 0 1 897.5085 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#706F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#706F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#C6C6C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C6C6C6"
    }
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M119.9,137.7v0.2C119.8,137.9,119.8,137.8,119.9,137.7z M119.9,137.7C119.5,137.9,119.5,137.9,119.9,137.7 L119.9,137.7L119.9,137.7z M120.2,137.5c0,0,0.1-0.1,0.1-0.1l0,0v0c0,0,0.1,0,0.1,0c0.7-0.2,1.8,0.5,2.3,1.7 c0.5,1.1,0.4,2.2-0.2,2.5l0,0l-0.3,0.2c0.6-0.4,0.3-1.2-0.1-2.3c-0.6-1.4-1.9-1.4-2.2-1.6v-0.2 C120,137.7,120.1,137.6,120.2,137.5z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M122.1,141.9c-0.7,0.2-1.8-0.5-2.3-1.7c-0.5-1.2-0.4-2.3,0.4-2.6c0.7-0.2,1.8,0.5,2.3,1.7 C123,140.5,122.8,141.6,122.1,141.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 762.2675,
    y1: 131.4751,
    x2: 783.6498,
    y2: 131.4751,
    gradientTransform: "matrix(-1 0 0 1 897.5085 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9FFF4F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02436084,
    style: {
      stopColor: "#9DFC4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4625,
    style: {
      stopColor: "#74D023"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8022,
    style: {
      stopColor: "#5BB40A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#52AA00"
    }
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M118.5,124.2c3.8-1,12.6,1.7,16.8,13.3l-3.7,1.5c-2.9-9.7-15.7-13.1-17.7-12.5 C115.2,125.4,118,124.3,118.5,124.2z"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st78",
    d: "M156,162.5l-1.5-0.9c-0.4-0.2-0.5-0.7-0.3-1.1c0.2-0.4,0.7-0.5,1.1-0.3l1.5,0.9c0.6,0.3,1.1,0.4,1.7,0.1 c2.4-1.1,4.5-7.4,5.6-12.4c0-0.2,0.2-0.4,0.4-0.5l2.6-1.5c0.2-0.1,0.5-0.1,0.7,0c0.2,0.1,0.4,0.3,0.4,0.6 c0.5,2.6,0.7,8.7-1.5,10.3c-0.7,0.5-1.5,0.6-2.4,0.1l-1.2-0.6c-1,2.5-2.4,4.7-4.1,5.4c-0.4,0.2-0.9,0.3-1.3,0.3 C157.1,163,156.5,162.8,156,162.5z M165.5,149.5c-0.3,1.6-0.9,3.9-1.8,6.3l1.3,0.6c0.5,0.2,0.7,0.1,0.7,0c1-0.8,1.4-4.6,1-7.7 L165.5,149.5z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 715.5938,
    y1: 170.9652,
    x2: 716.924,
    y2: 168.6614,
    gradientTransform: "matrix(-1 0 0 1 897.5085 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#706F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#706F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#C6C6C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C6C6C6"
    }
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st79",
    d: "M182.1,168.8l-1.8,1v1.1c0.8-0.4,1.5-0.9,2.3-1.3C182.7,169.4,182.5,168.9,182.1,168.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 714.9786,
    y1: 173.9274,
    x2: 719.0776,
    y2: 166.5325,
    gradientTransform: "matrix(-1 0 0 1 897.5085 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#706F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#706F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#C6C6C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C6C6C6"
    }
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M177.8,168.4L177.8,168.4L177.8,168.4L177.8,168.4L177.8,168.4z M178,168.2c1-0.3,2.4,0.7,3.1,2.3 c0.6,1.4,0.5,2.8-0.2,3.3l0.8-0.5v0c0.8-0.5,0.9-1.9,0.3-3.3c-0.7-1.6-2.1-2.6-3.1-2.3c0,0-0.1,0-0.1,0.1l0,0l0,0 c-0.1,0-0.1,0.1-0.2,0.1l-0.8,0.4C177.9,168.3,178,168.2,178,168.2z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M180.6,173.9c-1,0.3-2.4-0.7-3.1-2.3c-0.7-1.6-0.5-3.1,0.5-3.4c1-0.3,2.4,0.7,3.1,2.3 C181.8,172.1,181.6,173.6,180.6,173.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 724.0811,
    y1: 163.8253,
    x2: 712.2412,
    y2: 158.7995,
    gradientTransform: "matrix(-1 0 0 1 897.5085 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#706F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#706F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#9D9D9C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C6C6C6"
    }
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M176.8,152.9l-1.5,0.6l6.4,15.7c0.5,0.5,1.6,0,1.5-0.6L176.8,152.9z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M178.3,154.9l-2.9,1.2l2.4,3.7c0.5,0.4,1.4-0.1,1.5-0.6L178.3,154.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 731.2619,
    y1: 149.1782,
    x2: 717.2176,
    y2: 143.2167,
    gradientTransform: "matrix(-1 0 0 1 897.5085 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#706F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#706F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#9D9D9C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C6C6C6"
    }
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st82",
    d: "M170.5,135.8l-2.9,1.2l7.9,19.1c0.4,1,3.3-0.2,2.9-1.2L170.5,135.8z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M179.1,175.9c-1.3-1.1-2.5-2.7-3.4-4.6c-1.3-2.9-1.4-5.7-0.5-7.4c1.3,0.2,2.6,0.9,3.9,2v-3.7 c-2.2-1.6-4.6-2.3-6.6-1.7c-4,1.3-5,7.5-2.1,14c2,4.5,5.4,7.9,8.6,9.1V175.9z M185.1,169.9c-1.5-3.3-3.7-6-6-7.7v3.7 c1.3,1.2,2.5,2.8,3.3,4.6c1.1,2.5,1.4,5,0.9,6.9c-1.3,0.2-2.8-0.4-4.2-1.6v7.7c1.4,0.5,2.7,0.6,3.9,0.2 C187.1,182.6,188,176.3,185.1,169.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 733.1572,
    y1: 146.2748,
    x2: 698.7078,
    y2: 220.1519,
    gradientTransform: "matrix(-1 0 0 1 897.5085 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#706F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C6C6C6"
    }
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M176.4,179.1v-6.4c-0.3-0.4-0.5-0.9-0.7-1.4c-1.3-2.9-1.4-5.7-0.5-7.4c-0.5-0.1-1.1,0-1.6,0.1 c-2.8,0.9-3.5,5.2-1.4,9.7C173.2,176,174.8,177.9,176.4,179.1L176.4,179.1z M176.4,164.1l-1.2-0.2 C178,164.3,178.4,164.3,176.4,164.1z M183.3,177.4c-2.2,0.3-5-1.6-6.9-4.7v6.4c1.5,1.1,3.1,1.6,4.5,1.1 C182.2,179.9,183,178.8,183.3,177.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 726.3812,
    y1: 159.7983,
    x2: 715.2402,
    y2: 183.6904,
    gradientTransform: "matrix(-1 0 0 1 897.5085 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#706F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#706F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#C6C6C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C6C6C6"
    }
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st84",
    d: "M181.5,179.3c-2.6,0.8-6.2-1.9-8.1-6c-1.9-4.1-1.3-8.5,1.8-9.4c-1.1,2.3-0.5,5.2,0.5,7.4 c1.8,3.9,5.1,6.5,7.6,6.1c-0.1,0.2-0.1,0.4-0.2,0.6C182.7,178.6,182.2,179.1,181.5,179.3z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M171.4,161L171.4,161L171.4,161L171.4,161L171.4,161z M187.6,181.3L187.6,181.3l-3.5,2 c3.1-2,3.6-7.6,1-13.4c-2.9-6.4-8.5-10.7-12.6-9.4c-0.3,0.1-0.5,0.2-0.7,0.3l3.1-1.8c0.2-0.2,0.5-0.3,0.7-0.4l0,0l0,0 c0.2-0.1,0.4-0.1,0.5-0.2c4-1.3,9.7,2.9,12.6,9.4c1,2.3,1.6,4.5,1.7,6.5v1.3C190.3,178.3,189.3,180.3,187.6,181.3z"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M180.8,179.5C180.8,179.5,180.8,179.5,180.8,179.5c0.1,0,0.1-0.1,0.1-0.1l-4.5-15.2c0,0-0.1-0.1-0.1-0.1 c0,0-0.1,0.1-0.1,0.1L180.8,179.5C180.7,179.5,180.8,179.5,180.8,179.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M179,179.2C179,179.2,179,179.2,179,179.2C179,179.2,179.1,179.2,179,179.2l-0.8-14.1c0,0,0-0.1-0.1-0.1 c0,0-0.1,0-0.1,0.1L179,179.2C178.9,179.2,178.9,179.2,179,179.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M177.2,178.2C177.2,178.2,177.3,178.2,177.2,178.2l2.6-11.7c0,0,0-0.1-0.1-0.1c0,0-0.1,0-0.1,0.1 l-2.5,11.6C177.1,178.2,177.1,178.2,177.2,178.2C177.2,178.2,177.2,178.2,177.2,178.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M175.6,176.7C175.6,176.7,175.6,176.7,175.6,176.7l5.4-8.7c0,0,0-0.1,0-0.1c0,0-0.1,0-0.1,0l-5.4,8.6 C175.5,176.6,175.5,176.7,175.6,176.7C175.5,176.7,175.5,176.7,175.6,176.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M174.2,174.8C174.2,174.8,174.2,174.8,174.2,174.8l7.8-5.1c0,0,0-0.1,0-0.1c0,0-0.1,0-0.1,0l-7.7,5.1 C174.1,174.7,174.1,174.7,174.2,174.8C174.1,174.8,174.1,174.8,174.2,174.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M173.1,172.6C173.1,172.6,173.1,172.6,173.1,172.6l9.6-1.2c0,0,0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1 l-9.6,1.2C173,172.4,173,172.5,173.1,172.6C173,172.5,173.1,172.6,173.1,172.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M183.3,173.3C183.3,173.3,183.4,173.3,183.3,173.3c0.1-0.1,0.1-0.2,0-0.2l-10.8-3.1c0,0-0.1,0-0.1,0.1 c0,0,0,0.1,0.1,0.1L183.3,173.3C183.3,173.3,183.3,173.3,183.3,173.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M183.6,175.3C183.6,175.3,183.6,175.3,183.6,175.3c0.1-0.1,0.1-0.1,0-0.2l-11.2-7.6c0,0-0.1,0-0.1,0 c0,0,0,0.1,0,0.1L183.6,175.3C183.5,175.3,183.5,175.3,183.6,175.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M183.4,177.4C183.4,177.4,183.4,177.4,183.4,177.4c0.1-0.1,0.1-0.1,0.1-0.1l-10.3-11.7c0,0-0.1,0-0.1,0 c0,0,0,0.1,0,0.1L183.4,177.4C183.3,177.4,183.3,177.4,183.4,177.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M182.4,178.9C182.4,178.9,182.4,178.9,182.4,178.9c0.1,0,0.1-0.1,0.1-0.1l-7.9-14.5c0,0-0.1-0.1-0.1,0 c0,0-0.1,0.1,0,0.1L182.4,178.9C182.3,178.9,182.4,178.9,182.4,178.9z"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M179.8,179.5C179.8,179.5,179.8,179.5,179.8,179.5C179.9,179.4,179.9,179.4,179.8,179.5l-2.4-14.8 c0,0,0-0.1-0.1-0.1c0,0-0.1,0.1-0.1,0.1L179.8,179.5C179.7,179.4,179.8,179.5,179.8,179.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M178.1,178.8C178.2,178.8,178.2,178.8,178.1,178.8l0.9-13.1c0,0,0-0.1-0.1-0.1c0,0,0,0,0,0 c0,0-0.1,0-0.1,0.1L178.1,178.8C178,178.8,178.1,178.8,178.1,178.8C178.1,178.8,178.1,178.8,178.1,178.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M176.5,177.7C176.6,177.7,176.6,177.7,176.5,177.7l3.7-10.6c0,0,0-0.1-0.1-0.1c0,0-0.1,0-0.1,0.1 l-3.6,10.6C176.5,177.6,176.5,177.7,176.5,177.7C176.5,177.7,176.5,177.7,176.5,177.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M175.1,176.2C175.1,176.2,175.2,176.2,175.1,176.2l6.2-7.6c0,0,0-0.1,0-0.1c0,0-0.1,0-0.1,0l-6.1,7.6 C175,176.1,175,176.1,175.1,176.2C175.1,176.2,175.1,176.2,175.1,176.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M173.9,174.2C173.9,174.2,173.9,174.2,173.9,174.2l8.3-4.1c0,0,0.1-0.1,0-0.1c0,0-0.1-0.1-0.1,0 l-8.3,4.1C173.8,174.1,173.8,174.2,173.9,174.2C173.8,174.2,173.8,174.2,173.9,174.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M172.9,171.9h10c0,0,0.1,0,0.1-0.1s0-0.1-0.1-0.1h-10C172.8,171.7,172.8,171.8,172.9,171.9 C172.8,171.9,172.8,171.9,172.9,171.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M183.4,174C183.5,174,183.5,174,183.4,174c0.1-0.1,0.1-0.1,0-0.2l-11.1-4.7c0,0-0.1,0-0.1,0 c0,0,0,0.1,0,0.1L183.4,174C183.4,174,183.4,174,183.4,174z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M183.5,176.3C183.6,176.3,183.6,176.3,183.5,176.3c0.1-0.1,0.1-0.1,0.1-0.1l-10.9-9.6c0,0-0.1,0-0.1,0 c0,0,0,0.1,0,0.1L183.5,176.3C183.5,176.3,183.5,176.3,183.5,176.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M183,178.4C183,178.4,183,178.4,183,178.4c0.1,0,0.1-0.1,0.1-0.1l-9.2-13.5c0,0-0.1,0-0.1,0 c0,0,0,0.1,0,0.1L183,178.4C182.9,178.4,182.9,178.4,183,178.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M181.5,179.4C181.5,179.4,181.5,179.4,181.5,179.4c0.1,0,0.1-0.1,0.1-0.1l-6-15.1c0,0-0.1-0.1-0.1,0 c0,0-0.1,0.1,0,0.1L181.5,179.4C181.5,179.4,181.5,179.4,181.5,179.4z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 716.0809,
    y1: 174.4671,
    x2: 720.1798,
    y2: 167.0725,
    gradientTransform: "matrix(-1 0 0 1 897.5085 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#706F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#706F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#C6C6C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C6C6C6"
    }
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M176.7,168.9L176.7,168.9L176.7,168.9L176.7,168.9L176.7,168.9z M176.9,168.8c1-0.3,2.4,0.7,3.1,2.3 c0.6,1.4,0.5,2.8-0.2,3.3l0.8-0.5l0,0c0.8-0.5,0.9-1.9,0.3-3.3c-0.7-1.6-2.1-2.6-3.1-2.3c0,0-0.1,0-0.1,0.1v0l0,0 c-0.1,0-0.1,0.1-0.2,0.1l-0.8,0.4C176.8,168.8,176.9,168.8,176.9,168.8z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M179.5,174.4c-1,0.3-2.4-0.7-3.1-2.3c-0.7-1.6-0.5-3.1,0.5-3.4c1-0.3,2.4,0.7,3.1,2.3 C180.7,172.6,180.5,174.1,179.5,174.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 717.8975,
    y1: 173.4763,
    x2: 720.4193,
    y2: 168.9268,
    gradientTransform: "matrix(-1 0 0 1 897.5085 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#706F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#706F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#C6C6C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C6C6C6"
    }
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st86",
    d: "M177.1,170.2v0.1C177,170.3,177,170.3,177.1,170.2z M177.1,170.2L177.1,170.2L177.1,170.2L177.1,170.2 L177.1,170.2z M177.1,170.4c0.2,0.1,1.2,0.2,1.6,1.2c0.4,0.8,0.5,1.4,0.1,1.7l0.2-0.1v0c0.4-0.3,0.5-1,0.2-1.9 c-0.4-0.9-1.2-1.5-1.7-1.3c0,0-0.1,0-0.1,0v0l0,0c0,0-0.1,0-0.1,0.1c-0.1,0.1-0.2,0.1-0.2,0.2V170.4z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M178.7,173.3c-0.6,0.2-1.3-0.4-1.7-1.3c-0.4-0.9-0.3-1.7,0.3-1.9c0.6-0.2,1.3,0.4,1.7,1.3 C179.4,172.3,179.3,173.1,178.7,173.3z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M178.4,172.5c-0.3,0.1-0.7-0.2-0.9-0.7c-0.2-0.5-0.1-0.9,0.2-1c0.3-0.1,0.7,0.2,0.9,0.7 S178.7,172.5,178.4,172.5z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M184,165.2c-1,0.6-2.4,0.7-4,0.5c-2.1-1.8-5.2-4.5-8.7-3.5c-2,0.6-1.6,3.3-2.1,4.9 c-0.3,0.9-0.6,1.8-1.2,2.6c-1.2,0-2.3-0.9-2.8-1.5c0.5-0.5,1.1-1.5,1.1-2.4c-0.2-2-0.4-5.9,3.3-7.6 C175,155.8,182,162.4,184,165.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 709.5449,
    y1: 160.4431,
    x2: 726.9429,
    y2: 160.4431,
    gradientTransform: "matrix(-1 0 0 1 897.5085 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9FFF4F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02436084,
    style: {
      stopColor: "#9DFC4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4625,
    style: {
      stopColor: "#74D023"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8022,
    style: {
      stopColor: "#5BB40A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#52AA00"
    }
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "st88",
    d: "M174.2,155.9c3.8-1,10.8,1.5,13.7,7l-4,2.3c-5.1-6.3-11.4-7.8-13.4-7.1C171.9,156.9,173.8,156,174.2,155.9 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 719.9355,
    y1: 173.3728,
    x2: 721.2651,
    y2: 171.07,
    gradientTransform: "matrix(-1 0 0 1 897.5085 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#706F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#706F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#C6C6C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C6C6C6"
    }
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M177.7,171.2l-1.8,1v1.1c0.8-0.4,1.5-0.9,2.3-1.3C178.4,171.8,178.1,171.3,177.7,171.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 730.9384,
    y1: 168.2647,
    x2: 719.0187,
    y2: 163.2051,
    gradientTransform: "matrix(-1 0 0 1 897.5085 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#706F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#706F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#9D9D9C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C6C6C6"
    }
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "st90",
    d: "M169.8,157.2l-1.5,0.6l6.6,16.2c0.5,0.5,1.6,0,1.5-0.6L169.8,157.2z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M171.2,159l-2.9,1.2l2.4,3.7c0.5,0.4,1.4-0.1,1.5-0.6L171.2,159z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M131.5,139c-1,0.6-1.6,0.3-3.2,0.1c-3.3-7.8-9.3-9.7-12.8-8.7c-1.5,0.4-2,1.9-2.2,3.3l-2.9-1.7 c0.1-2,0.7-4.4,3.4-5.6C119.3,124.1,130,132,131.5,139z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "M114.2,137.5c1.4,0.9-0.4,4.1-1.9,3.3l-2.3-2.4c-0.5-0.5,0.4-2,1.2-1.8L114.2,137.5z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M136.8,137.9c-1.8,0.7-4.2,0.4-3.5,3c0.7,2.5,0.9,5.3,1.7,7.4c0.4,1.1,5.3,3.3,6.5,4 c3.5,1.9,2.3-5.6,2.3-8C143.7,140.3,140.3,136.6,136.8,137.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 777.8172,
    y1: 153.1915,
    x2: 769.1769,
    y2: 138.2262,
    gradientTransform: "matrix(-1 0 0 1 897.5085 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DADADA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#DADADA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#706F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#9D9D9C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C6C6C6"
    }
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "st92",
    d: "M114.3,137.5c-1.3-0.7-3.3,2.5-1.9,3.3l21.8,12.6c1.1,0.6,3-2.7,1.9-3.3L114.3,137.5z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M136.2,150.2c-1.4-0.8-3.3,2.3-1.8,3.3l3.1,0.8c0.7,0.2,1.6-1.4,1-2L136.2,150.2z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M133.5,138.6c-0.5,0.1-0.3,1.9-0.2,2.3c0.5,2,0.8,4.4,1.4,6.1c0.3,0.9,4.4,2.8,5.4,3.4 c0.3,0.2,0.5,0.2,0.7,0.3c0.5-1.6,0.1-4.6,0.1-5.8C140.9,139.9,137.3,137.3,133.5,138.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 766.7672,
    y1: 143.3179,
    x2: 775.6483,
    y2: 135.3213,
    gradientTransform: "matrix(-1 0 0 1 897.5085 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DADADA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#DADADA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#706F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#9D9D9C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C6C6C6"
    }
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "M120.2,139.2c-0.6,0.7,1.1,2.4,1.8,1.6l5.6-5.9c0.6-0.6-1.3-2.2-1.8-1.6L120.2,139.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 762.7601,
    y1: 135.4531,
    x2: 752.0178,
    y2: 116.847,
    gradientTransform: "matrix(-1 0 0 1 897.5085 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DADADA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#DADADA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#706F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#9D9D9C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C6C6C6"
    }
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M126.4,133.1c-1-0.7-0.3,2,0.4,2.4l7.9,4.6c1,0.6,3.7,1.7,5.1,1.1c7.5-3.6-1.6-1.3-2.6-1.8L126.4,133.1z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M143.2,139.7c-2.4,1.4-6,1.2-9.7-2c-1.7-1.6-8.2-4.7-7.1-8.7c0.9-3.1,1.6-2.7,8.3-2.7 c5.6,0,3.3,7.2,6.6,8.8C144.8,136.7,146.1,138,143.2,139.7z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M143.2,138.7c-2.4,1.1-5.4,1.3-9-2.4c-1.7-1.8-9.1-6.9-6.7-9.4c1.7-1.8,5.1-2.6,7.6-2.4 c5.6,0.6,3.5,8.5,6.9,10C148.7,137.5,146,137.3,143.2,138.7z"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M158.8,151.2c-0.6-0.4-0.6-1.5,0.1-2.4c0.6-1,1.6-1.4,2.2-1.1c0.6,0.4,0.6,1.5-0.1,2.4 C160.3,151.1,159.4,151.6,158.8,151.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M159.4,151.4c-0.5-0.3-0.5-1.3,0.1-2.2c0.6-0.9,1.4-1.3,2-0.9c0.5,0.3,0.5,1.3-0.1,2.2 C160.8,151.3,159.9,151.7,159.4,151.4z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st70",
    d: "M148.3,160c2.6,0,4.9-2.2,6.4-3.6c0.4-0.4,2.5-1.1,3.7-1.6c1.1-0.4,2.1-0.8,2.9-1.1 c1.5-0.7,1.8-1.7,1.8-2.2c0.1-0.9-0.5-1.8-1.7-2.5c-0.5-0.3-1.2-0.2-1.5,0.4c-0.3,0.5-0.2,1.2,0.4,1.5c0.3,0.2,0.5,0.4,0.6,0.4 c-0.1,0.1-0.2,0.2-0.5,0.3c-0.7,0.3-1.6,0.7-2.7,1c-2.3,0.9-3.8,1.4-4.5,2.1c-2.5,2.4-4.4,3.6-6.2,2.6l-8.6-5 c-0.5-0.3-1.2-0.1-1.5,0.4c-0.3,0.5-0.1,1.2,0.4,1.5l8.6,5C146.7,159.8,147.5,160,148.3,160z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 722.0876,
    y1: 173.8845,
    x2: 722.8088,
    y2: 172.5836,
    gradientTransform: "matrix(-1 0 0 1 897.5085 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#706F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#706F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#C6C6C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C6C6C6"
    }
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "st95",
    d: "M174.6,172.9L174.6,172.9L174.6,172.9L174.6,172.9L174.6,172.9z M174.6,172.9c0.2-0.1,0.4,0.1,0.5,0.4 c0.1,0.2,0.1,0.5,0,0.6l0.1-0.1l0,0c0.1-0.1,0.2-0.3,0-0.6c-0.1-0.3-0.4-0.5-0.5-0.4c0,0,0,0,0,0l0,0h0c0,0,0,0,0,0L174.6,172.9 C174.6,172.9,174.6,172.9,174.6,172.9z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M175.1,173.9c-0.2,0.1-0.4-0.1-0.5-0.4c-0.1-0.3-0.1-0.5,0.1-0.6c0.2-0.1,0.4,0.1,0.5,0.4 C175.3,173.6,175.3,173.8,175.1,173.9z"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M141,148.7l-5.2-2.6c-0.3-0.2-0.6,0-0.6,0.3v0c0,0.3,0.3,0.7,0.6,0.9l5.1,2.6 C141,149.4,141,149.1,141,148.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M140.9,146.7l-5.5-2.8c-0.3-0.2-0.6,0-0.6,0.3v0c0,0.3,0.3,0.7,0.6,0.9l5.5,2.8 C141,147.5,141,147.1,140.9,146.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M140.9,144.8l-5.8-2.9c-0.3-0.2-0.6,0-0.6,0.3v0c0,0.3,0.3,0.7,0.6,0.9l5.8,2.9 C140.9,145.5,140.9,145.1,140.9,144.8L140.9,144.8z"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M147.2,142.9c-0.5-0.3-3.4-1.8-4.3-2c-4.1-0.8-2.1,8.1-0.7,12.2c0.3,0.9,2.6,0.8,2.9-0.1l2.6-7.4 C148.1,144.3,147.8,143.2,147.2,142.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M146,143.8c-0.4-0.3-2.8-1.5-3.5-1.6c-3.4-0.7-1.7,6.6-0.6,10c0.2,0.7,2.1,0.6,2.4-0.1l2.1-6.1 C146.8,145,146.6,144.1,146,143.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M145.3,144.4c-0.4-0.2-2.4-1.3-2.9-1.4c-0.6-0.1-1,0-1.2,0.4c0.6,0.1,2.7,1.2,3.1,1.4 c0.5,0.3,0.8,1,0.6,1.9l-1.1,4.9c0.1-0.1,0.1-0.1,0.1-0.2l1.8-5.1C145.9,145.4,145.7,144.7,145.3,144.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M142.4,145.9c0.3-0.2,0.3-0.7,0-1.2c-0.3-0.5-0.8-0.7-1.1-0.5c-0.3,0.2-0.3,0.7,0,1.2 C141.6,145.9,142.1,146.1,142.4,145.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M142,146c0.3-0.2,0.3-0.7,0-1.1c-0.3-0.4-0.7-0.7-1-0.5c-0.3,0.2-0.3,0.7,0,1.1 C141.3,145.9,141.8,146.2,142,146z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M143.3,152.2c0.2-0.1,0.2-0.5,0-0.8c-0.2-0.3-0.5-0.5-0.7-0.3c-0.2,0.1-0.2,0.5,0,0.8 C142.8,152.1,143.1,152.3,143.3,152.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M143.1,152.2c0.2-0.1,0.2-0.4,0-0.7c-0.2-0.3-0.5-0.4-0.6-0.3c-0.2,0.1-0.2,0.4,0,0.7 C142.7,152.2,142.9,152.3,143.1,152.2z"
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M134.5,141.5c0.2-0.1,0.2-0.5,0-0.8c-0.2-0.3-0.5-0.5-0.7-0.3c-0.2,0.1-0.2,0.5,0,0.8 C134,141.5,134.3,141.6,134.5,141.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M134.3,141.6c0.2-0.1,0.2-0.4,0-0.7c-0.2-0.3-0.5-0.4-0.6-0.3c-0.2,0.1-0.2,0.4,0,0.7 C133.8,141.5,134.1,141.7,134.3,141.6z"
  }))), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "st96",
    d: "M150.3,143.8l4.1-1.6c0.7-0.3,1.4-0.3,2.1,0.1l4.5,2.2c0.3,0.1,0.4,0.4,0.4,0.7c0,0.3-0.2,0.5-0.5,0.7 l-3.8,1.6c-0.8,0.3-1.5,0.3-2.2,0l-4.7-2.3c-0.3-0.1-0.4-0.4-0.4-0.7C149.8,144.2,150,144,150.3,143.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 728.9717,
    y1: 139.8778,
    x2: 754.4573,
    y2: 139.8778,
    gradientTransform: "matrix(-1 0 0 1 897.5085 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9FFF4F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02436084,
    style: {
      stopColor: "#9DFC4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4625,
    style: {
      stopColor: "#74D023"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8022,
    style: {
      stopColor: "#5BB40A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#52AA00"
    }
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M165.7,134.6c2.6,1.6,4.1,6,1.5,8.1l0,0l0,0c-0.2,0.1-0.4,0.3-0.6,0.4c-0.1,0-0.2,0.1-0.2,0.1l-6,3.6 l-17.3-9.7l8-3.2c0.1-0.1,0.3-0.1,0.4-0.2l0.1,0l0,0c1-0.4,2-0.6,2.7-0.7C157,132.7,162.5,132.6,165.7,134.6z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M158.4,139.3c2.1,1.6,5,6.3,1.6,7.8c-0.8,0.4-2.2,0.4-3.5-0.3l-12.7-6.5c-4.9-2.5,1.4-4.3,3.9-4.4 C150.4,135.8,155.3,136.8,158.4,139.3z"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M154.8,134.8c0.1,0.4,0.8,0.7,1.6,0.6c0.8-0.1,1.5-0.5,1.4-1c-0.1-0.4-0.8-0.7-1.6-0.6 S154.7,134.3,154.8,134.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M154.9,134.4c0.1,0.4,0.7,0.6,1.5,0.6c0.8-0.1,1.3-0.5,1.3-0.9c-0.1-0.4-0.7-0.6-1.5-0.6 C155.4,133.6,154.8,134,154.9,134.4z"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M158.7,136.4c0.9,1.6,5.3,1.6,5.1-0.6l-0.2-1.6l-1,0.1c-0.5,0-1.2,0.1-1.8,0.3c-0.5,0.2-0.9,0.4-1.2,0.7 l-1,0.4L158.7,136.4C158.6,136.3,158.7,136.4,158.7,136.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M158.6,135.8c0.4,0.7,1.7,0.8,3.1,0.3c1.4-0.5,2.2-1.5,1.8-2.1c-0.4-0.7-1.7-0.8-3.1-0.3 C159,134.2,158.2,135.2,158.6,135.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M159,135.7c0.3,0.5,1.4,0.6,2.5,0.2c1.1-0.4,1.8-1.2,1.5-1.7c-0.3-0.5-1.4-0.6-2.5-0.2 C159.4,134.4,158.7,135.1,159,135.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M163.1,134.4c-0.4-0.4-1.4-0.4-2.4,0c-0.9,0.4-1.5,1-1.5,1.5c0.4,0.4,1.4,0.4,2.4,0 C162.5,135.5,163.1,134.9,163.1,134.4z"
  }))), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M124.1,134.9c-0.7,0.7,1.2,2.6,1.9,1.7l1.6-1.7c0.6-0.6-1.3-2.4-1.9-1.7L124.1,134.9z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M126.4,133.1c-1-0.7-0.3,2,0.4,2.4l1.7,1c-0.8-0.4-0.5-2.1,0.7-1.8L126.4,133.1z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st69",
    points: "168.4,137 173.7,149.6 168.5,152.6 163.1,140  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 738.3497,
    y1: 153.2349,
    x2: 724.3057,
    y2: 147.2736,
    gradientTransform: "matrix(-1 0 0 1 897.5085 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#706F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#706F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#9D9D9C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C6C6C6"
    }
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "M163.4,139.8l-2.9,1.2l7.9,19.1c0.4,1,3.3-0.2,2.9-1.2L163.4,139.8z"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M170.2,135l0.8,1.9c0.1,0.3-0.1,0.6-0.3,0.7l-8.8,5.1c-0.3,0.2-0.9,0-1-0.2l-0.9-2.1L170.2,135z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M169.8,135.7c0.6-0.3,0.8-0.9-0.6-0.9c-1.8,0-5.3,0.2-7.5,1.5c-1.4,0.8-1.6,2.7-1.8,3.9 c-0.1,0.5,0.6,0.8,1.2,0.5L169.8,135.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 727.0101,
    y1: 137.4947,
    x2: 727.0101,
    y2: 141.1816,
    gradientTransform: "matrix(-1 0 0 1 897.5085 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9FFF4F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02436084,
    style: {
      stopColor: "#9DFC4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4625,
    style: {
      stopColor: "#74D023"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8022,
    style: {
      stopColor: "#5BB40A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#52AA00"
    }
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "st101",
    d: "M170.9,137.5c-1.6-0.3-2.6,1.9-1.2,3l0.9,0.7l1.4-3.5L170.9,137.5z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M172.2,137.8c-0.6-0.3-1.4,0.3-1.8,1.3c-0.4,1-0.3,1.9,0.3,2.2c0.6,0.3,1.4-0.3,1.8-1.3 C172.9,139,172.8,138,172.2,137.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 725.3193,
    y1: 138.1019,
    x2: 726.5731,
    y2: 141.0558,
    gradientTransform: "matrix(-1 0 0 1 897.5085 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#706F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C6C6C6"
    }
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "st102",
    d: "M172.2,138.2c-0.5-0.2-1.1,0.3-1.4,1c-0.3,0.8-0.2,1.5,0.2,1.7c0.5,0.2,1.1-0.3,1.4-1 C172.7,139.2,172.6,138.4,172.2,138.2z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M171.6,138.4c-0.1,0-0.1,0-0.2,0c-0.3,0.2-0.5,0.5-0.7,0.9c-0.2,0.4-0.2,0.9-0.1,1.2c0,0,0.1,0.1,0.1,0.1 c0.4,0.2,0.9-0.2,1.1-0.8C172.1,139.1,172,138.5,171.6,138.4z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M172.1,138.3c-0.4-0.2-1,0.2-1.3,0.9c-0.2,0.5-0.2,1-0.1,1.3c-0.1-0.3,0-0.7,0.1-1.1 c0.3-0.7,0.9-1.1,1.3-0.9c0.1,0.1,0.2,0.2,0.3,0.3C172.4,138.6,172.3,138.4,172.1,138.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 728.5307,
    y1: 139.4011,
    x2: 728.5307,
    y2: 148.9412,
    gradientTransform: "matrix(-1 0 0 1 897.5085 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9FFF4F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02436084,
    style: {
      stopColor: "#9DFC4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4625,
    style: {
      stopColor: "#74D023"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8022,
    style: {
      stopColor: "#5BB40A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#52AA00"
    }
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M169.9,139.5c-4.3-0.7-6.7,4.8-3,7.6l2.4,1.8l3.6-9L169.9,139.5z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M173.3,140.1c-1.5-0.6-3.6,0.8-4.6,3.3c-1.1,2.5-0.7,5,0.8,5.6c1.5,0.6,3.6-0.8,4.6-3.3 C175.2,143.3,174.8,140.7,173.3,140.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 724.1559,
    y1: 140.973,
    x2: 727.4001,
    y2: 148.616,
    gradientTransform: "matrix(-1 0 0 1 897.5085 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#706F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C6C6C6"
    }
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M173.3,141.2c-1.2-0.5-2.9,0.7-3.7,2.6c-0.8,2-0.6,4,0.6,4.5c1.2,0.5,2.8-0.7,3.7-2.6 C174.7,143.8,174.5,141.8,173.3,141.2z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M171.9,141.6c-0.1-0.1-0.3-0.1-0.5-0.1c-0.7,0.5-1.4,1.3-1.9,2.3c-0.5,1.1-0.6,2.3-0.4,3.2 c0.1,0.1,0.2,0.1,0.3,0.2c0.9,0.4,2.2-0.5,2.9-2.1C173.1,143.6,172.8,142,171.9,141.6z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M173.1,141.6c-1.1-0.5-2.6,0.6-3.3,2.4c-0.5,1.2-0.6,2.5-0.2,3.3c-0.2-0.8-0.1-1.8,0.3-2.8 c0.8-1.8,2.3-2.8,3.3-2.4c0.3,0.1,0.6,0.4,0.7,0.7C173.9,142.2,173.6,141.8,173.1,141.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 733.2061,
    y1: 140.8941,
    x2: 733.2061,
    y2: 144.5813,
    gradientTransform: "matrix(-1 0 0 1 897.5085 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9FFF4F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02436084,
    style: {
      stopColor: "#9DFC4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4625,
    style: {
      stopColor: "#74D023"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8022,
    style: {
      stopColor: "#5BB40A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#52AA00"
    }
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M164.7,140.9c-1.6-0.3-2.6,1.9-1.2,3l0.9,0.7l1.4-3.5L164.7,140.9z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M166,141.2c-0.6-0.3-1.4,0.3-1.8,1.3c-0.4,1-0.3,1.9,0.3,2.2c0.6,0.3,1.4-0.3,1.8-1.3 C166.7,142.4,166.6,141.4,166,141.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 731.5153,
    y1: 141.5016,
    x2: 732.7689,
    y2: 144.455,
    gradientTransform: "matrix(-1 0 0 1 897.5085 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#706F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C6C6C6"
    }
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M166,141.6c-0.5-0.2-1.1,0.3-1.4,1c-0.3,0.8-0.2,1.5,0.2,1.7c0.5,0.2,1.1-0.3,1.4-1 C166.5,142.6,166.4,141.8,166,141.6z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M165.4,141.8c-0.1,0-0.1,0-0.2,0c-0.3,0.2-0.5,0.5-0.7,0.9c-0.2,0.4-0.2,0.9-0.1,1.2c0,0,0.1,0.1,0.1,0.1 c0.4,0.2,0.9-0.2,1.1-0.8C165.9,142.5,165.8,141.9,165.4,141.8z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M165.9,141.7c-0.4-0.2-1,0.2-1.3,0.9c-0.2,0.5-0.2,1-0.1,1.3c-0.1-0.3,0-0.7,0.1-1.1 c0.3-0.7,0.9-1.1,1.3-0.9c0.1,0.1,0.2,0.2,0.3,0.3C166.2,142,166.1,141.8,165.9,141.7z"
  })))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M172.2,118.9c-1.1,1-1,2.1-1.4,3.4c-0.3,1-1.1,2.3-2.8,2c0.1-0.1,0.5-0.8,0.6-0.8c2,0,2.2-1.8,2.4-3.6 C171,119.5,172.5,117.5,172.2,118.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M167.1,124.2c0.4,0,0.8-0.2,1-0.6l2.8-5.2c0.3-0.5,0.1-1.2-0.4-1.5c-0.5-0.3-1.2-0.1-1.5,0.4l-2.8,5.2 c-0.3,0.5-0.1,1.2,0.4,1.5C166.7,124.2,166.9,124.2,167.1,124.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M167.4,124.1c-0.8,0-1.5-0.7-1.5-1.5c0-0.8,0.6-1.4,1.4-1.3c0.8,0,1.5,0.7,1.5,1.5 C168.8,123.5,168.2,124.1,167.4,124.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M167.1,124.5c-0.8,0-1.5-0.7-1.5-1.5c0-0.8,0.6-1.4,1.4-1.3c0.8,0,1.5,0.7,1.5,1.5 C168.6,124,167.9,124.6,167.1,124.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M164.1,137.5c0.1,0,0.3,0,0.4-0.1c1.6-0.9,3-2,4-3.2c1.3-1.5,0.3-3.4-0.6-5.1c-0.5-1-1.1-2.1-1.1-2.9 c0-0.6,0.3-1.4,0.9-2.5c0.2-0.4,0.1-0.9-0.3-1.1c-0.4-0.2-0.9-0.1-1.1,0.3c-0.7,1.4-1.1,2.4-1.1,3.2c0,1.2,0.7,2.5,1.3,3.7 c0.9,1.6,1.4,2.7,0.8,3.3c-0.9,1.1-2.1,2-3.6,2.8c-0.4,0.2-0.5,0.7-0.3,1.1C163.6,137.4,163.8,137.5,164.1,137.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M172.2,118.6c-1.1,1-1,2.1-1.4,3.4c-0.3,1-1.2,2.3-2.5,2c0.1-0.1,0.3-0.8,0.4-0.8c2,0,1.9-2,2.2-3.6 C171.1,119.2,172,117.5,172.2,118.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M165.9,134.3c-1.7,1-3.1,1.8-4.8,2.8c-0.6,0.3-0.8,0.7-0.8,1.3c0.2,0.3,1,0.6,1.7,0.7c1.7-1,3.4-2,5.1-3 C167.2,135.2,166.8,134.3,165.9,134.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M165.9,134.3c-1.7,1-3.1,1.8-4.8,2.8c0.6,0.2,1.2,0.6,0.9,2c1.7-1,3.4-2,5.1-3 C167.2,135.2,166.8,134.3,165.9,134.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M158.3,139.7c0.3,0,0.5,0,0.8-0.1c0.9-0.3,1.4-0.4,2.3-0.8c0.4-0.2,0.6-0.6,0.4-1 c-0.2-0.4-0.6-0.6-1-0.4c-0.8,0.3-1.3,0.5-2.2,0.7c-1,0.3-2.2-0.8-3.3-2c-1-1.1-2.1-2.2-3.4-2.5c-2.3-0.7-6.6,0.2-9.7,0.9 c-0.8,0.2-1.6,0.3-2.1,0.4c-0.4,0.1-0.7,0.5-0.6,0.9c0.1,0.4,0.5,0.7,0.9,0.6c0.6-0.1,1.3-0.3,2.2-0.4c2.8-0.6,7-1.5,8.9-0.9 c0.9,0.3,1.8,1.2,2.8,2.1C155.4,138.4,156.7,139.7,158.3,139.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M147.3,135.6c-0.6,0-1.1-0.7-1.1-1.5c0-0.4-0.4-0.8-0.2-1.1c0.2-0.2,1-0.3,1.3-0.3c0.6,0,1.1,0.7,1.1,1.5 C148.4,135.1,147.9,135.7,147.3,135.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M146.5,135.8c-0.6,0-1.1-0.7-1.1-1.5c0-0.8,0.5-1.4,1.1-1.3c0.6,0,1.1,0.7,1.1,1.5 C147.6,135.2,147.1,135.8,146.5,135.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st78",
    d: "M140.2,136.7c0.1,0,0.1,0,0.2,0l5.7-1.1c0.6-0.1,1-0.7,0.9-1.3c-0.1-0.6-0.7-1-1.3-0.9l-5.7,1.1 c-0.6,0.1-1,0.7-0.9,1.3C139.2,136.4,139.7,136.7,140.2,136.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M141.7,137.1c1.3-0.9,2.5-0.5,4.1-0.6c1.2-0.1,2.9-0.5,2.6-1.7l-0.1-0.6c-0.4,1.6-3.2,2-5.3,2 c-0.4,0-1.8,0-1.9,0.3C141.1,136.6,141.4,137,141.7,137.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M141.5,136.7c1.3-0.9,2.5-0.5,4.1-0.6c1.2-0.1,3.2-0.7,2.7-2l-0.8,0.1c-0.4,2-2.8,1.5-4.7,1.5 C142.4,135.7,140.3,136.3,141.5,136.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M140,136.8c-0.5,0-0.8-0.5-0.8-1.1c0-0.6,0.3-1,0.8-1c0.5,0,0.8,0.5,0.8,1.1 C140.8,136.4,140.4,136.8,140,136.8z"
  })))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M152.8,161.5c-0.6,0.1-1.3-0.3-1.6-1.1c-0.1-0.4-0.7-0.7-0.5-1c0.1-0.3,0.8-0.6,1.1-0.6 c0.6-0.1,1.3,0.3,1.6,1.1C153.6,160.7,153.4,161.4,152.8,161.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M152.1,162c-0.6,0.1-1.3-0.3-1.6-1.1c-0.3-0.7,0-1.5,0.6-1.6c0.6-0.1,1.3,0.3,1.6,1.1 C152.9,161.1,152.6,161.8,152.1,162z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st78",
    d: "M146.1,164.9c0.2,0,0.4,0,0.6-0.1l5-2.9c0.5-0.3,0.7-1,0.4-1.5c-0.3-0.5-1-0.7-1.5-0.4l-5,2.9 c-0.5,0.3-0.7,1-0.4,1.5C145.3,164.7,145.7,164.9,146.1,164.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M146.1,164.8c-0.3,0.1-0.8-0.2-0.9-0.6c-0.2-0.4,0-0.9,0.3-0.9c0.3-0.1,0.8,0.2,0.9,0.6 C146.6,164.3,146.5,164.7,146.1,164.8z"
  })))))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M224.2,237.6c10,0,18.1,4.3,18.1,9.6c0,5.3-8.1,9.6-18.1,9.6c-10,0-18.1-4.3-18.1-9.6 C206.1,241.8,214.2,237.6,224.2,237.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M238.3,193.3c-0.2,3.8-3.1,11-3.1,11.5c-0.9,0.7-2.7,0.3-2.3-0.9c1.3-4.7-0.1-7.5,1.3-13.4 c0.2-0.8,1.4-1.4,2.7-1.3C237.5,189.4,238.4,190.6,238.3,193.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M232.9,203.9c-0.5,0.3-0.9,0.8-0.8,1.3c0.3,1.4-0.8,1.5-1,2.4c0.1,0.4,2.8,1.8,3.2,1.2 c0.8-0.2,1.3-1.9,1.4-2.8c0-0.8-0.1-0.8-0.4-1.6l0.3-1.9c-0.3-0.7-1.1-0.6-2.1-0.6L232.9,203.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M232.5,204.4c-0.3,0.3-0.9,0.8-1.3,1.1c-0.5,0.4-0.6,0.7-1.1,1.1c0.4,0.3,0.8,0.4,1.6-0.4 c1.3-1,1.7,0,2.1-1.4C234,204.2,233.1,203.9,232.5,204.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M230.8,207.9l0.2-1.7c0.1-0.5,0.8-0.4,0.8,0.1l0,1.7C231.7,208.5,230.8,208.4,230.8,207.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M231.7,208.3l0.2-1.9c0.1-0.6,0.9-0.5,0.8,0.1l0,1.8C232.7,209,231.6,208.9,231.7,208.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M232.7,208.5l0.2-1.6c0.1-0.5,0.7-0.4,0.7,0.1l0,1.6C233.5,209,232.6,209,232.7,208.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M233.6,208.8l0.1-1.3c0-0.4,0.6-0.3,0.6,0.1l0,1.3C234.3,209.3,233.5,209.2,233.6,208.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M228.9,244.7c-0.6,0.7,0.1,2.5,1.9,2.9c0.7,0.1,1.2,0.1,2.7-0.4c1.1-0.4,1.6-0.7,2.6-0.7 c0.1,0,0.2,0.5,0.4,0.5c0.9,0,1.4-0.1,2.2-0.1c0.7-0.1,2.2-1.1,2.2-2c0-0.5-0.5-1.7-1.5-2L228.9,244.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M232.2,242.8c-1.3,0.8-1.6,0-2.8,0.9c-0.6,0.4-0.7,1.2-0.5,1.7c0.2,0.8,1.1,1.4,1.8,1.6 c0.6,0.2,1.5,0.2,2.1-0.1c2.9-1.4,5.3-0.9,6.1-1.4c1.1-0.7,1.3-1.4,1.1-1.9c-0.4-1.2-1.6-1.8-2.1-2.5c-0.9-1.2-1.4-1.7-1.6-2.6 c-1-0.3-3.7,0-4.5,1.3C233.4,241.9,232.5,242.5,232.2,242.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M232.7,244.3C232.7,244.3,232.7,244.3,232.7,244.3c-0.5-0.7-0.8-1.2-0.5-1.8c0-0.1,0.1-0.1,0.1,0 c0.1,0,0.1,0.1,0.1,0.1c-0.2,0.5,0,0.9,0.4,1.5C232.9,244.2,232.9,244.3,232.7,244.3C232.8,244.3,232.8,244.3,232.7,244.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M232.1,244.6C232.1,244.6,232,244.5,232.1,244.6c-0.4-0.7-0.7-1.2-0.3-1.8c0-0.1,0.1-0.1,0.2,0 c0.1,0,0.1,0.1,0,0.2c-0.3,0.5-0.1,0.9,0.2,1.5C232.2,244.5,232.2,244.5,232.1,244.6C232.1,244.6,232.1,244.6,232.1,244.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M233.2,243.8C233.2,243.8,233.2,243.8,233.2,243.8c-0.6-0.6-1-1-0.8-1.6c0-0.1,0.1-0.1,0.1-0.1 c0.1,0,0.1,0.1,0.1,0.1c-0.2,0.5,0.2,0.9,0.7,1.4C233.3,243.6,233.3,243.7,233.2,243.8C233.3,243.8,233.2,243.8,233.2,243.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M233.5,243.1C233.5,243.1,233.5,243.1,233.5,243.1c-0.7-0.4-1.1-0.8-1-1.5c0-0.1,0.1-0.1,0.1-0.1 c0.1,0,0.1,0.1,0.1,0.1c-0.1,0.5,0.3,0.9,0.9,1.3C233.6,243,233.6,243,233.5,243.1C233.6,243.1,233.5,243.1,233.5,243.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M233.6,242.3C233.6,242.3,233.6,242.3,233.6,242.3c-0.7-0.3-1.2-0.6-1.3-1.3c0-0.1,0-0.1,0.1-0.1 c0,0,0,0,0,0c0.1,0,0.1,0,0.1,0.1c0,0.5,0.5,0.8,1.1,1.1c0.1,0,0.1,0.1,0.1,0.1C233.7,242.3,233.7,242.3,233.6,242.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M233.7,241.5C233.7,241.5,233.6,241.5,233.7,241.5c-0.7-0.2-1.3-0.4-1.4-1c0-0.1,0-0.1,0.1-0.1 c0.1,0,0.1,0,0.1,0.1c0.1,0.5,0.6,0.7,1.3,0.9c0.1,0,0.1,0.1,0.1,0.1C233.8,241.5,233.7,241.5,233.7,241.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M233.5,240.8C233.5,240.8,233.5,240.8,233.5,240.8c-0.7-0.1-1.3-0.2-1.6-0.8c0-0.1,0-0.1,0.1-0.1 c0.1,0,0.1,0,0.1,0.1c0.2,0.5,0.7,0.6,1.4,0.7c0.1,0,0.1,0.1,0.1,0.1C233.6,240.7,233.5,240.8,233.5,240.8z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M239.5,241.5c-1,2-6,2.2-7.9,0.2c-1.8-4-8.3-11-9.3-14.9c-0.6-8.3-0.5-22.5,1.4-23.4c2.4-0.8,4.8-0.8,7.2-1.6 c0.6,2.9,2.6,6.8-0.1,10.1c-0.3,5.5-0.8,10.6-0.6,13.4C234,228.3,235.7,236.3,239.5,241.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M235.5,180.6c1.7,2.4,3.3,12.1,2,12.6c-0.5,0.2-2.8-0.9-3.2-2.2c-1.5-2.7-3.6-4.6-3.6-8.3 c-3.5-4.7-1.7-6.7-0.3-7.2C230.8,175.8,235,173.6,235.5,180.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M236.3,179.5c-1.3,1.9-4,2.9-6,3.5c-2-2.8-6.1-7.9-1.5-10.2C233.9,170.8,234.9,176.6,236.3,179.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M231.8,172.5c3.2,0.9,1,6-0.8,8.1c-0.1,0.1-2.6,6.3-6.8,9.5c-2.4,1.4-3.9-2.2-2.5-4.6c0.9-3.8,2.5-6.9,2.9-8 C225.1,175.7,228.6,171,231.8,172.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M222.2,175.5c-0.4,0.1-2.7,1.2-4.5,3.5c-1.3,1.6-1.2,5.3-1.1,5.8c0.2,1.6-1.6,16.9,0.6,17.2 c-1.1,4.5,10.4,0.8,13.8-2c2.1-1.5,1.2-11.3,1.5-13c0.3-1.7,1.6-9.7-0.7-12.8c-0.5-0.7-1.5-1.6-2.3-1.5 C226.6,173,222.7,175.4,222.2,175.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M218.3,178.3c2.4-0.8,7.5,3.2,9.4,11.4c1,0.3,0.7-0.8,1.7-1.1c-1.6-6.8-5.3-12.9-8.6-12.4 C219.4,176.8,219.3,177.4,218.3,178.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M227.2,173.4c5.9,1.2,3.3,7.5,1.6,15.7c0.8,0.3,1.1-0.8,2.2-1.1c1.4-6.8,4-13.6-1.4-15.4 C229,172.4,228.7,172.5,227.2,173.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M211.1,244.8c-0.2,0-0.8,1.4-0.3,2.4c0.1,0.3,0,1.3,2.8,2.3c0.8,0.3,1.5,0.2,3.1,0.9c0.4,0.2,0,0.7,0.3,0.9 c0.8,0.5,1.4,0.8,1.8,1.1c0.6,0.4,2.7,0.4,3.2-0.5c0.3-0.5-0.1-2.7-0.1-2.7L211.1,244.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M222,244.9c0.2-0.4-0.6-1.2-0.6-1.2s-0.1,0.7-0.2,1.1c-0.1,0.4-1.3,1.2-3.3,0.2c-1.4-0.7-1.1-2.2-1.1-2.2 c0-0.2-0.5,0.1-0.5,0.5c0,1.1-0.5,1.5-0.9,1.6c-1.7-0.1-2.6-0.7-3.1-0.7c-0.5,0-1.3,0.4-1.5,1c-0.3,0.9,0.2,1.9,0.7,2.6 c0.4,0.5,1.3,1.1,1.9,1.2c3.5,0.6,5.3,2.5,6.4,2.5c1.4,0,1.8-0.3,2-1c0.4-1.3,0-2.5-0.3-3.4C221.7,246.2,221.9,245.1,222,244.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M222,244.9c0.2-0.4-0.6-1.2-0.6-1.2s-0.1,0.7-0.2,1.1c-0.1,0.4-1.3,1.2-3.3,0.2c-1.4-0.7-1.1-2.2-1.1-2.2 c0-0.2-0.5,0.1-0.5,0.5c0,1.1-0.5,1.5-0.9,1.6c-1.7-0.1-2.6-0.7-3.1-0.7c-0.5,0-1.3,0.4-1.5,1c-0.3,0.9,0.2,1.9,0.7,2.6 c0.4,0.5,1.3,1.1,1.9,1.2c3.5,0.6,5.3,2.5,6.4,2.5c1.4,0,1.8-0.3,2-1c0.4-1.3,0-2.5-0.3-3.4C221.7,246.2,221.9,245.1,222,244.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M222,244.9c0.2-0.4-0.6-1.2-0.6-1.2s-0.1,0.7-0.2,1.1c-0.1,0.4-1.3,1.2-3.3,0.2c-1.4-0.7-1.1-2.2-1.1-2.2 c0-0.2-0.5,0.1-0.5,0.5c0,1.1-0.5,1.5-0.9,1.6c-1.7-0.1-1.4-1-3.1-1c-0.8,0-1.3,0.6-1.5,1.3c-0.3,0.9,0.2,1.9,0.7,2.6 c0.4,0.5,1.3,1.1,1.9,1.2c3.5,0.6,5.3,2.5,6.4,2.5c1.4,0,1.8-0.3,2-1c0.4-1.3,0-2.5-0.3-3.4C221.7,246.2,221.9,245.1,222,244.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M213.4,245.8c0,0,0,0.1,0.1,0.1c0.1,0,0.1,0,0.1,0c0.2-0.4,0.4-0.7,0.6-0.8c0.2-0.2,0.5-0.2,0.8-0.2 c0.1,0,0.1,0,0.1-0.1c0-0.1-0.1-0.1-0.1-0.1c-0.3,0-0.7,0-0.9,0.2C213.8,245.1,213.6,245.4,213.4,245.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M213.9,246.1c0,0,0,0.1,0.1,0.1c0.1,0,0.1,0,0.1,0c0.1-0.4,0.3-0.7,0.5-0.9c0.2-0.2,0.5-0.3,0.8-0.3 c0.1,0,0.1,0,0.1-0.1c0-0.1-0.1-0.1-0.1-0.1c-0.3,0-0.6,0.1-0.9,0.3C214.2,245.3,214.1,245.6,213.9,246.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M214.6,246.4c0,0.1,0,0.1,0.1,0.1c0.1,0,0.1,0,0.1-0.1c0-0.4,0.1-0.8,0.3-1c0.2-0.2,0.4-0.4,0.7-0.5 c0.1,0,0.1-0.1,0-0.1c0,0-0.1-0.1-0.1-0.1c-0.3,0.1-0.6,0.3-0.8,0.6C214.7,245.6,214.6,246,214.6,246.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M215.3,246.8c0,0,0.1,0.1,0.1,0.1c0.1,0,0.1-0.1,0.1-0.1c-0.2-0.4-0.2-0.7-0.1-1c0.1-0.3,0.2-0.5,0.5-0.7 c0,0,0-0.1,0-0.1c0,0-0.1,0-0.2,0c-0.3,0.2-0.4,0.5-0.5,0.8C215,246,215.1,246.3,215.3,246.8z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M224.5,215.8c-0.2,3.7-1.3,6.5-2.2,10.6c-0.7,3,1,18.5,0.3,22.5c-0.7,1.2-5,0.2-7.1-2.4 c-0.7-2.9-1.9-18.1-1.5-21.7c0.3-1.2,0.7-7.3,0.8-9.6c0.3-6,1.4-10.6,2.2-12c0,0,4.9-0.5,9.4,0.3 C230.2,210.8,225,215.4,224.5,215.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M217,203.3c2.1,1.9,11.1,2.5,13.9-1.5c0-0.5,0.1-1.3,0.1-1.8c-3.2,2.4-10.1,4.1-13.8,2 C217.1,202.4,217,202.8,217,203.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M218.5,228.6c0-2.8,0.4-5.7,1.5-8.5c-2.2-0.5-4-1.3-5.3-2.8c-0.7,3.6-2,8.3-0.7,9.2 C215.6,227.7,216.8,228.4,218.5,228.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M219.4,220.3c-2.4-0.8-3.7-1.6-4.8-2.7c-0.3,0.7-0.6,1.4-1,2.2c1.3,1.3,2.8,2.4,4.9,2.8 C218.9,221.9,219.2,221.1,219.4,220.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M214.9,220.3c0.1-0.1,0.1-0.4-0.1-0.7c-0.2-0.2-0.5-0.3-0.6-0.2c-0.1,0.1-0.1,0.4,0.1,0.7 S214.8,220.5,214.9,220.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M218.3,222.1c0.1-0.1,0.1-0.4-0.1-0.7c-0.2-0.2-0.5-0.3-0.6-0.2c-0.1,0.1-0.1,0.4,0.1,0.7 C217.9,222.2,218.1,222.3,218.3,222.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M216.4,204.4c-1.8,6.3-2.6,11.4-1.7,11.8c2.1,1.2,3.1,1.7,5.1,1.8c0.5-1.7,0.7-4.2,1.1-6 c-3.7-1.2-3.3-4.8-2.8-6.9C217.3,205,217.2,204.7,216.4,204.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M225.2,202.4c1.5-3.8,2.6-8,2.5-13c1.1-0.5,2.3-1.1,3.4-1.6c0,4.1-0.1,8.1-0.1,12.2 C229.3,202.1,227.3,202.8,225.2,202.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M220.1,161.9c0,0.8-0.6,1.8-0.7,2.6c-0.1,0.5-0.2,0.7,0,1.2c0.3,0.7,0.2,1.4,0,2.2c-0.2,0.9,0.1,1.8,0.3,2.7 c0.2,0.7,0.3,1.5,0.9,1.9c1.6,1,3.3,0.4,4.9-0.1c1.6-0.5,1.3-3.3,1.8-4.6c0.9-2.3,0.2-5.6-2.3-6.6c-1.2-0.5-3-0.7-4.2-0.2 C220.4,161.1,220.1,161.9,220.1,161.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M222.3,171.4c0,0-0.5,2.6-0.2,3.9c0.2,0.4,1.7,1.5,3,1.5c2,0,4.3-1,3.6-2.7c-0.4-0.9-1.3-1.8-0.7-5.4 C228.1,167.6,222.3,171.4,222.3,171.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M228.1,160.3c-2.4-1.6-5.7-1.1-7.2,0.7c-0.9,1-1,2.2-1,2.2c0.5,0.7,0.9-0.1,1.2,1.8c0.1,0.5,0.6,1.1,0.7,1.5 c1.9,8.1,5.9,4.6,6,4.3c1.2-2.8,2-2.2,2.5-3.9C231.1,164.4,231.5,162.6,228.1,160.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M222.9,168.5c-0.3,0.9-0.5,1.7-0.9,1.5c-0.4-0.2-0.8-1-0.5-1.8c0.3-0.9,0.5-1.7,0.9-1.7 C223.2,166.5,223.2,167.7,222.9,168.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M221.8,186.9c0.5,2.9-2.4,12.3-3.8,12.1c-0.5-0.1-2.1-2.1-1.9-3.4c-0.2-3.1-1.2-5.7,0.4-9.1 c-1.1-5.8,1.5-6.7,2.9-6.6C219.7,180.5,224.4,180.4,221.8,186.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M222.8,188.2c-2.1,0.9-5,0.4-7-0.2c-0.2-3.4-0.9-9.9,4.2-9.4C225.3,179.6,223.1,185,222.8,188.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M219.3,199.4c-1.2,3.6-5.8,9-5.9,9.5c-1.1,0.4-2.7-0.5-2-1.5c2.9-3.7,1.6-6.7,4.6-12 c0.4-0.7,1.9-0.8,3.1-0.3C219.7,195.4,220.2,196.9,219.3,199.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M230.6,165.5c0.7,0.7,2.1,2.3,2.6,3.2c-1.9-1-3.7,0-4.9,0.3c-1.4,0.3-2.9-2.2-4.1-3.1 C227.9,166.7,229.7,166.1,230.6,165.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M230.7,165.9c-2.2,1.3-8,0-11.2-2.1c0.4-5,4-5.3,7.1-4.5C230.2,160.2,232.3,163.3,230.7,165.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M229,163.4c0,0.1,0.1,0.2,0.1,0.3c0.1,0.3,0.1,0.7,0.2,1l-0.3,0v0.5l0.3,0c0,0.2,0,0.5,0,0.7 c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0c0-0.7-0.1-1.3-0.3-2c-0.2-0.7-0.4-1.3-0.7-2V163.4z M228.7,164.8c0-0.3,0.1-0.7,0.1-1.1 c0-0.4,0-0.7,0-1.1c0,0,0,0,0,0c0.1,0.2,0.2,0.5,0.2,0.7v-1.5l0-0.1c-0.1,0-0.3,0-0.4,0.1c-0.1,0-0.3,0-0.4,0.1 c0.1,0.7,0.2,1.4,0.1,2.1c0,0.7-0.2,1.4-0.4,2.1c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0c0.1-0.2,0.1-0.5,0.2-0.7c0.1,0,0.2,0,0.3,0 l0,0v-0.5L228.7,164.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M220.7,228.1c0-2.8,0.4-5.7,1.5-8.5c-2.2-0.5-4-1.3-5.3-2.8c-0.7,3.6-2,8.3-0.7,9.2 C217.8,227.2,218.9,227.8,220.7,228.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M221.5,219.7c-2.4-0.8-3.7-1.6-4.8-2.7c-0.3,0.7-0.6,1.4-1,2.2c1.3,1.3,2.8,2.4,4.9,2.8 C221,221.3,221.3,220.6,221.5,219.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M218.8,212.5l-7.9-4.6v1.5l1.4,0.8c0.4,0.2,0.7,0.6,0.9,1c0.2,0.4,0.1,0.8-0.1,0.9l-2.1,1.2v15.9 c8.7,4.9,10.5,5.2,10.6,0.6v-0.9c0-2.9-0.5-7.2-0.5-13.1C220.9,214.6,220,213.1,218.8,212.5z M210.9,207.9l-1.7-1 c-0.6-0.3-1.1-0.4-1.4-0.3c0,0-0.8,0.4-0.9,0.5l0.3,0.1c-0.1,0.2-0.1,0.4-0.1,0.6l0,17.1c0,1.2,1,2.7,2.1,3.4 c0.6,0.3,1.2,0.7,1.7,1v-15.9l-0.7,0.4c-0.3,0.2-0.7,0-1-0.3c-0.4-0.4-0.6-0.8-0.6-1.2l0-3.2c0-0.5,0.4-0.7,0.9-0.4l1.4,0.8 V207.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M220.2,216.2c0-1.2-1-2.7-2.1-3.4l-7.9-4.6l-1.7-1c-1.2-0.7-2.1-0.3-2.1,0.9l0,17.1c0,1.2,1,2.8,2.1,3.4 c0.6,0.3,1.2,0.6,1.7,0.8c8.9,4.3,10.8,4.5,10.8,0C221,226.8,220.3,222.4,220.2,216.2z M212.2,212.5l-2.1,1.2l-0.7,0.4 c-0.3,0.2-0.7,0-1-0.3c-0.4-0.4-0.6-0.8-0.6-1.2l0-3.2c0-0.5,0.4-0.7,0.9-0.4l1.4,0.8l1.4,0.8c0.4,0.2,0.7,0.6,0.9,1 C212.5,212,212.5,212.4,212.2,212.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M220.4,211.2l-3.3-1.9c-8.7,5-8.5,4.4-8.5,14.3c0,1.2,1,2.7,2.1,3.4l4.1,2.4l3.7,5.3l3.5-2l0,0 c0.3-0.2,0.5-0.6,0.5-1.1l0-17.1C222.6,213.4,221.6,211.8,220.4,211.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M217,213.1l-3.2-1.8l-2.9,1.6l-0.4,0.2l-4.3,2.5c-0.7,0.4-1.1,1.1-1.1,1.9l0,8c0,1.2,1,2.7,2.1,3.4 l9.7,5.6c1.2,0.7,2.1,0.3,2.1-0.9l0-17.1C219.1,215.3,218.2,213.8,217,213.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st110",
    points: "217.6,216 213.6,213.7 208.9,216.2 208.9,227.4 217.6,232.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st111",
    points: "217.2,221.2 209.4,216.7 209.4,227.2 217.2,231.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st112",
    d: "M217.6,209.4c-0.6,0-1.1,0.1-1.5,0.3h-0.9v1.6c0,0.7,1.1,1.2,2.3,1.2c1.3,0,2.3-0.6,2.3-1.2v-1.6h-0.9 C218.7,209.5,218.2,209.4,217.6,209.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st110",
    d: "M217.6,208.5c-1.3,0-2.3,0.6-2.3,1.2c0,0.7,1.1,1.2,2.3,1.2s2.3-0.6,2.3-1.2 C220,209,218.9,208.5,217.6,208.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M214.1,207.4c-0.2-0.4-1.3-1.5-1.9-1c-1,0.4-1.9,1.3-2,1.4c-0.2,0.2-1.1,2-1.3,2.2c-0.2,0.3,0.1,0.8,0.7,0.8 c0.2,0.2,0.7,0.4,1,0.3c0.3,0.2,0.4,0.3,1,0.3c0.2,0.1,0.4,0.4,0.6,0.3c0.7-0.2,1-0.9,1.6-1.9 C214.3,208.9,214.6,208.3,214.1,207.4z"
  })))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M124.8,196.2c-3-2.5-6.1-10.4-6.4-10.7c0.1-1.2,2.4-1,2.9,0.1c2,4.3,5.2,4.5,8.5,9.6c0.4,0.7-0.2,2-1.1,2.9 C128.1,198.4,126.6,198.2,124.8,196.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M116,217.9c-0.3,0.4-1.1,0.4-1.6,0.4c-0.6,0.1-0.8,0.9-1.6,0.9c-0.8,0,1.3-1.8,1.6-2c0.2-0.2,1.2-0.6,1.5-0.3 C116.4,217.3,116.1,217.5,116,217.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M120.7,184.5c0.2-0.5,0.2-1.1-0.2-1.5c-1.1-0.8-0.3-1.7-0.8-2.5c-0.3-0.2-3.3,0.5-3.2,1.1 c-0.5,0.7,0.2,2.3,0.7,3.1c0.5,0.6,0.6,0.6,1.3,0.9l1,1.7c0.7,0.3,1.3-0.3,2.1-0.9L120.7,184.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M127.9,246.3c10,0,18.1,4.3,18.1,9.6c0,5.3-8.1,9.6-18.1,9.6c-10,0-18.1-4.3-18.1-9.6 C109.9,250.6,118,246.3,127.9,246.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M136.2,181.6c3.2,0.9,1,6-0.8,8.1c-0.1,0.1-2.6,6.3-6.8,9.5c-2.4,1.4-3.9-2.2-2.5-4.6c0.9-3.8,2.5-6.9,2.9-8 C129.6,184.7,133.1,180,136.2,181.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M130.2,249.7c-0.2,0-0.8,1.4-0.3,2.4c0.1,0.3,0,1.3,2.8,2.3c0.8,0.3,1.5,0.2,3.1,0.9c0.4,0.2,0,0.7,0.3,0.9 c0.8,0.5,1.4,0.8,1.8,1.1c0.6,0.4,2.7,0.4,3.2-0.5c0.3-0.5-0.1-2.7-0.1-2.7L130.2,249.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M141.2,249.7c0.2-0.4-0.6-1.2-0.6-1.2c0,0-0.1,0.7-0.2,1.1c-0.1,0.4-1.3,1.2-3.3,0.2 c-1.4-0.7-1.1-2.2-1.1-2.2c0-0.2-0.5,0.1-0.5,0.5c0,1.1-0.5,1.5-0.9,1.6c-1.7-0.1-2.6-0.7-3.1-0.7c-0.5,0-1.3,0.4-1.5,1 c-0.3,0.9,0.2,1.9,0.7,2.6c0.4,0.5,1.3,1.1,1.9,1.2c3.5,0.6,5.3,2.5,6.4,2.5c1.4,0,1.8-0.3,2-1c0.4-1.3,0-2.5-0.3-3.4 C140.9,251,141.1,250,141.2,249.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M141.2,249.7c0.2-0.4-0.6-1.2-0.6-1.2c0,0-0.1,0.7-0.2,1.1c-0.1,0.4-1.3,1.2-3.3,0.2 c-1.4-0.7-1.1-2.2-1.1-2.2c0-0.2-0.5,0.1-0.5,0.5c0,1.1-0.5,1.5-0.9,1.6c-1.7-0.1-2.6-0.7-3.1-0.7c-0.5,0-1.3,0.4-1.5,1 c-0.3,0.9,0.2,1.9,0.7,2.6c0.4,0.5,1.3,1.1,1.9,1.2c3.5,0.6,5.3,2.5,6.4,2.5c1.4,0,1.8-0.3,2-1c0.4-1.3,0-2.5-0.3-3.4 C140.9,251,141.1,250,141.2,249.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M141.2,249.7c0.2-0.4-0.6-1.2-0.6-1.2c0,0-0.1,0.7-0.2,1.1c-0.1,0.4-1.3,1.2-3.3,0.2 c-1.4-0.7-1.1-2.2-1.1-2.2c0-0.2-0.5,0.1-0.5,0.5c0,1.1-0.5,1.5-0.9,1.6c-1.7-0.1-1.4-1-3.1-1c-0.8,0-1.3,0.6-1.5,1.3 c-0.3,0.9,0.2,1.9,0.7,2.6c0.4,0.5,1.3,1.1,1.9,1.2c3.5,0.6,5.3,2.5,6.4,2.5c1.4,0,1.8-0.3,2-1c0.4-1.3,0-2.5-0.3-3.4 C140.9,251,141.1,250,141.2,249.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M132.6,250.7c0,0,0,0.1,0.1,0.1c0.1,0,0.1,0,0.1,0c0.2-0.4,0.4-0.7,0.6-0.8c0.2-0.2,0.5-0.2,0.8-0.2 c0.1,0,0.1,0,0.1-0.1c0-0.1-0.1-0.1-0.1-0.1c-0.3,0-0.7,0-0.9,0.2C133,249.9,132.7,250.2,132.6,250.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M133.1,250.9c0,0,0,0.1,0.1,0.1c0.1,0,0.1,0,0.1,0c0.1-0.4,0.3-0.7,0.5-0.9c0.2-0.2,0.5-0.3,0.8-0.3 c0.1,0,0.1,0,0.1-0.1c0-0.1-0.1-0.1-0.1-0.1c-0.3,0-0.6,0.1-0.9,0.3C133.4,250.2,133.2,250.5,133.1,250.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M133.7,251.3c0,0.1,0,0.1,0.1,0.1c0.1,0,0.1,0,0.1-0.1c0-0.4,0.1-0.8,0.3-1c0.2-0.2,0.4-0.4,0.7-0.5 c0.1,0,0.1-0.1,0-0.1c0,0-0.1-0.1-0.1-0.1c-0.3,0.1-0.6,0.3-0.8,0.6C133.8,250.5,133.7,250.8,133.7,251.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M134.4,251.6c0,0,0.1,0.1,0.1,0.1c0.1,0,0.1-0.1,0.1-0.1c-0.2-0.4-0.2-0.7-0.1-1c0.1-0.3,0.2-0.5,0.5-0.7 c0,0,0-0.1,0-0.1c0,0-0.1,0-0.2,0c-0.3,0.2-0.4,0.5-0.5,0.8C134.2,250.8,134.3,251.2,134.4,251.6z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M136.6,222.8c-0.5,2.6,0.8,9.5,0.8,12.1c2.1,3.7,4,15.5,4.5,17.7c0.6,2.7-6.9,2-7.7-0.8 c-0.4-6.6-3.3-8.2-4.7-15.8c-1.3-7-2.8-14.3-2.8-15.4c-0.1-1.9,1.4-2.8,1.4-4.8c0,0,2.8-5.5,7.3-5 C138.3,216.6,137.7,222,136.6,222.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M126.7,184.6c-0.4,0.1-2.7,1.2-4.5,3.5c-1.3,1.6-1.2,5.3-1.1,5.8c0.2,1.6-1.6,16.9,0.6,17.2 c-1.1,4.5,10.4,0.8,13.8-2c2.1-1.5,1.2-11.3,1.5-13c0.3-1.7,1.6-9.7-0.7-12.8c-0.5-0.7-1.5-1.6-2.3-1.5 C131.1,182,127.2,184.4,126.7,184.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M122.8,187.4c2.4-0.8,7.5,3.2,9.4,11.4c1,0.3,0.7-0.8,1.7-1.1c-1.6-6.8-5.3-12.9-8.6-12.4 C123.9,185.8,123.8,186.4,122.8,187.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M131.7,182.5c5.9,1.2,3.3,7.5,1.6,15.7c0.8,0.3,1.1-0.8,2.2-1.1c1.4-6.8,4-13.6-1.4-15.4 C133.4,181.5,133.2,181.5,131.7,182.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M115.5,253.9c-0.2,0-0.8,1.4-0.3,2.4c0.1,0.3,0,1.3,2.8,2.3c0.8,0.3,1.5,0.2,3.1,0.9c0.4,0.2,0,0.7,0.3,0.9 c0.8,0.5,1.4,0.8,1.8,1.1c0.6,0.4,2.7,0.4,3.2-0.5c0.3-0.5-0.1-2.7-0.1-2.7L115.5,253.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M126.5,253.9c0.2-0.4-0.6-1.2-0.6-1.2s-0.1,0.7-0.2,1.1c-0.1,0.4-1.3,1.2-3.3,0.2c-1.4-0.7-1.1-2.2-1.1-2.2 c0-0.2-0.5,0.1-0.5,0.5c0,1.1-0.5,1.5-0.9,1.6c-1.7-0.1-2.6-0.7-3.1-0.7c-0.5,0-1.3,0.4-1.5,1c-0.3,0.9,0.2,1.9,0.7,2.6 c0.4,0.5,1.3,1.1,1.9,1.2c3.5,0.6,5.3,2.5,6.4,2.5c1.4,0,1.8-0.3,2-1c0.4-1.3,0-2.5-0.3-3.4C126.2,255.2,126.4,254.2,126.5,253.9z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M126.5,253.9c0.2-0.4-0.6-1.2-0.6-1.2s-0.1,0.7-0.2,1.1c-0.1,0.4-1.3,1.2-3.3,0.2c-1.4-0.7-1.1-2.2-1.1-2.2 c0-0.2-0.5,0.1-0.5,0.5c0,1.1-0.5,1.5-0.9,1.6c-1.7-0.1-2.6-0.7-3.1-0.7c-0.5,0-1.3,0.4-1.5,1c-0.3,0.9,0.2,1.9,0.7,2.6 c0.4,0.5,1.3,1.1,1.9,1.2c3.5,0.6,5.3,2.5,6.4,2.5c1.4,0,1.8-0.3,2-1c0.4-1.3,0-2.5-0.3-3.4C126.2,255.2,126.4,254.2,126.5,253.9z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M126.5,253.9c0.2-0.4-0.6-1.2-0.6-1.2s-0.1,0.7-0.2,1.1c-0.1,0.4-1.3,1.2-3.3,0.2c-1.4-0.7-1.1-2.2-1.1-2.2 c0-0.2-0.5,0.1-0.5,0.5c0,1.1-0.5,1.5-0.9,1.6c-1.7-0.1-1.4-1-3.1-1c-0.8,0-1.3,0.6-1.5,1.3c-0.3,0.9,0.2,1.9,0.7,2.6 c0.4,0.5,1.3,1.1,1.9,1.2c3.5,0.6,5.3,2.5,6.4,2.5c1.4,0,1.8-0.3,2-1c0.4-1.3,0-2.5-0.3-3.4C126.2,255.2,126.4,254.2,126.5,253.9z "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M117.9,254.8c0,0,0,0.1,0.1,0.1c0.1,0,0.1,0,0.1,0c0.2-0.4,0.4-0.7,0.6-0.8c0.2-0.2,0.5-0.2,0.8-0.2 c0.1,0,0.1,0,0.1-0.1c0-0.1-0.1-0.1-0.1-0.1c-0.3,0-0.7,0-0.9,0.2C118.3,254.1,118,254.4,117.9,254.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M118.4,255.1c0,0,0,0.1,0.1,0.1c0.1,0,0.1,0,0.1,0c0.1-0.4,0.3-0.7,0.5-0.9c0.2-0.2,0.5-0.3,0.8-0.3 c0.1,0,0.1,0,0.1-0.1c0-0.1-0.1-0.1-0.1-0.1c-0.3,0-0.6,0.1-0.9,0.3C118.7,254.3,118.5,254.7,118.4,255.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M119,255.5c0,0.1,0,0.1,0.1,0.1c0.1,0,0.1,0,0.1-0.1c0-0.4,0.1-0.8,0.3-1c0.2-0.2,0.4-0.4,0.7-0.5 c0.1,0,0.1-0.1,0-0.1c0,0-0.1-0.1-0.1-0.1c-0.3,0.1-0.6,0.3-0.8,0.6C119.2,254.6,119.1,255,119,255.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M119.7,255.8c0,0,0.1,0.1,0.1,0.1c0.1,0,0.1-0.1,0.1-0.1c-0.2-0.4-0.2-0.7-0.1-1c0.1-0.3,0.2-0.5,0.5-0.7 c0,0,0-0.1,0-0.1c0,0-0.1,0-0.2,0c-0.3,0.2-0.4,0.5-0.5,0.8C119.5,255,119.6,255.4,119.7,255.8z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M129,224.8c-0.2,3.7-1.3,6.5-2.2,10.6c-0.7,3,1,18.5,0.3,22.5c-0.7,1.2-5,0.2-7.1-2.4 c-0.7-2.9-1.9-18.1-1.5-21.7c0.3-1.2,0.7-7.3,0.8-9.6c0.3-6,1.4-10.6,2.2-12c0,0,4.9-0.5,9.4,0.3 C134.7,219.8,129.5,224.5,129,224.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M121.4,212.3c2.1,1.9,11.1,2.5,13.9-1.5c0-0.5,0.1-1.3,0.1-1.8c-3.2,2.4-10.1,4.1-13.8,2 C121.6,211.5,121.5,211.9,121.4,212.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M123,237.7c0-2.8,0.4-5.7,1.5-8.5c-2.2-0.5-4-1.3-5.3-2.8c-0.7,3.6-2,8.3-0.7,9.2 C120.1,236.8,121.3,237.4,123,237.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M123.8,229.3c-2.4-0.8-3.7-1.6-4.8-2.7c-0.3,0.7-0.6,1.4-1,2.2c1.3,1.3,2.8,2.4,4.8,2.8 C123.3,230.9,123.7,230.1,123.8,229.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M119.4,229.4c0.1-0.1,0.1-0.4-0.1-0.7c-0.2-0.2-0.5-0.3-0.6-0.2c-0.1,0.1-0.1,0.4,0.1,0.7 C119,229.4,119.2,229.5,119.4,229.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M122.7,231.2c0.1-0.1,0.1-0.4-0.1-0.7c-0.2-0.2-0.5-0.3-0.6-0.2c-0.1,0.1-0.1,0.4,0.1,0.7 C122.4,231.2,122.6,231.3,122.7,231.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M120.9,213.4c-1.8,6.3-2.6,11.4-1.7,11.8c2.1,1.2,3.1,1.7,5.1,1.8c0.5-1.7,0.7-4.2,1.1-6 c-3.7-1.2-3.3-4.8-2.8-6.9C121.8,214,121.7,213.8,120.9,213.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M129.7,211.5c1.5-3.8,2.6-8,2.5-13c1.1-0.5,2.3-1.1,3.4-1.6c0,4.1-0.1,8.1-0.1,12.2 C133.8,211.1,131.8,211.8,129.7,211.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M96.8,185c-0.9-0.1-1.5-0.8-1.4-1.7c0.1-0.9,0.8-1.5,1.7-1.4l15.4,1.2l11.4-4c0.2-0.1,0.4-0.1,0.6-0.1l0,0 l13.6,1.1l6.1-6.2c0.3-0.3,0.8-0.5,1.2-0.4l0,0l17,1.4c0.9,0.1,1.5,0.8,1.4,1.7c-0.1,0.9-0.8,1.5-1.7,1.4l-16.3-1.3l-6,6.1 c-0.3,0.4-0.8,0.6-1.3,0.5l-14-1.1l-11.3,4c-0.2,0.1-0.5,0.1-0.7,0.1L96.8,185z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st113",
    d: "M97,185c-0.5,0-1.4-0.3-1.5-1.3l17.6,1.4l11.4-4c0.2-0.1,0.4-0.1,0.6-0.1l0,0l13.6,1.1l6.1-6.2 c0.3-0.3,0.8-0.5,1.2-0.4l0,0l17,1.4c0.2,0,0.4,0.1,0.6,0.2c-0.3,0.6-0.9,0.9-1.5,0.9l-16.3-1.3l-6,6.1c-0.3,0.4-0.8,0.6-1.3,0.5 l-14-1.1l-11.3,4c-0.2,0.1-0.5,0.1-0.7,0.1L97,185z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M171.7,172l-9.9,10.5c-4.2-0.3-8.4-0.7-12.6-1c-0.9-0.1-1.3-0.7-1.5-1c-2.5-3.9,7.1-10.1,10.7-9.5L171.7,172 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st114",
    d: "M147.4,179.4c-0.5-3.9,7.8-9,11.1-8.4l13.2,1.1l-11.5,8.4c-4.2-0.3-8.4-0.7-12.6-1 C147.5,179.4,147.4,179.4,147.4,179.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M154.7,171.7c1.5-0.6,2.8-0.9,3.8-0.8l13.2,1.1l-1.3,1C165.1,172.6,159.9,172.1,154.7,171.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M164.8,174c3.6-2.3,7.5-2.7,8.7-0.9c1.2,1.8-0.9,5.2-4.5,7.5c-3.6,2.3-7.5,2.7-8.7,0.9 C159.1,179.6,161.2,176.3,164.8,174z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M170.9,178.4c-1.1-0.1-1.9-1.4-1.8-2.9c0.1-1.5,1.1-2.7,2.2-2.6v0l0,0l11.9,1l-2.4,5.4L170.9,178.4 L170.9,178.4L170.9,178.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st115",
    d: "M169.1,175.5c0-0.4,0.1-0.8,0.3-1.1c0.4-0.6,1.1-0.9,1.9-0.9v0l0,0l11.7,0.9l-0.4,1l-1.6,2.5l-9.9-0.8l0,0 v0C170,177.1,169.2,176.3,169.1,175.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st116",
    d: "M183.3,173.9c1.1,0.1,1.5,1.4,0.8,2.8c-0.7,1.5-2.1,2.6-3.2,2.5c-1.1-0.1-1.5-1.4-0.8-2.8 C180.7,174.9,182.1,173.8,183.3,173.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M164.7,181.5c-1.1-0.1-1.9-1.4-1.8-2.9c0.1-1.5,1.1-2.7,2.2-2.6v0l0,0l11.9,1l-2.4,5.4L164.7,181.5 L164.7,181.5L164.7,181.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st115",
    d: "M162.9,178.5c0-0.4,0.1-0.8,0.3-1.1c0.4-0.6,1.1-0.9,1.9-0.9v0l0,0l11.7,0.9l-0.4,1l-1.6,2.5l-9.9-0.8l0,0 v0C163.7,180.1,163,179.4,162.9,178.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st116",
    d: "M177,176.9c1.1,0.1,1.5,1.4,0.8,2.8c-0.7,1.5-2.1,2.6-3.2,2.5c-1.1-0.1-1.5-1.4-0.8-2.8 C174.5,178,175.9,176.9,177,176.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M147.7,177.5c4.2,0.3,8.5,0.7,12.7,1c-0.1,0.2-0.2,0.5-0.3,0.7c-4.2-0.3-8.4-0.7-12.7-1 C147.5,178,147.6,177.7,147.7,177.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M124.6,171c0,0.8-0.6,1.8-0.7,2.6c-0.1,0.5-0.2,0.7,0,1.2c0.3,0.7,0.2,1.4,0,2.2c-0.2,0.9,0.1,1.8,0.3,2.7 c0.2,0.7,0.3,1.5,0.9,1.9c1.6,1,3.3,0.4,4.9-0.1c1.6-0.5,1.3-3.3,1.8-4.6c0.9-2.3,0.2-5.6-2.3-6.6c-1.2-0.5-3-0.7-4.2-0.2 C124.9,170.1,124.6,171,124.6,171z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M126.8,180.4c0,0-0.5,2.6-0.2,3.9c0.2,0.4,1.7,1.5,3,1.5c2,0,4.3-1,3.6-2.7c-0.4-0.9-1.3-1.8-0.7-5.4 C132.6,176.6,126.8,180.4,126.8,180.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M132.5,169.3c-2.4-1.6-5.7-1.1-7.2,0.7c-0.9,1-1,2.2-1,2.2c0.5,0.7,0.9-0.1,1.2,1.8c0.1,0.5,0.6,1.1,0.7,1.5 c1.9,8.1,5.9,4.6,6,4.3c1.2-2.8,2-2.2,2.5-3.9C135.6,173.4,135.9,171.6,132.5,169.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M127.4,177.6c-0.3,0.9-0.5,1.7-0.9,1.5c-0.4-0.2-0.8-1-0.5-1.8c0.3-0.9,0.5-1.7,0.9-1.7 C127.7,175.5,127.7,176.7,127.4,177.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M126.5,176.1c-0.4,0.7-0.1,2.8,0.1,4.1c0.1,0.5,0.2,1.2,0.3,1.7c0,1,0.5,1.2-2,1.7c-1.2,0.2-2.1-4.2-0.8-4.8 c0.8-0.4,1.1-0.4,1.4-1.5C125.6,176.8,126.8,175,126.5,176.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M120.9,184.6c0.3-0.4,0.7-1,1-1.4c0.4-0.5,0.5-0.8,0.8-1.3c-0.4-0.3-0.8-0.2-1.4,0.8 c-1.1,1.2-1.7,0.4-1.7,1.8C119.6,185.1,120.5,185.2,120.9,184.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M119.5,180l0.9,1.4c0.3,0.4-0.3,0.8-0.7,0.4l-1-1.3C118.5,180.1,119.3,179.5,119.5,180z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M118.6,180.2l1,1.6c0.3,0.5-0.4,0.9-0.7,0.5l-1.2-1.4C117.4,180.3,118.3,179.7,118.6,180.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M117.7,180.7l0.9,1.3c0.3,0.4-0.3,0.8-0.6,0.4l-1-1.2C116.7,180.8,117.5,180.3,117.7,180.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M116.9,181.1l0.8,1.1c0.2,0.3-0.3,0.6-0.5,0.3l-0.9-1C116,181.1,116.6,180.7,116.9,181.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M121.2,227.7c1.1,0.6,2.4,0.5,3.4-0.1l-3.1-1.7c0.1-1.1,0.6-2.1,1.5-2.7l3.1,1.7c0-1.2-0.6-2.3-1.7-2.9 c-1.1-0.6-2.3-0.5-3.3,0c-0.3,0.2-0.6,0.2-0.8,0l-9.5-5.4c0-0.1-0.1-0.2-0.1-0.3c0-1-0.6-2-1.5-2.5c-1-0.5-2.1-0.5-3,0.1l2.7,1.5 c-0.1,1.1-0.6,1.8-1.4,2.4l-2.7-1.5c0,1,0.5,2,1.5,2.6c0.9,0.5,2,0.5,2.9,0c0.1-0.1,0.2-0.1,0.3-0.1l9.5,5.4 c0.3,0.1,0.4,0.4,0.4,0.7C119.6,226,120.2,227.1,121.2,227.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st117",
    d: "M121,227.9c1.1,0.6,2.4,0.5,3.4-0.1l-3.1-1.7c0.1-1.1,0.6-2.1,1.5-2.7l3.1,1.7c0-1.2-0.6-2.3-1.7-2.9 c-1.1-0.6-2.3-0.5-3.3,0c-0.3,0.2-0.6,0.2-0.8,0l-9.5-5.4c0-0.1-0.1-0.2-0.1-0.3c0-1-0.6-2-1.5-2.5c-1-0.5-2.1-0.5-3,0.1l2.7,1.5 c-0.1,1.1-0.6,1.8-1.4,2.4l-2.7-1.5c0,1,0.5,2,1.5,2.6c0.9,0.5,2,0.5,2.9,0c0.1-0.1,0.2-0.1,0.3-0.1l9.5,5.4 c0.3,0.1,0.4,0.4,0.4,0.7C119.3,226.2,119.9,227.3,121,227.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st118",
    d: "M118,217.1c0-0.5-1-1.7-1.4-1.2c-0.5,0.4-2.3,2-2.4,2.1c-0.2,0.2-0.3,0.4-0.4,0.6c-0.2,0.3-0.2,0.5-0.2,0.9 c0,0.3-0.1,1.3-0.1,1.6c0.1,0.6,0.1,1.3,0.3,1.8c0.1,0,0.3,0,0.4-0.2c0.1,0.2,0.1,0.5,0.2,0.5c0.4-0.1,0.4-0.5,0.4-0.5l0,0.2 c0.4,0,0.6-0.3,0.6-0.5c0.1-0.2,0.1-0.9,0.1-1.2c0.1-0.5,0.4-1.8,0.2-0.5c-0.1,0.6-0.1,1.4,0.2,1.2c0.5-0.3,0.3-0.7,0.4-1.2 c0.1-0.5,0.5-1.5,0.9-1.9C118.1,218,117.9,217.8,118,217.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M126.3,196c0.5,2.9-2.4,12.3-3.8,12.1c-0.5-0.1-2.1-2.1-1.9-3.4c-0.2-3.1-1.2-5.7,0.4-9.1 c-1.1-5.8,1.5-6.7,2.9-6.6C124.2,189.6,128.9,189.5,126.3,196z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M127.2,197.3c-2.1,0.9-5,0.4-7-0.2c-0.2-3.4-0.9-9.9,4.2-9.4C129.8,188.6,127.6,194.1,127.2,197.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M123.8,208.4c-1.2,3.6-5.8,9-5.9,9.5c-1.1,0.4-2.7-0.5-2-1.5c2.9-3.7,1.6-6.7,4.6-12c0.4-0.7,1.9-0.8,3.1-0.3 C124.2,204.5,124.7,205.9,123.8,208.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M135,174.5c0.7,0.7,2.1,2.3,2.6,3.2c-1.9-1-3.7,0-4.9,0.3c-1.4,0.3-2.9-2.2-4.1-3.1 C132.4,175.8,134.2,175.2,135,174.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135.2,175c-2.2,1.3-8,0-11.2-2.1c0.4-5,4-5.3,7.1-4.5C134.7,169.3,136.8,172.4,135.2,175z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M133.4,172.4c0,0.1,0.1,0.2,0.1,0.3c0.1,0.3,0.1,0.7,0.2,1l-0.3,0v0.5l0.3,0c0,0.2,0,0.5,0,0.7 c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0c0-0.7-0.1-1.3-0.3-2c-0.2-0.7-0.4-1.3-0.7-2V172.4z M133.2,173.9c0-0.3,0.1-0.7,0.1-1.1 c0-0.4,0-0.7,0-1.1c0,0,0,0,0,0c0.1,0.2,0.2,0.5,0.2,0.7v-1.5l0-0.1c-0.1,0-0.3,0-0.4,0.1c-0.1,0-0.3,0-0.4,0.1 c0.1,0.7,0.2,1.4,0.1,2.1c0,0.7-0.2,1.4-0.4,2.1c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0c0.1-0.2,0.1-0.5,0.2-0.7c0.1,0,0.2,0,0.3,0 l0,0v-0.5L133.2,173.9z"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M69.4,139.7c1.7,2.4,3.3,12.1,2,12.6c-0.5,0.2-2.8-0.9-3.2-2.2c-1.5-2.7-3.6-4.6-3.6-8.3 c-3.5-4.7-1.7-6.7-0.3-7.2C64.6,134.9,68.8,132.7,69.4,139.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.2,138.6c-1.3,1.9-4,2.9-6,3.5c-2-2.8-6.1-7.9-1.5-10.2C67.7,129.9,68.8,135.7,70.2,138.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M72.1,152.4c-0.2,3.8-2.8,10.2-2.8,10.7c-0.9,0.7-2.9,0.4-2.4-0.7c1.7-4.4-0.2-6.8,1.2-12.7 c0.2-0.8,1.4-1.4,2.7-1.3C71.3,148.5,72.2,149.7,72.1,152.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M42.2,162.6c-0.7-0.3-2.2-0.4-2.7-0.4c-0.7,0-1,0.1-1.6,0.1c0.2,0.4,0.1,0.7,1.3,0.6c0.8,0.2,3,1.9,3.3,0.8 C42.5,163.1,43.2,162.9,42.2,162.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M66.8,163.1c-0.5,0.3-0.9,0.8-0.8,1.3c0.3,1.4-0.8,1.5-1,2.4c0.1,0.4,2.8,1.8,3.2,1.2 c0.8-0.2,1.3-1.9,1.4-2.8c0-0.8-0.1-0.8-0.4-1.6l0.3-1.9c-0.3-0.7-1.2-0.6-2.2-0.7L66.8,163.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M66.4,163.1c-0.5,0.1-1.2,0.3-1.6,0.4c-0.6,0.1-0.9,0.3-1.5,0.5c0.2,0.5,0.5,0.7,1.6,0.3 c1.6-0.3,1.5,0.8,2.5-0.3C67.7,163.6,67.1,162.9,66.4,163.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M64.7,167l0.2-1.7c0.1-0.5,0.8-0.4,0.8,0.1l0,1.7C65.6,167.6,64.6,167.5,64.7,167z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M65.5,167.5l0.2-1.9c0.1-0.6,0.9-0.5,0.8,0.1l0,1.8C66.5,168.1,65.5,168,65.5,167.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M66.5,167.6l0.2-1.6c0.1-0.5,0.7-0.4,0.7,0.1l0,1.6C67.4,168.2,66.5,168.1,66.5,167.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M67.4,167.9l0.1-1.3c0-0.4,0.6-0.3,0.6,0.1l0,1.3C68.1,168.4,67.4,168.3,67.4,167.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M57.9,196.5c9.8,0,17.8,4.2,17.8,9.4s-8,9.4-17.8,9.4c-9.8,0-17.8-4.2-17.8-9.4S48.1,196.5,57.9,196.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M60.2,199.7c-0.2,0-0.8,1.4-0.3,2.4c0.1,0.3,0,1.3,2.8,2.3c0.8,0.3,1.5,0.2,3.1,0.9c0.4,0.2,0,0.7,0.3,0.9 c0.8,0.5,1.4,0.8,1.8,1.1c0.6,0.4,2.7,0.4,3.2-0.5c0.3-0.5-0.1-2.7-0.1-2.7L60.2,199.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M71.2,199.7c0.2-0.4-0.6-1.2-0.6-1.2c0,0-0.1,0.7-0.2,1.1c-0.1,0.4-1.3,1.2-3.3,0.2 c-1.4-0.7-1.1-2.2-1.1-2.2c0-0.2-0.5,0.1-0.5,0.5c0,1.1-0.5,1.5-0.9,1.6c-1.7-0.1-2.6-0.7-3.1-0.7c-0.5,0-1.3,0.4-1.5,1 c-0.3,0.9,0.2,1.9,0.7,2.6c0.4,0.5,1.3,1.1,1.9,1.2c3.5,0.6,5.3,2.5,6.4,2.5c1.4,0,1.8-0.3,2-1c0.4-1.3,0-2.5-0.3-3.4 C70.9,201,71.1,200,71.2,199.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M71.2,199.7c0.2-0.4-0.6-1.2-0.6-1.2c0,0-0.1,0.7-0.2,1.1c-0.1,0.4-1.3,1.2-3.3,0.2 c-1.4-0.7-1.1-2.2-1.1-2.2c0-0.2-0.5,0.1-0.5,0.5c0,1.1-0.5,1.5-0.9,1.6c-1.7-0.1-2.6-0.7-3.1-0.7c-0.5,0-1.3,0.4-1.5,1 c-0.3,0.9,0.2,1.9,0.7,2.6c0.4,0.5,1.3,1.1,1.9,1.2c3.5,0.6,5.3,2.5,6.4,2.5c1.4,0,1.8-0.3,2-1c0.4-1.3,0-2.5-0.3-3.4 C70.9,201,71.1,200,71.2,199.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M71.2,199.7c0.2-0.4-0.6-1.2-0.6-1.2c0,0-0.1,0.7-0.2,1.1c-0.1,0.4-1.3,1.2-3.3,0.2c-1.4-0.7-1.1-2.2-1.1-2.2 c0-0.2-0.5,0.1-0.5,0.5c0,1.1-0.5,1.5-0.9,1.6c-1.7-0.1-1.4-1-3.1-1c-0.8,0-1.3,0.6-1.5,1.3c-0.3,0.9,0.2,1.9,0.7,2.6 c0.4,0.5,1.3,1.1,1.9,1.2c3.5,0.6,5.3,2.5,6.4,2.5c1.4,0,1.8-0.3,2-1c0.4-1.3,0-2.5-0.3-3.4C70.9,201,71.1,200,71.2,199.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M62.6,200.6c0,0,0,0.1,0.1,0.1c0.1,0,0.1,0,0.1,0c0.2-0.4,0.4-0.7,0.6-0.8c0.2-0.2,0.5-0.2,0.8-0.2 c0.1,0,0.1,0,0.1-0.1c0-0.1-0.1-0.1-0.1-0.1c-0.3,0-0.7,0-0.9,0.2C63,199.9,62.7,200.2,62.6,200.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M63.1,200.9c0,0,0,0.1,0.1,0.1c0.1,0,0.1,0,0.1,0c0.1-0.4,0.3-0.7,0.5-0.9c0.2-0.2,0.5-0.3,0.8-0.3 c0.1,0,0.1,0,0.1-0.1c0-0.1-0.1-0.1-0.1-0.1c-0.3,0-0.6,0.1-0.9,0.3C63.4,200.1,63.2,200.5,63.1,200.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M63.7,201.3c0,0.1,0,0.1,0.1,0.1c0.1,0,0.1,0,0.1-0.1c0-0.4,0.1-0.8,0.3-1c0.2-0.2,0.4-0.4,0.7-0.5 c0.1,0,0.1-0.1,0-0.1c0,0-0.1-0.1-0.1-0.1c-0.3,0.1-0.6,0.3-0.8,0.6C63.8,200.4,63.7,200.8,63.7,201.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M64.4,201.6c0,0,0.1,0.1,0.1,0.1c0.1,0,0.1-0.1,0.1-0.1c-0.2-0.4-0.2-0.7-0.1-1c0.1-0.3,0.2-0.5,0.5-0.7 c0,0,0-0.1,0-0.1c0,0-0.1,0-0.2,0c-0.3,0.2-0.4,0.5-0.5,0.8C64.2,200.8,64.3,201.2,64.4,201.6z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M66.6,172.8c-0.5,2.6,0.8,9.5,0.8,12.1c2.1,3.7,4,15.5,4.5,17.7c0.6,2.7-6.9,2-7.7-0.8 c-0.4-6.6-3.3-8.2-4.7-15.8c-1.3-7-2.8-14.3-2.8-15.4c-0.1-1.9,1.4-2.8,1.4-4.8c0,0,2.8-5.5,7.3-5C68.3,166.5,67.7,172,66.6,172.8z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.7,134.5c-0.4,0.1-2.7,1.2-4.5,3.5c-1.3,1.6-1.2,5.3-1.1,5.8c0.2,1.6-1.6,16.9,0.6,17.2 c-1.1,4.5,10.4,0.8,13.8-2c2.1-1.5,1.2-11.3,1.5-13c0.3-1.7,1.6-9.7-0.7-12.8c-0.5-0.7-1.5-1.6-2.3-1.5 C61.1,132,57.2,134.4,56.7,134.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M52.8,137.3c2.4-0.8,7.5,3.2,9.4,11.4c1,0.3,0.7-0.8,1.7-1.1c-1.6-6.8-5.3-12.9-8.6-12.4 C53.9,135.8,53.8,136.4,52.8,137.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M61.7,132.5c5.9,1.2,3.3,7.5,1.6,15.7c0.8,0.3,1.1-0.8,2.2-1.1c1.4-6.8,4-13.6-1.4-15.4 C63.4,131.4,63.2,131.5,61.7,132.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M56.7,130.9c0,0-0.5,2.6-0.2,3.9c0.2,0.4,1.7,1.5,3,1.5c2,0,4.3-1,3.6-2.7c-0.4-0.9-1.3-1.8-0.7-5.4 C62.5,127.2,56.7,130.9,56.7,130.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M45.5,203.8c-0.2,0-0.8,1.4-0.3,2.4c0.1,0.3,0,1.3,2.8,2.3c0.8,0.3,1.5,0.2,3.1,0.9c0.4,0.2,0,0.7,0.3,0.9 c0.8,0.5,1.4,0.8,1.8,1.1c0.6,0.4,2.7,0.4,3.2-0.5c0.3-0.5-0.1-2.7-0.1-2.7L45.5,203.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M56.5,203.9c0.2-0.4-0.6-1.2-0.6-1.2s-0.1,0.7-0.2,1.1c-0.1,0.4-1.3,1.2-3.3,0.2c-1.4-0.7-1.1-2.2-1.1-2.2 c0-0.2-0.5,0.1-0.5,0.5c0,1.1-0.5,1.5-0.9,1.6c-1.7-0.1-2.6-0.7-3.1-0.7c-0.5,0-1.3,0.4-1.5,1c-0.3,0.9,0.2,1.9,0.7,2.6 c0.4,0.5,1.3,1.1,1.9,1.2c3.5,0.6,5.3,2.5,6.4,2.5c1.4,0,1.8-0.3,2-1c0.4-1.3,0-2.5-0.3-3.4C56.2,205.2,56.4,204.2,56.5,203.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M56.5,203.9c0.2-0.4-0.6-1.2-0.6-1.2s-0.1,0.7-0.2,1.1c-0.1,0.4-1.3,1.2-3.3,0.2c-1.4-0.7-1.1-2.2-1.1-2.2 c0-0.2-0.5,0.1-0.5,0.5c0,1.1-0.5,1.5-0.9,1.6c-1.7-0.1-2.6-0.7-3.1-0.7c-0.5,0-1.3,0.4-1.5,1c-0.3,0.9,0.2,1.9,0.7,2.6 c0.4,0.5,1.3,1.1,1.9,1.2c3.5,0.6,5.3,2.5,6.4,2.5c1.4,0,1.8-0.3,2-1c0.4-1.3,0-2.5-0.3-3.4C56.2,205.2,56.4,204.2,56.5,203.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M56.5,203.9c0.2-0.4-0.6-1.2-0.6-1.2s-0.1,0.7-0.2,1.1c-0.1,0.4-1.3,1.2-3.3,0.2c-1.4-0.7-1.1-2.2-1.1-2.2 c0-0.2-0.5,0.1-0.5,0.5c0,1.1-0.5,1.5-0.9,1.6c-1.7-0.1-1.4-1-3.1-1c-0.8,0-1.3,0.6-1.5,1.3c-0.3,0.9,0.2,1.9,0.7,2.6 c0.4,0.5,1.3,1.1,1.9,1.2c3.5,0.6,5.3,2.5,6.4,2.5c1.4,0,1.8-0.3,2-1c0.4-1.3,0-2.5-0.3-3.4C56.2,205.2,56.4,204.2,56.5,203.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M47.9,204.8c0,0,0,0.1,0.1,0.1c0.1,0,0.1,0,0.1,0c0.2-0.4,0.4-0.7,0.6-0.8c0.2-0.2,0.5-0.2,0.8-0.2 c0.1,0,0.1,0,0.1-0.1c0-0.1-0.1-0.1-0.1-0.1c-0.3,0-0.7,0-0.9,0.2C48.3,204.1,48,204.4,47.9,204.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M48.4,205.1c0,0,0,0.1,0.1,0.1c0.1,0,0.1,0,0.1,0c0.1-0.4,0.3-0.7,0.5-0.9c0.2-0.2,0.5-0.3,0.8-0.3 c0.1,0,0.1,0,0.1-0.1c0-0.1-0.1-0.1-0.1-0.1c-0.3,0-0.6,0.1-0.9,0.3C48.7,204.3,48.5,204.6,48.4,205.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M49,205.4c0,0.1,0,0.1,0.1,0.1c0.1,0,0.1,0,0.1-0.1c0-0.4,0.1-0.8,0.3-1c0.2-0.2,0.4-0.4,0.7-0.5 c0.1,0,0.1-0.1,0-0.1c0,0-0.1-0.1-0.1-0.1c-0.3,0.1-0.6,0.3-0.8,0.6C49.2,204.6,49.1,205,49,205.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M49.7,205.8c0,0,0.1,0.1,0.1,0.1c0.1,0,0.1-0.1,0.1-0.1c-0.2-0.4-0.2-0.7-0.1-1c0.1-0.3,0.2-0.5,0.5-0.7 c0,0,0-0.1,0-0.1c0,0-0.1,0-0.2,0c-0.3,0.2-0.4,0.5-0.5,0.8C49.5,205,49.6,205.4,49.7,205.8z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M59,174.8c-0.2,3.7-1.3,6.5-2.2,10.6c-0.7,3,1,18.5,0.3,22.5c-0.7,1.2-5,0.2-7.1-2.4 c-0.7-2.9-1.9-18.1-1.5-21.7c0.3-1.2,0.7-7.3,0.8-9.6c0.3-6,1.4-10.6,2.2-12c0,0,4.9-0.5,9.4,0.3C64.7,169.8,59.5,174.4,59,174.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M51.4,162.3c2.1,1.9,11.1,2.5,13.9-1.5c0-0.5,0.1-1.3,0.1-1.8c-3.2,2.4-10.1,4.1-13.8,2 C51.6,161.4,51.5,161.8,51.4,162.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M53,187.6c0-2.8,0.4-5.7,1.5-8.5c-2.2-0.5-4-1.3-5.3-2.8c-0.7,3.6-2,8.3-0.7,9.2 C50.1,186.7,51.3,187.4,53,187.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M53.8,179.3c-2.4-0.8-3.7-1.6-4.8-2.7c-0.3,0.7-0.6,1.4-1,2.2c1.3,1.3,2.8,2.4,4.9,2.8 C53.3,180.9,53.7,180.1,53.8,179.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M49.4,179.3c0.1-0.1,0.1-0.4-0.1-0.7c-0.2-0.2-0.5-0.3-0.6-0.2c-0.1,0.1-0.1,0.4,0.1,0.7 C49,179.4,49.2,179.5,49.4,179.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M52.7,181.1c0.1-0.1,0.1-0.4-0.1-0.7c-0.2-0.2-0.5-0.3-0.6-0.2c-0.1,0.1-0.1,0.4,0.1,0.7 C52.4,181.2,52.6,181.3,52.7,181.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M50.9,163.4c-1.8,6.3-2.6,11.4-1.7,11.8c2.1,1.2,3.1,1.7,5.1,1.8c0.5-1.7,0.7-4.2,1.1-6 c-3.7-1.2-3.3-4.8-2.8-6.9C51.8,164,51.7,163.7,50.9,163.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M59.7,161.5c1.5-3.8,2.6-8,2.5-13c1.1-0.5,2.3-1.1,3.4-1.6c0,4.1-0.1,8.1-0.1,12.2 C63.8,161.1,61.8,161.8,59.7,161.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M53.2,122.1c0,0.9-0.3,1.7-0.6,2.5c-0.4,1,0.8,1.3-0.1,2.6c-0.2,1,0,2.6,0.3,3.5c0.1,0.7,0.2,1.8,1.3,2.5 c1.7,1.2,3.5-0.4,5.3-0.9c1.7-0.5,1.1-2.7,1.6-4.1c1.1-2.5,1.1-6-1.7-7.2c-1.2-0.5-3.3-0.9-4.6-0.4 C54.2,120.8,53.2,121.2,53.2,122.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M58.7,126.1c0.5,0.3,0.6,0.3,0.7,0.9c0.1,0.5,0,2-1,3.4c0,0.1,1.2-1.1,1.8-1.4c1.4-1.4,0.8,2.2,2.1,3.3 c0.1,0,1-0.3,1.1-0.5c-1.8-2.7,2.1-7.8-0.1-10.6c-3.2,0.1-4.3,0.1-5.5,1.8C57.6,124,58.1,125.8,58.7,126.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M58,119c-4.5,0.6-6.3,3.5-5.2,5c0.5,0.7,2.2,0,5-0.4c1-1.4,2.4-1.8,5.6-2.1C62.6,118.8,59.2,118.8,58,119z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M56,130.2l0,0.1C56,130.2,56,130.2,56,130.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M62.1,128.3c-0.4,0.9-1,1.5-1.4,1.3c-0.4-0.2-0.5-1.1-0.1-2c0.4-0.9,1.1-1.4,1.5-1.3 C62.5,126.6,62.5,127.4,62.1,128.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M52.3,129.8c0.2-0.3,0.6-0.5,1.2-0.4c0.7,0.2,2,0.5,2.8,1.9c0.4,0.8-0.1,1.7,0.1,1.9l-0.3,0.1 c-0.5-2.2-2.1-2.1-2.5-2.8c-0.2,0.4-0.9,0-0.7,1.3C52.7,131.4,51.9,130.4,52.3,129.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M18.5,163.6c1.5,0.8,2.6,0.2,4.1,0.1c1.2-0.1,2.8,0.2,3.2,2.1c-0.2,0-1.1-0.2-1.1-0.3 c-0.8-2.1-2.8-1.6-4.7-1C19.6,164.6,16.8,163.8,18.5,163.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M24.9,168.3c0,0-0.1,0-0.1,0l-6.6-0.8c-0.6-0.1-1-0.6-1-1.2c0.1-0.6,0.6-1.1,1.2-1l6.6,0.8 c0.6,0.1,1,0.6,1,1.2C25.9,167.9,25.5,168.3,24.9,168.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M25.8,166.5c0.3,0.9-0.1,1.9-1,2.2c-0.8,0.4-1.7-0.1-2-0.9c-0.3-0.9,0.1-1.9,1-2.2 C24.6,165.2,25.5,165.6,25.8,166.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M26.4,166.6c0.3,0.9-0.1,1.9-1,2.2c-0.8,0.4-1.7-0.1-2-0.9c-0.3-0.9,0.1-1.9,1-2.2 C25.2,165.3,26.1,165.7,26.4,166.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M26.8,168.1c-0.5,0-1.1,0-1.7-0.1c-0.4-0.1-0.7-0.4-0.7-0.9c0.1-0.4,0.4-0.7,0.9-0.7 c1.4,0.2,2.4,0.1,3-0.1c0.9-0.4,1.8-1.4,2.6-2.4c1.4-1.6,2.9-3.4,5-2.7c1.7,0.6,3.4,1.5,5,2.8c0.3,0.3,0.4,0.8,0.1,1.1 c-0.3,0.3-0.8,0.4-1.1,0.1c-1.5-1.2-3-2.1-4.5-2.6c-1-0.3-1.9,0.6-3.3,2.2c-1,1.2-2,2.3-3.3,2.9C28.4,168,27.7,168.1,26.8,168.1z "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M18.1,163.7c1.5,0.8,2.6,0.2,4.1,0.1c1.2-0.1,2.9,0.3,3.1,1.8c-0.2,0-1,0-1-0.1c-0.8-2.1-2.8-1.2-4.7-0.9 C19.1,164.6,17,164.3,18.1,163.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M37.2,163.8c1.8,1.4,3.1,2.5,4.9,3.9c0.5,0.6,1.1,0.6,1.7,0.3c0.2-0.4,0.2-1.3,0-2.1 c-1.7-1.4-3.5-2.8-5.2-4.1C37.5,162,36.8,162.9,37.2,163.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st119",
    d: "M37.2,163.8c1.8,1.4,3.1,2.5,4.9,3.9c-0.1-0.7,0.1-1.5,1.7-1.8c-1.7-1.4-3.5-2.8-5.2-4.1 C37.5,162,36.8,162.9,37.2,163.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M49.2,190.9c-0.3,0-0.5-0.1-0.7-0.4c-0.3-0.5-0.8-1.2-1.3-2c-2-3-4.7-7.1-5-9.7c-0.1-1.5,0.6-3.1,1.2-4.6 c0.8-1.8,1.5-3.4,0.7-4.4c-0.6-0.8-1-1.3-1.7-2c-0.3-0.3-0.3-0.8,0-1.1c0.3-0.3,0.8-0.3,1.1,0c0.7,0.8,1.1,1.3,1.8,2.1 c1.4,1.7,0.4,3.9-0.5,6c-0.6,1.3-1.2,2.7-1.1,3.8c0.2,2.2,2.9,6.3,4.7,9c0.5,0.8,1,1.5,1.4,2.1c0.2,0.4,0.1,0.9-0.3,1.1 C49.5,190.9,49.3,190.9,49.2,190.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M46.2,182.7c0.2,0.7-0.3,1.5-1.1,1.8c-0.4,0.2-0.7,0.8-1.1,0.6c-0.3-0.1-0.7-0.9-0.8-1.2 c-0.2-0.7,0.3-1.5,1.1-1.8C45.2,181.8,46,182.1,46.2,182.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M46.8,183.5c0.2,0.7-0.3,1.5-1.1,1.8c-0.8,0.3-1.6,0.1-1.8-0.6c-0.2-0.7,0.3-1.5,1.1-1.8 C45.7,182.6,46.6,182.9,46.8,183.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st78",
    d: "M49.2,191.3c-0.4,0-0.7-0.2-0.9-0.5l-3.5-5.5c-0.3-0.5-0.2-1.2,0.3-1.5c0.5-0.3,1.2-0.2,1.5,0.3l3.5,5.5 c0.3,0.5,0.2,1.2-0.3,1.5C49.6,191.2,49.4,191.3,49.2,191.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M50.1,188c-1.5-1-1.5-2.5-2.3-4c-0.6-1.2-1.7-2.8-2.8-2l-0.7,0.3c1.9-0.3,3.4,2.5,4.2,4.7 c0.1,0.4,0.8,1.9,1.2,1.9C49.8,188.8,50.1,188.3,50.1,188z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M49.8,188.4c-1.5-1-1.5-2.5-2.3-4c-0.6-1.2-2.1-3-3.2-2.1l0.5,0.8c2.2-0.4,2.7,2.3,3.5,4.3 C48.4,187.8,49.8,189.8,49.8,188.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M50.5,189.9c0.2,0.5-0.2,1.1-0.8,1.4c-0.6,0.3-1.2,0.1-1.4-0.4c-0.2-0.5,0.2-1.1,0.8-1.4 C49.7,189.3,50.4,189.4,50.5,189.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M43.3,163.8c0-0.4-0.6-1.9-1.3-1.7c-1,0.4-2.2,0.7-2.4,0.8c-0.3,0.1-1.9,1-2.1,1.2c-0.3,0.2-0.2,0.7,0.3,1 c0.1,0.3,0.4,0.7,0.8,0.7c0.2,0.3,0.3,0.5,0.8,0.6c0.1,0.2,0.2,0.5,0.5,0.5c0.7,0.2,1.3-0.4,2.2-1.1 C42.8,165.2,43.4,164.8,43.3,163.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M56.3,145.8c0.5,2.9-2.4,12.3-3.8,12.1c-0.5-0.1-2.1-2.1-1.9-3.4c-0.2-3.1-1.2-5.7,0.4-9.1 c-1.1-5.8,1.5-6.7,2.9-6.6C54.2,139.4,58.9,139.3,56.3,145.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M57.2,147c-2.1,0.9-5,0.4-7-0.2c-0.2-3.4-0.9-9.9,4.2-9.4C59.7,138.4,57.5,143.9,57.2,147z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M52.2,158.5c-2.7,2.7-9,5.6-9.3,5.9c-1.2-0.1-2.4-1.7-1.3-2.2c4.2-2.1,4.4-5.1,9.5-8.5c0.7-0.5,2-0.1,2.9,0.9 C54.3,155.1,54.1,156.6,52.2,158.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M52.9,123.7c-0.9,0.5-2.5,1.9-3.2,2.6c2.1-0.6,3.6,0.7,4.8,1.2c1.3,0.6,3.3-1.6,4.6-2.2 C55.2,125.5,53.6,124.5,52.9,123.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.7,124.2c1.9,1.7,7.8,1.5,11.4,0.2c0.6-4.9-2.8-6-6.1-5.8C54.3,118.7,51.6,121.3,52.7,124.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M54.9,123.5c0-0.4,0.1-0.7,0.1-1c0.1-0.3,0.2-0.7,0.3-1c0,0,0,0,0,0c-0.2,0.3-0.3,0.5-0.4,0.8v-1.1 c0.1-0.2,0.3-0.4,0.4-0.6c0.1,0,0.3,0.1,0.4,0.1c0.1,0,0.3,0.1,0.4,0.1c-0.2,0.7-0.5,1.4-0.6,2.1c-0.1,0.7-0.1,1.4,0,2.1 c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.2-0.1-0.3-0.1c0-0.3,0-0.5,0-0.8l-0.1,0L54.9,123.5L54.9,123.5z M54.8,122.2c0,0,0,0.1-0.1,0.1 c-0.1,0.3-0.3,0.6-0.4,1l0.4,0.2v0.5l-0.3-0.1c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0.2-0.1,0.5-0.2,0.7c-0.1,0-0.2-0.1-0.3-0.1 c-0.1,0-0.2-0.1-0.3-0.1c0.2-0.6,0.3-1.3,0.6-1.9c0.2-0.4,0.4-0.8,0.7-1.2V122.2z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintainance);
export default __webpack_public_path__ + "static/media/maintainance.cf09260298370295f5399258dcc9f2cf.svg";
export { ForwardRef as ReactComponent };